import { EventEmitter, Component, ContentChild, TemplateRef, Input, Output, ElementRef, Renderer2, NgZone, ViewChild, Injectable, ɵɵdefineInjectable, ɵɵinject, HostBinding, Directive, HostListener, ChangeDetectorRef, ViewChildren, Pipe, NgModule } from '@angular/core';
import { isArray } from 'util';
import { FormControl, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { Subject, BehaviorSubject, Subscription, fromEvent, timer } from 'rxjs';
import { addYears, format, parse, isValid, compareAsc } from 'date-fns';
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LastResponseService, SettingsService, CoreNg } from '@inflight/core-ng';
import { UrlUtils } from '@inflight/core-nlx';
import { map, pairwise, share, filter, take } from 'rxjs/operators';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { EventEmitter as EventEmitter$1 } from 'events';
import { StepStatus } from '@inflight/core-models';
import { getParser } from 'bowser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputRangeComponent {
    constructor() {
        this.step = 1;
        this.slidechange = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const inputChanges = changes.field;
        if (inputChanges) {
            /** @type {?} */
            const options = ((/** @type {?} */ (this.field))).options;
            if (options && isArray(options)) {
                this.options = options;
                this.inputField = undefined;
            }
            else {
                this.inputField = (/** @type {?} */ (this.field));
                this.options = undefined;
            }
            this.setUpRange();
        }
    }
    /**
     * @return {?}
     */
    setUpRange() {
        if (this.inputField) {
            this.min = (this.inputField.hasOwnProperty("min")) ? this.inputField.min : 0;
            this.max = this.inputField.max;
        }
        else {
            this.min = 0;
            this.max = this.options.length - 1;
        }
        this.updateValue();
        this.cssvalue = this.getCssValue(this.value);
        this.slidechange.emit(this.value);
    }
    /**
     * @private
     * @param {?=} ref
     * @return {?}
     */
    updateValue(ref) {
        /** @type {?} */
        let refVal;
        if (this.options) {
            if (this.options.length === 0) {
                return;
            }
            refVal = ref ? ref.value : this.options.findIndex((/**
             * @param {?} x
             * @return {?}
             */
            (x) => x.selected));
            if (refVal === -1) {
                refVal = 0;
            }
            this.item = this.options[refVal];
            this.value = refVal;
        }
        else {
            this.value = ref ? ref.value : this.field.value;
        }
    }
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    getCssValue(value) {
        return value * (100 / (this.max));
    }
    /**
     * @param {?} ref
     * @return {?}
     */
    changeRange(ref) {
        this.updateValue(ref);
        this.form.value[this.field.name] = this.options ? this.item.value : this.value;
        this.cssvalue = this.getCssValue(ref.value);
        this.slidechange.emit(this.value);
    }
}
InputRangeComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-range',
                template: "<div class=\"slider\">\n  <input type=\"range\" #ref (change)=\"changeRange(ref)\" (input)=\"changeRange(ref)\" [style.background-size]=\"cssvalue+'% 100%'\" min=\"{{min}}\" max=\"{{max}}\" value=\"{{value}}\" step=\"{{step}}\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n  <label class=\"form-control-label mb-0\">\n    <ng-container [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{'value': value, 'item': item}\"></ng-container>\n  </label>\n  <ui-input [field]=\"field\" [form]=\"form\" style=\"display:none\"></ui-input>\n</div>\n"
            }] }
];
/** @nocollapse */
InputRangeComponent.ctorParameters = () => [];
InputRangeComponent.propDecorators = {
    template: [{ type: ContentChild, args: [TemplateRef, { static: false },] }],
    step: [{ type: Input }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    slidechange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputRangeComponent.prototype.template;
    /** @type {?} */
    InputRangeComponent.prototype.step;
    /** @type {?} */
    InputRangeComponent.prototype.field;
    /** @type {?} */
    InputRangeComponent.prototype.form;
    /** @type {?} */
    InputRangeComponent.prototype.slidechange;
    /** @type {?} */
    InputRangeComponent.prototype.value;
    /** @type {?} */
    InputRangeComponent.prototype.min;
    /** @type {?} */
    InputRangeComponent.prototype.max;
    /** @type {?} */
    InputRangeComponent.prototype.cssvalue;
    /** @type {?} */
    InputRangeComponent.prototype.item;
    /**
     * @type {?}
     * @private
     */
    InputRangeComponent.prototype.options;
    /**
     * @type {?}
     * @private
     */
    InputRangeComponent.prototype.inputField;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const KeyCode = {
    SPACE: 13,
    ENTER: 32,
};
KeyCode[KeyCode.SPACE] = 'SPACE';
KeyCode[KeyCode.ENTER] = 'ENTER';
;
class InputSwitchComponent {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this.switch = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} button
     * @return {?}
     */
    action(button) {
        this.switch.emit(button);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    keyPress(event) {
        if (event.keyCode === KeyCode.SPACE || event.keyCode === KeyCode.ENTER) {
            this.el.nativeElement.querySelector('div.switch').click();
            event.preventDefault();
        }
    }
}
InputSwitchComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-switch',
                template: "<label [class.disabled]=\"field.disabled\">\n  <div class=\"switch\">\n    <ui-checkbox-radio class=\"d-none\" [field]=\"field\" [form]=\"form\" (change)=\"action(field)\" (click)=\"$event.stopPropagation()\" [class.checked]=\"field.checked\"></ui-checkbox-radio>\n    <div class=\"slider round\" [class.disabled]=\"field.disabled\" (keypress)=\"keyPress($event)\" role=\"checkbox\" [attr.aria-checked]=\"field.checked\"\n      [attr.aria-labelledby]=\"field.id+'-switch'\" [attr.tabindex]=\"field.disabled ? -1 : 0\"></div>\n  </div>\n  <span class=\"pl-2\" [id]=\"field.id+'-switch'\" *ngIf=\"field.label\">{{field.label | translate}}</span>\n</label>\n"
            }] }
];
/** @nocollapse */
InputSwitchComponent.ctorParameters = () => [
    { type: ElementRef }
];
InputSwitchComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    switch: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputSwitchComponent.prototype.field;
    /** @type {?} */
    InputSwitchComponent.prototype.form;
    /** @type {?} */
    InputSwitchComponent.prototype.switch;
    /**
     * @type {?}
     * @private
     */
    InputSwitchComponent.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class FieldComponent {
    constructor() { }
    /**
     * @param {?} value
     * @return {?}
     */
    set FormCtrl(value) {
        this.formCtrl = value;
    }
    /**
     * @return {?}
     */
    get FormCtrl() {
        if (!this.formCtrl) {
            this.initFormControl();
        }
        return this.formCtrl;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChangePreProcessor(event) {
        FieldComponent.onChangePreProcessorSubject.next(event);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.syncFieldToForm();
        this.checkForError();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        /** @type {?} */
        const fieldChanges = changes['field'];
        if (fieldChanges) {
            this.updateOriginalValue();
            if (!fieldChanges.firstChange) {
                this.syncFieldToForm();
            }
        }
        this.checkForError();
    }
    /**
     * @return {?}
     */
    updateOriginalValue() {
        this.originalValue = this.field.value;
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        if (this.field.value) {
            this.FormCtrl.setValue(this.field.value);
        }
        else {
            this.FormCtrl.setValue('');
        }
    }
    /**
     * @return {?}
     */
    checkForError() {
        this.hasError =
            (this.field.hasError && this.valueNotChanged()) ||
                (this.FormCtrl &&
                    this.FormCtrl.invalid &&
                    !(this.FormCtrl.pristine && this.FormCtrl.untouched) &&
                    !this.FormCtrl.pending);
    }
    /**
     * @return {?}
     */
    initFormControl() {
        if (this.field['type'] !== 'radio' && this.form.contains(this.field.name)) {
            this.form.removeControl(this.field.name);
        }
        if (!this.form.contains(this.field.name) ||
            this.field['type'] === 'radio') {
            this.formCtrl = new FormControl('', { updateOn: this.updateOn });
            this.form.addControl(this.field.name, this.formCtrl);
            /** @type {?} */
            let validators;
            if (this.validators) {
                if (Array.isArray(this.validators)) {
                    validators = (/** @type {?} */ (this.validators));
                }
                else if (this.validators) {
                    validators = [(/** @type {?} */ (this.validators))];
                }
            }
            else {
                validators = (/** @type {?} */ ([]));
            }
            if (this.field.required) {
                validators.push(Validators.required);
            }
            validators.push((/**
             * @return {?}
             */
            () => {
                if (this._hasServerError()) {
                    return {
                        customErrorMsg: this.field.error || 'This field is invalid.'
                    };
                }
                return null;
            }));
            /** @type {?} */
            const ctrl = this.form.controls[this.field.name];
            if (validators) {
                ctrl.setValidators(validators);
            }
            if (this.asyncValidators) {
                ctrl.setAsyncValidators(this.asyncValidators);
            }
            if (this.field.disabled) {
                ctrl.disable();
            }
            else if (ctrl.disabled) {
                ctrl.enable();
            }
        }
        if (!this.originalValue) {
            this.originalValue = this.field.value;
        }
        this.FormCtrl.statusChanges.subscribe((/**
         * @return {?}
         */
        () => {
            this.checkForError();
        }));
        return this.formCtrl;
    }
    /**
     * @private
     * @return {?}
     */
    _hasServerError() {
        return this.valueNotChanged() && this.field.hasError;
    }
    /**
     * @return {?}
     */
    valueNotChanged() {
        return (this.field && this.FormCtrl && this.FormCtrl.value === this.originalValue);
    }
}
FieldComponent.onChangePreProcessorSubject = new Subject();
FieldComponent.onChangePreProcessorObservable = FieldComponent.onChangePreProcessorSubject.asObservable();
FieldComponent.propDecorators = {
    form: [{ type: Input }],
    validators: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    updateOn: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    FieldComponent.onChangePreProcessorSubject;
    /** @type {?} */
    FieldComponent.onChangePreProcessorObservable;
    /** @type {?} */
    FieldComponent.prototype.field;
    /** @type {?} */
    FieldComponent.prototype.hasError;
    /**
     * @type {?}
     * @private
     */
    FieldComponent.prototype.originalValue;
    /**
     * @type {?}
     * @private
     */
    FieldComponent.prototype.formCtrl;
    /** @type {?} */
    FieldComponent.prototype.form;
    /** @type {?} */
    FieldComponent.prototype.validators;
    /** @type {?} */
    FieldComponent.prototype.asyncValidators;
    /** @type {?} */
    FieldComponent.prototype.updateOn;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
        this.blur.complete();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        this.form.value[field.name] = field.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @param {?} field
     * @return {?}
     */
    handleBlur(field) {
        this.blur.emit(field);
    }
}
InputComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <input ifPII base-input class=\"form-control\" [formControlName]=\"field.name\" (input)=\"changeOccurred($event, field)\"\n      [field]=\"field\" (blur)=\"handleBlur(field)\" [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.placeholder]=\"field.placeholder | translate\"\n      [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" [attr.aria-invalid]=\"hasError\" [attr.aria-describedby]=\"field.id + '_error_req ' + field.id + '_error_custom ' + field.id + '_help'\"/>\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
InputComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }],
    blur: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputComponent.prototype.field;
    /** @type {?} */
    InputComponent.prototype.change;
    /** @type {?} */
    InputComponent.prototype.blur;
    /** @type {?} */
    InputComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputFileComponent extends InputComponent {
    /**
     * @param {?} hostElement
     * @param {?} renderer
     */
    constructor(hostElement, renderer) {
        super();
        this.hostElement = hostElement;
        this.renderer = renderer;
        this.fileChange = new EventEmitter();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    fileChangeOccurred($event, field) {
        /** @type {?} */
        const file = this.getFile($event);
        if (file) {
            this.fileName = file.name;
        }
        super.changeOccurred($event, field);
        this.fileChange.emit(file);
    }
    /**
     * @return {?}
     */
    removeFile() {
        this.fileName = undefined;
        this.renderer.setValue(this.hostElement.nativeElement, '');
        this.fileChange.emit(undefined);
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        return;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.fileChange.complete();
    }
    /**
     * @private
     * @param {?} $event
     * @return {?}
     */
    getFile($event) {
        /** @type {?} */
        const eventObj = (/** @type {?} */ ($event));
        /** @type {?} */
        const target = (/** @type {?} */ (eventObj.target));
        if (target.files && target.files.length > 0) {
            return target.files[0];
        }
        return undefined;
    }
}
InputFileComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-file',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n\n    <div *ngIf=\"!fileName\" class=\"input-group\" style=\"overflow: hidden\">\n      <input ifPII base-input class=\"form-control\" [formControlName]=\"field.name\" (input)=\"fileChangeOccurred($event, field)\" [field]=\"field\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" style=\"position: absolute; opacity: 0; width: 100%; height: 100%\"\n        [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n      />\n\n      <button class=\"btn btn-primary\" type=\"button\">\n        <i class=\"ifc-icon ifc-upload pr-2\"></i>{{ 'ui.controls.input-file.file_upload' | translate }}\n      </button>\n    </div>\n\n    <div *ngIf=\"fileName\">\n      <div class=\"card d-flex flex-row mb-2\">\n        <div class=\"card-header p-3 d-none d-md-block\">\n          <i class=\"ifc-icon ifc-single-paragraph\"></i>\n        </div>\n        <div class=\"flex-column w-100 mw-0\" style=\"min-width: 0px;\">\n          <div class=\"d-flex flex-row\">\n            <div class=\"flex-column p-3\" style=\"min-width: 0px;\">\n              <h4 class=\"my-1 font-weight-bold text-truncate\" ifPII>{{fileName}}</h4>\n            </div>\n            <div class=\"flex-column p-3 ml-auto\">\n              <button class=\"btn btn-outline-danger btn-sm\" (click)=\"removeFile();\">{{'ui.controls.input-file.delete' | translate}}</button>\n            </div>\n          </div>\n\n        </div>\n      </div>\n\n    </div>\n\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
/** @nocollapse */
InputFileComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
InputFileComponent.propDecorators = {
    fileChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputFileComponent.prototype.fileChange;
    /** @type {?} */
    InputFileComponent.prototype.fileName;
    /**
     * @type {?}
     * @private
     */
    InputFileComponent.prototype.hostElement;
    /**
     * @type {?}
     * @private
     */
    InputFileComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InlineDatepickerComponent {
    /**
     * @param {?} elRef
     * @param {?} zone
     */
    constructor(elRef, zone) {
        this.elRef = elRef;
        this.zone = zone;
        this.change = new EventEmitter();
        this.dateFormat = 'yyyy-MM-dd';
        this.oldvalue = '';
        this.minDate = new Date(1950, 0, 1);
        this.maxDate = addYears((new Date()).setHours(23, 59, 59), 10);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            $(node).datepicker('destroy');
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.config) {
            this.setDateFormat(this.config.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('D', 'd').replace('YY', 'yy'));
            this.setMinMaxDate(this.config);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            this.zone.runOutsideAngular((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const datepickerSettings = {
                    autoclose: false,
                    endDate: format(this.maxDate, this.dateFormat),
                    format: this.dateFormat.toLowerCase(),
                    maxViewMode: this.config.maxView,
                    minViewMode: this.config.minView,
                    startView: this.config.startView,
                    startDate: this.config.startDate ? this.config.startDate : format(this.minDate, this.dateFormat),
                    showOnFocus: false
                };
                $(node)
                    .datepicker(datepickerSettings)
                    .on('show', (/**
                 * @return {?}
                 */
                () => {
                    this.timeSinceClose = null;
                    this.datepickerShowing = true;
                }))
                    .on('hide', (/**
                 * @param {?} evt
                 * @return {?}
                 */
                (evt) => {
                    this.datepickerShowing = false;
                    this.timeSinceClose = Date.now();
                }))
                    .on('changeDate', (/**
                 * @return {?}
                 */
                () => {
                    this.dateChanged();
                    if (this.datepickerShowing) {
                        this.toggle();
                    }
                }));
            }));
        }
    }
    /**
     * @return {?}
     */
    toggle() {
        if (this.timeSinceClose && Date.now() - this.timeSinceClose < 250) {
            return;
        }
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            if (this.datepickerShowing) {
                $(node).datepicker('hide');
            }
            else {
                $(node).datepicker('show')
                    .focus();
            }
            this.timeSinceClose = null;
        }
    }
    /**
     * @return {?}
     */
    dateChanged() {
        /** @type {?} */
        const dp = this.getDatePickerElement();
        /** @type {?} */
        const value = $(dp).datepicker('getFormattedDate');
        if (dp && value !== this.oldvalue) {
            this.oldvalue = value;
            this.change.emit(value);
        }
    }
    /**
     * @private
     * @return {?}
     */
    getDatePickerElement() {
        if (this.datepickerChild) {
            return this.datepickerChild.nativeElement;
        }
    }
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    setMinMaxDate(config) {
        if (config.minDate) {
            if (config.minDate === 'today') {
                /** @type {?} */
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = parse(this.dateFormat, config.minDate, new Date());
            }
        }
        if (config.maxDate) {
            if (config.maxDate === 'today') {
                /** @type {?} */
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.maxDate = parse(this.dateFormat, config.maxDate, new Date());
            }
        }
    }
    /**
     * @private
     * @param {?} dateFormat
     * @return {?}
     */
    setDateFormat(dateFormat) {
        if (!dateFormat) {
            this.dateFormat = `MM/dd/yyyy`;
            return;
        }
        /** @type {?} */
        const isPSDate = /^[YMD]{3}.$/;
        if (dateFormat !== 'yyyy' && dateFormat.length === 4 && dateFormat.match(isPSDate)) {
            /** @type {?} */
            const formatString = dateFormat.substring(0, 3);
            // date formats are expected to be 4 characters
            /** @type {?} */
            let separator = dateFormat.substring(3, 4);
            if (!separator) {
                separator = '/';
            }
            if (formatString === 'MDY') {
                this.dateFormat = `MM${separator}dd${separator}yyyy`;
            }
            else if (formatString === 'DMY') {
                this.dateFormat = `dd${separator}MM${separator}yyyy`;
            }
            else if (formatString === 'YMD') {
                this.dateFormat === `yyyy${separator}MM${separator}dd`;
            }
            else {
                this.dateFormat = `MM${separator}dd${separator}yyyy`;
            }
        }
        else {
            this.dateFormat = dateFormat;
        }
    }
}
InlineDatepickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-inline-datepicker',
                template: `<div id="datepicker" #datepicker></div>`
            }] }
];
/** @nocollapse */
InlineDatepickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
InlineDatepickerComponent.propDecorators = {
    datepickerChild: [{ type: ViewChild, args: ['datepicker', { static: true },] }],
    config: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InlineDatepickerComponent.prototype.datepickerChild;
    /** @type {?} */
    InlineDatepickerComponent.prototype.config;
    /** @type {?} */
    InlineDatepickerComponent.prototype.change;
    /** @type {?} */
    InlineDatepickerComponent.prototype.datePicker;
    /** @type {?} */
    InlineDatepickerComponent.prototype.dateFormat;
    /** @type {?} */
    InlineDatepickerComponent.prototype.minDate;
    /** @type {?} */
    InlineDatepickerComponent.prototype.maxDate;
    /**
     * @type {?}
     * @private
     */
    InlineDatepickerComponent.prototype.oldvalue;
    /**
     * @type {?}
     * @private
     */
    InlineDatepickerComponent.prototype.datepickerShowing;
    /**
     * @type {?}
     * @private
     */
    InlineDatepickerComponent.prototype.timeSinceClose;
    /**
     * @type {?}
     * @private
     */
    InlineDatepickerComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    InlineDatepickerComponent.prototype.zone;
}
/**
 * @record
 */
function DatepickerConfig() { }
if (false) {
    /** @type {?|undefined} */
    DatepickerConfig.prototype.minDate;
    /** @type {?|undefined} */
    DatepickerConfig.prototype.maxDate;
    /** @type {?|undefined} */
    DatepickerConfig.prototype.startDate;
    /** @type {?|undefined} */
    DatepickerConfig.prototype.granularity;
    /** @type {?} */
    DatepickerConfig.prototype.dateFormat;
    /** @type {?} */
    DatepickerConfig.prototype.startView;
    /** @type {?} */
    DatepickerConfig.prototype.minView;
    /** @type {?} */
    DatepickerConfig.prototype.maxView;
    /** @type {?|undefined} */
    DatepickerConfig.prototype.container;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ButtonGroupComponent {
    constructor() {
        this.click = new EventEmitter();
        this.primaryClick = new EventEmitter();
        this.secondaryClick = new EventEmitter();
        this.tertiaryClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.click.complete();
    }
    /**
     * @param {?} event
     * @param {?} field
     * @param {?} output
     * @return {?}
     */
    handleClick(event, field, output) {
        output.emit(field);
        this.click.emit(field);
        event.stopPropagation();
    }
}
ButtonGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-button-group',
                template: "<div class=\"row\" [class.justify-content-end]=\"!tertiaryAction\" [class.justify-content-between]=\"tertiaryAction\"\n  (click)=\"$event.stopPropagation()\">\n  <div class=\"col-12 col-lg-auto order-lg-2\">\n    <div class=\"row\">\n      <div class=\"col-12 order-lg-2 col-lg-auto pl-lg-1 mb-2 mb-lg-0\" *ngIf=\"primaryAction\">\n        <button\n          base-button\n          class=\"btn btn-primary btn-block\"\n          [field]=\"primaryAction\" (click)=\"handleClick($event, primaryAction, primaryClick)\"\n          [attr.data-if-id]=\"primaryAction.extraAttributes?.ifId? primaryAction.extraAttributes.ifId + 'primary' : 'primary'\">\n          {{primaryAction.text | translate}}\n        </button>\n      </div>\n      <div class=\"col-12 order-lg-1 col-lg-auto px-lg-1 mb-2 mb-lg-0\" *ngIf=\"secondaryAction\">\n        <button\n          base-button class=\"btn btn-default btn-block\"\n          [field]=\"secondaryAction\"\n          (click)=\"handleClick($event, secondaryAction, secondaryClick)\"\n          [attr.data-if-id]=\"secondaryAction.extraAttributes?.ifId? secondaryAction.extraAttributes.ifId + '-secondary' : 'secondary'\">\n          {{secondaryAction.text | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-12 col-lg-auto order-lg-1\" *ngIf=\"tertiaryAction\">\n    <button\n      base-button\n      class=\"btn btn-default btn-block\"\n      [field]=\"tertiaryAction\"\n      (click)=\"handleClick($event, tertiaryAction, tertiaryClick)\"\n      [attr.data-if-id]=\"tertiaryAction.extraAttributes?.ifId? tertiaryAction.extraAttributes.ifId + '-tertiary': 'tertiary'\">\n      {{tertiaryAction.text | translate}}\n    </button>\n  </div>\n</div>\n"
            }] }
];
ButtonGroupComponent.propDecorators = {
    primaryAction: [{ type: Input }],
    secondaryAction: [{ type: Input }],
    tertiaryAction: [{ type: Input }],
    click: [{ type: Output }],
    primaryClick: [{ type: Output }],
    secondaryClick: [{ type: Output }],
    tertiaryClick: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ButtonGroupComponent.prototype.primaryAction;
    /** @type {?} */
    ButtonGroupComponent.prototype.secondaryAction;
    /** @type {?} */
    ButtonGroupComponent.prototype.tertiaryAction;
    /** @type {?} */
    ButtonGroupComponent.prototype.click;
    /** @type {?} */
    ButtonGroupComponent.prototype.primaryClick;
    /** @type {?} */
    ButtonGroupComponent.prototype.secondaryClick;
    /** @type {?} */
    ButtonGroupComponent.prototype.tertiaryClick;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ListItem() { }
if (false) {
    /** @type {?|undefined} */
    ListItem.prototype.header;
    /** @type {?|undefined} */
    ListItem.prototype.subtext;
    /** @type {?|undefined} */
    ListItem.prototype.action;
    /** @type {?|undefined} */
    ListItem.prototype.icon;
    /** @type {?|undefined} */
    ListItem.prototype.isButton;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListViewComponent {
    constructor() {
        this.actionTriggered = new EventEmitter();
    }
    /**
     * @param {?} action
     * @return {?}
     */
    action(action) {
        this.actionTriggered.emit([action]);
    }
}
ListViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-list-view',
                template: "<ul class=\"row cards p-0\">\n  <li class=\"list-unstyled col-lg-6 mb-lg-3\" *ngFor=\"let item of list; let i = index\">\n    <a *ngIf=\"item.action; else notAction\" (click)=\"action(item.action)\" href=\"javascript:void(0);\"\n      [attr.role]=\"item.isButton ? 'button' : null\">\n      <div class=\"card h-100 d-flex flex-row align-items-start\">\n        <i class=\"ifc-icon ifc-icon-2 h-100 p-4 text-center {{item.icon}}\"></i>\n        <div class=\"card-body pl-3\">\n          <div *ngIf=\"item.header\" class=\"card-title h4 mb-1\" [innerHTML]=\"item.header\">\n          </div>\n          <ng-container [ngTemplateOutlet]=\"listItemTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n        </div>\n      </div>\n    </a>\n    <ng-template #notAction>\n      <div class=\"card h-100 d-flex flex-row align-items-start\">\n        <i class=\"ifc-icon ifc-icon-2 h-100 p-4 text-center {{item.icon}}\"></i>\n        <div class=\"card-body pl-3\">\n          <div *ngIf=\"item.header\" class=\"card-title h4 mb-1\" [innerHTML]=\"item.header\">\n          </div>\n          <ng-container [ngTemplateOutlet]=\"listItemTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n        </div>\n      </div>\n    </ng-template>\n  </li>\n</ul>\n"
            }] }
];
/** @nocollapse */
ListViewComponent.ctorParameters = () => [];
ListViewComponent.propDecorators = {
    listItemTemplate: [{ type: ContentChild, args: [TemplateRef, { static: false },] }],
    list: [{ type: Input }],
    actionTriggered: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ListViewComponent.prototype.listItemTemplate;
    /** @type {?} */
    ListViewComponent.prototype.list;
    /** @type {?} */
    ListViewComponent.prototype.actionTriggered;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TileViewComponent {
    constructor() {
        this.actionTriggered = new EventEmitter();
    }
    /**
     * @param {?} action
     * @return {?}
     */
    action(action) {
        this.actionTriggered.emit([action]);
    }
}
TileViewComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-tile-view',
                template: "<ul class=\"row cards p-0\">\n  <li class=\"list-unstyled col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mb-4\" *ngFor=\"let item of list; let i = index\">\n    <a *ngIf=\"item.action; else notAction\" class=\"card h-100\" href=\"javascript:void(0);\" (click)=\"action(item.action)\" [attr.role]=\"item.isButton ? 'button' : null\">\n      <div class=\"card-body d-flex flex-column justify-content-center text-center\">\n        <i *ngIf=\"item.icon\" class=\"ifc-icon ifc-icon-2 p-4 {{item.icon}}\"></i>\n        <div *ngIf=\"item.header\" class=\"tile-header mb-1 h1 text-primary\" [innerHTML]=\"item.header\">\n        </div>\n        <div class=\"tile-subtext text-muted m-0\" *ngIf=\"item.subtext\" [innerHTML]=\"item.subtext\"></div>\n      </div>\n      <div class=\"card-footer border-0 small text-muted\" *ngIf=\"tileTemplate\">\n        <ng-container [ngTemplateOutlet]=\"tileTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n      </div>\n    </a>\n    <ng-template #notAction>\n      <div class=\"card h-100\">\n        <div class=\"card-body d-flex flex-column justify-content-center text-center\">\n          <i *ngIf=\"item.icon\" class=\"ifc-icon ifc-icon-2 p-4 {{item.icon}}\"></i>\n          <div *ngIf=\"item.header\" class=\"tile-header mb-1 h1 text-primary\" [innerHTML]=\"item.header\">\n          </div>\n          <div class=\"tile-subtext text-muted m-0\" *ngIf=\"item.subtext\" [innerHTML]=\"item.subtext\"></div>\n        </div>\n        <div class=\"card-footer border-0 small text-muted\" *ngIf=\"tileTemplate\">\n          <ng-container [ngTemplateOutlet]=\"tileTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n        </div>\n      </div>\n    </ng-template>\n  </li>\n</ul>\n"
            }] }
];
/** @nocollapse */
TileViewComponent.ctorParameters = () => [];
TileViewComponent.propDecorators = {
    tileTemplate: [{ type: ContentChild, args: [TemplateRef, { static: false },] }],
    list: [{ type: Input }],
    actionTriggered: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    TileViewComponent.prototype.tileTemplate;
    /** @type {?} */
    TileViewComponent.prototype.list;
    /** @type {?} */
    TileViewComponent.prototype.actionTriggered;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IGenericEdit() { }
if (false) {
    /** @type {?|undefined} */
    IGenericEdit.prototype.header;
    /** @type {?} */
    IGenericEdit.prototype.page;
    /** @type {?} */
    IGenericEdit.prototype.hiddens;
    /** @type {?} */
    IGenericEdit.prototype.errors;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoadingService {
    /**
     * @param {?} router
     * @param {?} translate
     */
    constructor(router, translate) {
        this.router = router;
        this.translate = translate;
        this.loadingSpinnerCompleteId = "LoadingSpinnerComplete";
        this.subject = new BehaviorSubject(false);
        this.observable = this.subject.asObservable();
    }
    /**
     * @param {?} status
     * @return {?}
     */
    setStatus(status) {
        this.subject.next(status);
    }
    /**
     * @return {?}
     */
    get status() {
        return this.observable;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subject.complete();
    }
}
LoadingService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LoadingService.ctorParameters = () => [
    { type: Router },
    { type: TranslateService }
];
/** @nocollapse */ LoadingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(ɵɵinject(Router), ɵɵinject(TranslateService)); }, token: LoadingService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoadingService.prototype.subject;
    /**
     * @type {?}
     * @private
     */
    LoadingService.prototype.observable;
    /**
     * @type {?}
     * @private
     */
    LoadingService.prototype.loadingSpinnerCompleteId;
    /**
     * @type {?}
     * @private
     */
    LoadingService.prototype.router;
    /**
     * @type {?}
     * @private
     */
    LoadingService.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificationService {
    constructor() {
        this.pendingMessage = '';
        this.messageSubject = new BehaviorSubject({ msg: '' });
        this.messageObservable = this.messageSubject.asObservable();
        this.alertSubject = new Subject();
        this.alertObservable = this.alertSubject.asObservable();
    }
    /**
     * @param {?} message
     * @param {?=} delay
     * @return {?}
     */
    setMessage(message, delay) {
        if (delay) {
            this.messageSubject.next({ msg: message, delay: delay });
        }
        else {
            this.messageSubject.next({ msg: message });
        }
    }
    /**
     * @param {?} message
     * @param {?=} delay
     * @return {?}
     */
    setAlert(message, delay) {
        if (delay) {
            this.alertSubject.next({ msg: message, delay: delay });
        }
        else {
            this.alertSubject.next({ msg: message });
        }
    }
    /**
     * @return {?}
     */
    get message() {
        return this.messageObservable;
    }
    /**
     * @return {?}
     */
    get alert() {
        return this.alertObservable;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.messageSubject) {
            this.messageSubject.complete();
        }
        if (this.alertSubject) {
            this.alertSubject.complete();
        }
    }
}
NotificationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NotificationService.ctorParameters = () => [];
/** @nocollapse */ NotificationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(); }, token: NotificationService, providedIn: "root" });
if (false) {
    /** @type {?} */
    NotificationService.prototype.pendingMessage;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.messageSubject;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.messageObservable;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.alertSubject;
    /**
     * @type {?}
     * @private
     */
    NotificationService.prototype.alertObservable;
}
/**
 * @record
 */
function NotificationMessage() { }
if (false) {
    /** @type {?} */
    NotificationMessage.prototype.msg;
    /** @type {?|undefined} */
    NotificationMessage.prototype.delay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoadingSpinnerComponent {
    /**
     * @param {?} loadingService
     * @param {?} notificationService
     * @param {?} translate
     */
    constructor(loadingService, notificationService, translate) {
        this.loadingService = loadingService;
        this.notificationService = notificationService;
        this.translate = translate;
        this.notificationToggle = true;
        this.loadingMessage = 'ui.controls.loading-spinner.label';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.notificationToggle) {
            this.translate.get(this.loadingMessage).subscribe((/**
             * @param {?} term
             * @return {?}
             */
            term => {
                this.notificationService.setMessage(term);
            }));
        }
    }
}
LoadingSpinnerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-loading-spinner',
                template: "\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\"\n  xml:space=\"preserve\" width=\"64\" height=\"64\">\n  <g class=\"nc-icon-wrapper\" fill=\"#444444\">\n    <g class=\"nc-loop_dots-07-64\">\n      <circle data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\"\n        cx=\"32\" cy=\"32\" r=\"6\" transform=\"translate(9.071078400034459 9.071078400034459) scale(0.7165287999989232)\" style=\"opacity:0.7165287999989232;\"\n        stroke-linejoin=\"miter\"></circle>\n      <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"8\" cy=\"32\" r=\"6\"\n        stroke-linejoin=\"miter\" style=\"opacity:0.6834712000010768;\" transform=\"translate(2.532230399991386 10.128921599965544) scale(0.6834712000010768)\"></circle>\n      <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"56\" cy=\"32\" r=\"6\"\n        transform=\"translate(33.6 19.2) scale(0.4)\" style=\"opacity:0.4;\" stroke-linejoin=\"miter\"></circle>\n    </g>\n    <script>\n      ! function () {\n        function t(t) {\n          this.element = t, this.dots = [this.element.getElementsByTagName(\"circle\")[1], this.element.getElementsByTagName(\n              \"circle\")[0], this.element.getElementsByTagName(\"circle\")[2]], this.animationId, this.start = null,\n            this.init()\n        }\n        if (!window.requestAnimationFrame) {\n          var e = null;\n          window.requestAnimationFrame = function (t, i) {\n            var n = (new Date).getTime();\n            e || (e = n);\n            var a = Math.max(0, 16 - (n - e)),\n              s = window.setTimeout(function () {\n                t(n + a)\n              }, a);\n            return e = n + a, s\n          }\n        }\n        t.prototype.init = function () {\n          var t = this;\n          this.animationId = window.requestAnimationFrame(t.triggerAnimation.bind(t))\n        }, t.prototype.reset = function () {\n          var t = this;\n          window.cancelAnimationFrame(t.animationId)\n        }, t.prototype.triggerAnimation = function (t) {\n          var e = this;\n          this.start || (this.start = t);\n          var i = t - this.start,\n            n = Math.min(i / 250, 4),\n            a = (n = 4 == n ? 0 : n) % 1,\n            s = Math.ceil(n);\n          1e3 > i || (this.start = this.start + 1e3);\n          var r = [],\n            o = [8, 32, 56],\n            m = [32, 32, 32];\n          switch (r[0] = r[1] = r[2] = .4, s) {\n            case 1:\n              r[0] = 1 - 3 * a / 5, r[1] = .4 + 3 * a / 5;\n              break;\n            case 2:\n              r[1] = 1 - 3 * a / 5, r[2] = .4 + 3 * a / 5;\n              break;\n            case 3:\n              r[1] = .4 + 3 * a / 5, r[2] = 1 - 3 * a / 5;\n              break;\n            case 4:\n              r[0] = .4 + 3 * a / 5, r[1] = 1 - 3 * a / 5;\n              break;\n            default:\n              r[0] = 1\n          }\n          for (var c = 0; 3 > c; c++) this.dots[c].setAttribute(\"style\", \"opacity:\" + r[c] + \";\"), this.dots[c].setAttribute(\n            \"transform\", \"translate(\" + (1 - r[c]) * o[c] + \" \" + (1 - r[c]) * m[c] + \") scale(\" + r[c] + \")\");\n          if (document.documentElement.contains(this.element)) window.requestAnimationFrame(e.triggerAnimation.bind(\n            e))\n        };\n        var i = document.getElementsByClassName(\"nc-loop_dots-07-64\"),\n          n = [];\n        if (i)\n          for (var a = 0; i.length > a; a++) ! function (e) {\n            n.push(new t(i[e]))\n          }(a);\n        document.addEventListener(\"visibilitychange\", function () {\n          \"hidden\" == document.visibilityState ? n.forEach(function (t) {\n            t.reset()\n          }) : n.forEach(function (t) {\n            t.init()\n          })\n        })\n      }();\n\n    </script>\n  </g>\n</svg>\n\n"
            }] }
];
/** @nocollapse */
LoadingSpinnerComponent.ctorParameters = () => [
    { type: LoadingService },
    { type: NotificationService },
    { type: TranslateService }
];
LoadingSpinnerComponent.propDecorators = {
    notificationToggle: [{ type: Input }],
    loadingMessage: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    LoadingSpinnerComponent.prototype.active;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.notificationToggle;
    /** @type {?} */
    LoadingSpinnerComponent.prototype.loadingMessage;
    /**
     * @type {?}
     * @private
     */
    LoadingSpinnerComponent.prototype.loadingService;
    /**
     * @type {?}
     * @private
     */
    LoadingSpinnerComponent.prototype.notificationService;
    /**
     * @type {?}
     * @private
     */
    LoadingSpinnerComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoadingComponent {
    /**
     * @param {?} loadingService
     */
    constructor(loadingService) {
        this.title = 'Loading';
        loadingService.status.subscribe((/**
         * @param {?} status
         * @return {?}
         */
        status => {
            this.active = status;
        }));
    }
}
LoadingComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-loading',
                template: "<div id=\"overlay\" class=\"overlay\" [ngClass]=\"{'active': active}\"></div>\n<div id=\"loader\" class=\"loader\" [ngClass]=\"{'active': active}\">\n  <ui-loading-spinner *ngIf=\"active\"></ui-loading-spinner>\n</div>\n"
            }] }
];
/** @nocollapse */
LoadingComponent.ctorParameters = () => [
    { type: LoadingService }
];
LoadingComponent.propDecorators = {
    active: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    LoadingComponent.prototype.title;
    /** @type {?} */
    LoadingComponent.prototype.active;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorComponent {
    /**
     * @param {?} activatedRoute
     * @param {?} router
     * @param {?} lastResponseService
     */
    constructor(activatedRoute, router, lastResponseService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.lastResponseService = lastResponseService;
        this.errorType = 'general'; // default
        this.hideGoHome = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.routeDataSubscription = this.activatedRoute.data.subscribe((/**
         * @param {?} routeData
         * @return {?}
         */
        routeData => {
            if (routeData.errorType) {
                this.errorType = routeData.errorType;
                this.hideGoHome = routeData.hideGoHome;
            }
        }));
        if (this.lastResponseService.ifResponse
            && this.lastResponseService.ifResponse.Results
            && this.lastResponseService.ifResponse.Results.data
            && this.lastResponseService.ifResponse.Results.data.native) {
            this.error = this.lastResponseService.ifResponse.Results.data.native;
        }
        this.setErrorContent(this.errorType);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['error']) {
            /** @type {?} */
            let errorDetails = [];
            if (this.error) {
                if (this.error.header) {
                    errorDetails.push(`<head>${this.error.header}</head>`);
                }
                if (this.error.body) {
                    errorDetails.push(`<body>${this.error.body}</body>`);
                }
                if (errorDetails.length > 0) {
                    errorDetails = ['<html>', ...errorDetails, '</html>'];
                }
                if (this.error.details) {
                    errorDetails.push(this.error.details);
                }
            }
            this.errorDetails = errorDetails.join('');
        }
    }
    /**
     * @private
     * @param {?} errorType
     * @return {?}
     */
    setErrorContent(errorType) {
        switch (errorType) {
            case 'network':
                this.errorIcon = 'ifc-planet';
                this.errorHeader = 'ui.error.network_header';
                this.errorText = 'ui.error.network_text';
                break;
            case 'sso':
                this.errorIcon = 'ifc-alert-circle-exc';
                this.errorHeader = 'ui.error.sso_header';
                this.errorText = 'ui.error.sso_text';
                break;
            case 'not-found':
                this.errorIcon = 'ifc-search';
                this.errorHeader = 'ui.error.not_found_header';
                this.errorText = 'ui.error.not_found_text';
                break;
            default:
                this.errorIcon = 'ifc-alert-circle-exc';
                this.errorHeader = 'ui.error.general_header';
                this.errorText = 'ui.error.general_text';
                break;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.routeDataSubscription) {
            this.routeDataSubscription.unsubscribe();
        }
    }
    /**
     * @return {?}
     */
    goHome() {
        this.router.navigateByUrl('');
    }
}
ErrorComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-error',
                template: "<article class=\"row\">\n    <div class=\"col-sm-10 offset-sm-1 col-xl-8 offset-xl-2 card p-4 p-sm-5 text-center\">\n      <i class=\"ifc-icon {{errorIcon}} ifc-icon-3 mb-2\"></i>\n      <h1 class=\"h2\">{{errorHeader | translate}}</h1>\n      <p class=\"lead my-4\">{{errorText | translate}}</p><span *ngIf=\"errorDetails\"><a href=\"#\" role=\"button\" data-toggle=\"collapse\" data-target=\"#result\">{{ 'ui.error.more_details' | translate }}</a> </span>\n\n      <div class=\"row\">\n        <div id=\"result\" class=\"collapse col\" *ngIf=\"errorDetails\">\n          <textarea readonly class=\"form-control\" rows=\"20\" id=\"resultPage\">{{errorDetails}}</textarea>\n        </div>\n      </div>\n\n      <ng-content></ng-content>\n\n      <button class=\"btn btn-outline-primary mt-4\" (click)=\"goHome()\" *ngIf=\"!hideGoHome\">{{'ui.error.return_home' | translate}}</button>\n    </div>\n  </article>\n"
            }] }
];
/** @nocollapse */
ErrorComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: LastResponseService }
];
ErrorComponent.propDecorators = {
    errorType: [{ type: Input }],
    error: [{ type: Input }],
    hideGoHome: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ErrorComponent.prototype.errorType;
    /** @type {?} */
    ErrorComponent.prototype.error;
    /** @type {?} */
    ErrorComponent.prototype.hideGoHome;
    /** @type {?} */
    ErrorComponent.prototype.errorHeader;
    /** @type {?} */
    ErrorComponent.prototype.errorText;
    /** @type {?} */
    ErrorComponent.prototype.errorIcon;
    /** @type {?} */
    ErrorComponent.prototype.errorDetails;
    /**
     * @type {?}
     * @private
     */
    ErrorComponent.prototype.routeDataSubscription;
    /**
     * @type {?}
     * @private
     */
    ErrorComponent.prototype.activatedRoute;
    /**
     * @type {?}
     * @private
     */
    ErrorComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ErrorComponent.prototype.lastResponseService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CopyrightComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.year = new Date().getFullYear();
    }
}
CopyrightComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-copyright',
                template: "<span>{{ 'ui.copyright' | translate:{'year':year, 'company': company} }}</span>"
            }] }
];
/** @nocollapse */
CopyrightComponent.ctorParameters = () => [];
CopyrightComponent.propDecorators = {
    company: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CopyrightComponent.prototype.company;
    /** @type {?} */
    CopyrightComponent.prototype.year;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AttachmentsComponent {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.done = new EventEmitter();
        this.urlPrefix = settings.defaultSystemSettings.IFURLPrefix;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes) {
            this._attachments = this.attachments;
        }
    }
    /**
     * @param {?} attachment
     * @return {?}
     */
    updateAttachmentList(attachment) {
        this._attachments = this._attachments.filter((/**
         * @param {?} attach
         * @return {?}
         */
        attach => attach !== attachment));
        if (this._attachments.length === 0) {
            this.done.emit();
        }
    }
    /**
     * @param {?} url
     * @return {?}
     */
    toAttachmentUrl(url) {
        /** @type {?} */
        const hasHostRegex = /https?:\/\/[^/]+\/.*/i;
        if (!hasHostRegex.test(url)) {
            url = `${this.urlPrefix}${url}`;
        }
        return url.replace('/NLX3/', '/').replace('/NLX7/', '/');
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.done.complete();
    }
}
AttachmentsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-attachments',
                template: "<div *ngFor=\"let attachment of _attachments\">\n  <div class=\"card w-100\">\n    <div class=\"d-flex flex-row\">\n      <div class=\"card-body d-flex justify-content-around\">\n        <h5 class=\"mb-0 pt-1 mr-2\">\n          {{ 'ui.attachments.information' | translate }}\n        </h5>\n        <a\n          class=\"btn btn-primary mr-2\"\n          [title]=\"'ui.attachments.title' | translate\"\n          href=\"{{toAttachmentUrl(attachment.url)}}\"\n          target=\"_blank\"\n          [attr.download]=\"forceDownloadOption ? '' : null\"\n          (click)=\"updateAttachmentList(attachment)\"\n        >\n          <ng-container *ngIf=\"forceDownloadOption\">{{\n            'ui.attachments.download' | translate\n          }}</ng-container>\n          <ng-container *ngIf=\"!forceDownloadOption\">{{\n            'ui.attachments.view_attachment' | translate\n          }}</ng-container>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
AttachmentsComponent.ctorParameters = () => [
    { type: SettingsService }
];
AttachmentsComponent.propDecorators = {
    attachments: [{ type: Input }],
    forceDownloadOption: [{ type: Input }],
    done: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    AttachmentsComponent.prototype.attachments;
    /** @type {?} */
    AttachmentsComponent.prototype.forceDownloadOption;
    /** @type {?} */
    AttachmentsComponent.prototype.done;
    /** @type {?} */
    AttachmentsComponent.prototype._attachments;
    /** @type {?} */
    AttachmentsComponent.prototype.urlPrefix;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ResponsiveImgComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const img = {};
        if (this.src && typeof (this.src) !== 'string') {
            /** @type {?} */
            const rimg = (/** @type {?} */ (this.src));
            if (rimg.path) {
                img.src = `${rimg.path}${rimg.src}`;
            }
            else {
                img.src = rimg.src;
            }
            if (rimg.srcset) {
                /** @type {?} */
                const imageName = rimg.src.substring(0, rimg.src.lastIndexOf(','));
                /** @type {?} */
                const regex = new RegExp(`${imageName}`, 'g');
                img.srcset = rimg.srcset.replace(regex, `${rimg.path}${imageName}`);
            }
            img.sizes = rimg.sizes;
            img.alt = rimg.alt;
        }
        else {
            img.src = this.src;
        }
        this.img = img.src ? img : undefined;
    }
}
ResponsiveImgComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-responsive-img',
                template: "<picture *ngIf=\"img\">\n  <img\n    class=\"img-fluid\"\n    [src]=\"img.src\"\n    [attr.sizes]=\"img.sizes\"\n    [attr.srcset]=\"img.srcset\"\n    [attr.alt]= \"alt || img.alt\"\n    [attr.role]=\"!alt && !img.alt? 'presentation': ''\"\n    >\n</picture>\n"
            }] }
];
/** @nocollapse */
ResponsiveImgComponent.ctorParameters = () => [];
ResponsiveImgComponent.propDecorators = {
    src: [{ type: Input }],
    alt: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ResponsiveImgComponent.prototype.img;
    /** @type {?} */
    ResponsiveImgComponent.prototype.src;
    /** @type {?} */
    ResponsiveImgComponent.prototype.alt;
}
/**
 * @record
 */
function ResponsiveImage() { }
if (false) {
    /** @type {?} */
    ResponsiveImage.prototype.src;
    /** @type {?|undefined} */
    ResponsiveImage.prototype.sizes;
    /** @type {?|undefined} */
    ResponsiveImage.prototype.srcset;
    /** @type {?|undefined} */
    ResponsiveImage.prototype.path;
    /** @type {?|undefined} */
    ResponsiveImage.prototype.alt;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormHelper {
    /**
     * @param {?} form
     * @return {?}
     */
    static validateForm(form) {
        form.markAsTouched();
        form.markAsDirty();
        this.markDirtyandTouched(form);
        form.updateValueAndValidity();
    }
    /**
     * @private
     * @param {?} form
     * @return {?}
     */
    static markDirtyandTouched(form) {
        Object.keys(form.controls).forEach((/**
         * @param {?} ctrl
         * @return {?}
         */
        ctrl => {
            if (form.controls[ctrl].controls) {
                this.markDirtyandTouched(form.controls[ctrl]);
            }
            form.controls[ctrl].markAsTouched();
            form.controls[ctrl].markAsDirty();
            form.controls[ctrl].updateValueAndValidity();
        }));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Modal() { }
if (false) {
    /** @type {?} */
    Modal.prototype.selected;
    /** @type {?} */
    Modal.prototype.disableDismiss;
}
class ModalService {
    constructor() {
        this.showModal = {
            selected: '',
            disableDismiss: true
        };
        this.modalSource = new Subject();
        this.modalObservable = this.modalSource.asObservable();
    }
    /**
     * @param {?=} disableDismiss
     * @param {?=} id
     * @return {?}
     */
    show(disableDismiss = false, id = 'default') {
        this.showModal = {
            selected: id,
            disableDismiss: disableDismiss
        };
        this.modalSource.next(this.showModal);
    }
    /**
     * @return {?}
     */
    hide() {
        this.showModal.selected = '';
        this.modalSource.next(this.showModal);
    }
}
ModalService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ModalService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    ModalService.prototype.showModal;
    /** @type {?} */
    ModalService.prototype.modalObservable;
    /**
     * @type {?}
     * @private
     */
    ModalService.prototype.modalSource;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalComponent {
    /**
     * @param {?} modalService
     */
    constructor(modalService) {
        this.modalService = modalService;
        this.id = 'default';
        this.focusedElementSelector = 'input:not([disabled]):not([type="hidden"]),select:not([disabled]), button:not([disabled]), a';
        this.closed = new EventEmitter();
        this.showModal = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.modalService.modalObservable.subscribe((/**
         * @param {?} show
         * @return {?}
         */
        show => {
            if (show && show.selected === this.id) {
                this.disableDismiss = show.disableDismiss;
                this.showModal = true;
            }
            else if (this.showModal) {
                this.closed.emit(this.id);
                this.showModal = false;
            }
        })));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.closed.complete();
    }
    /**
     * @param {?=} $event
     * @return {?}
     */
    closeModal($event) {
        if ((!$event || $event.className.indexOf("modal ") !== -1) && !this.disableDismiss) {
            this.modalService.hide();
        }
    }
}
ModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-modal',
                template: "<div class=\"modal fade\" [ngClass]=\"{'show': showModal, 'd-block':showModal, 'd-none':!showModal}\"\n  (keyup.esc)=\"closeModal()\" (click)=\"closeModal($event.target)\" tabindex=\"-1\" role=\"dialog\"\n  [attr.aria-label]=\"label | translate\" [attr.aria-modal]='true'>\n  <ng-container *ngIf=\"showModal\">\n    <div class=\"modal-dialog modal-dialog-scrollable\" uiModalDialog [focusedElementSelector]=\"focusedElementSelector\"\n      [lastFocusableElementId]=\"lastFocusableElementId\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\" *ngIf=\"headerTemplate\" tabindex=\"-1\">\n          <ng-container [ngTemplateOutlet]=\"headerTemplate\">\n          </ng-container>\n        </div>\n        <div class=\"modal-body\" *ngIf=\"bodyTemplate\">\n          <ng-container [ngTemplateOutlet]=\"bodyTemplate\">\n          </ng-container>\n        </div>\n        <div class=\"modal-footer\" *ngIf=\"footerTemplate\">\n          <ng-container [ngTemplateOutlet]=\"footerTemplate\">\n          </ng-container>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</div>\n\n<ng-container *ngIf=\"showModal\">\n  <div class=\"modal-backdrop fade show\"> </div>\n</ng-container>"
            }] }
];
/** @nocollapse */
ModalComponent.ctorParameters = () => [
    { type: ModalService }
];
ModalComponent.propDecorators = {
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate', { static: false },] }],
    bodyTemplate: [{ type: ContentChild, args: ['bodyTemplate', { static: false },] }],
    footerTemplate: [{ type: ContentChild, args: ['footerTemplate', { static: false },] }],
    label: [{ type: Input }],
    id: [{ type: Input }],
    focusedElementSelector: [{ type: Input }],
    lastFocusableElementId: [{ type: Input }],
    closed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ModalComponent.prototype.headerTemplate;
    /** @type {?} */
    ModalComponent.prototype.bodyTemplate;
    /** @type {?} */
    ModalComponent.prototype.footerTemplate;
    /** @type {?} */
    ModalComponent.prototype.label;
    /** @type {?} */
    ModalComponent.prototype.id;
    /** @type {?} */
    ModalComponent.prototype.focusedElementSelector;
    /** @type {?} */
    ModalComponent.prototype.lastFocusableElementId;
    /** @type {?} */
    ModalComponent.prototype.closed;
    /** @type {?} */
    ModalComponent.prototype.showModal;
    /** @type {?} */
    ModalComponent.prototype.disableDismiss;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.modalService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const UI_PROXY_KEY = '__PROXY_DO_NOT_PROMPT__';
class ProxyUrlService {
    /**
     * @param {?} lastResponse
     * @param {?} settings
     */
    constructor(lastResponse, settings) {
        this.lastResponse = lastResponse;
        this.settings = settings;
        this.subject = new Subject();
        this.observable = this.subject.asObservable();
        this.lastResponse.ifResponseObservable.subscribe((/**
         * @param {?} ifResponse
         * @return {?}
         */
        (ifResponse) => {
            if (this.isProxyRoute(ifResponse)) {
                /** @type {?} */
                const responseData = (/** @type {?} */ (ifResponse.Results.data));
                /** @type {?} */
                let url;
                if (responseData && responseData.url) {
                    url = responseData.url;
                }
                else {
                    url = this.lastResponse.getReferringTarget();
                }
                this.subject.next({
                    proxyUrl: this.processProxyUrl(url),
                    title: responseData.title
                });
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.removeDoNotPromptSetting();
    }
    /**
     * @param {?} ifResponse
     * @return {?}
     */
    isProxyRoute(ifResponse) {
        return (ifResponse &&
            ifResponse.ProposedTemplate &&
            ifResponse.ProposedTemplate.indexOf('/proxy-page') === 0);
    }
    /**
     * @return {?}
     */
    get proxyUrl() {
        return this.observable;
    }
    /**
     * @return {?}
     */
    getDoNotPromptState() {
        return sessionStorage.getItem(UI_PROXY_KEY);
    }
    /**
     * @return {?}
     */
    setDoNotPromptForSession() {
        sessionStorage.setItem(UI_PROXY_KEY, 'true');
    }
    /**
     * @return {?}
     */
    removeDoNotPromptSetting() {
        sessionStorage.removeItem(UI_PROXY_KEY);
    }
    /**
     * @param {?} url
     * @return {?}
     */
    processProxyUrl(url) {
        if (!url) {
            return;
        }
        if (url && url.indexOf('http') !== 0) {
            url = this.settings.IFURLPrefix + url;
        }
        return url
            .replace('/NLX3/', '/')
            .replace('/NLX7/', '/');
    }
}
ProxyUrlService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ProxyUrlService.ctorParameters = () => [
    { type: LastResponseService },
    { type: SettingsService }
];
/** @nocollapse */ ProxyUrlService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ProxyUrlService_Factory() { return new ProxyUrlService(ɵɵinject(LastResponseService), ɵɵinject(SettingsService)); }, token: ProxyUrlService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ProxyUrlService.prototype.subject;
    /**
     * @type {?}
     * @private
     */
    ProxyUrlService.prototype.observable;
    /**
     * @type {?}
     * @private
     */
    ProxyUrlService.prototype.lastResponse;
    /**
     * @type {?}
     * @private
     */
    ProxyUrlService.prototype.settings;
}
/**
 * @record
 */
function ProxyUrlData() { }
if (false) {
    /** @type {?} */
    ProxyUrlData.prototype.proxyUrl;
    /** @type {?} */
    ProxyUrlData.prototype.title;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProxyUrlComponent {
    /**
     * @param {?} proxyService
     */
    constructor(proxyService) {
        this.proxyService = proxyService;
        this.done = new EventEmitter();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    promptChanged(e) {
        if (e) {
            /** @type {?} */
            const target = e.target;
            this.doNotPrompt = target.checked;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.done.complete();
    }
    /**
     * @return {?}
     */
    open() {
        if (this.doNotPrompt) {
            this.proxyService.setDoNotPromptForSession();
        }
        this.done.emit();
    }
}
ProxyUrlComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-proxy-url',
                template: "<div class=\"card w-100\" *ngIf=\"data\">\n\t<div class=\"d-flex flex-row\">\n\t\t<div class=\"card-body\">\n\t\t\t<p>{{'ui.proxy_url.description' | translate}} </p>\n\t\t\t<div class=\"mb-4\">\n\t\t\t\t<div class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input class=\"custom-control-input\"\n\t\t\t\t\t name=\"doNotPromptAgain\" id=\"doNotPromptAgain\" type=\"checkbox\" (change)=\"promptChanged($event)\">\n\t\t\t\t\t <label class=\"custom-control-label\" for=\"doNotPromptAgain\">{{'ui.proxy_url.do_not_prompt_text' | translate}}</label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"doNotPrompt\" class=\"mt-3 alert alert-warning\">{{'ui.proxy_url.popup_blocker_text' | translate}}</div>\n\t\t\t</div>\n\t\t\t<div class=\"d-flex justify-content-around\">\n\t\t\t\t<a class=\"btn btn-primary btn-block\" [title]=\"data.title\" [href]=\"data.proxyUrl\" target=\"_blank\" (click)=\"open()\">\n\t\t\t\t\t{{'ui.proxy_url.open' | translate}} {{data.title}} <span class=\"sr-only\">{{'ui.proxy_url.new_window_text' |\n\t\t\t\t\t\ttranslate}}</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
            }] }
];
/** @nocollapse */
ProxyUrlComponent.ctorParameters = () => [
    { type: ProxyUrlService }
];
ProxyUrlComponent.propDecorators = {
    data: [{ type: Input }],
    done: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ProxyUrlComponent.prototype.data;
    /** @type {?} */
    ProxyUrlComponent.prototype.done;
    /** @type {?} */
    ProxyUrlComponent.prototype.doNotPrompt;
    /**
     * @type {?}
     * @private
     */
    ProxyUrlComponent.prototype.proxyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TrackingPixelsService {
    /**
     * @param {?} lastResponse
     * @param {?} settings
     */
    constructor(lastResponse, settings) {
        this.lastResponse = lastResponse;
        this.settings = settings;
        this.pixelsSubject = new Subject();
        this.pixels = this.pixelsSubject.asObservable();
        this.lastResponse.ifResponseObservable.subscribe((/**
         * @param {?} ifr
         * @return {?}
         */
        ifr => {
            if (ifr && ifr.Results && ifr.Results.data && ifr.Results.data.trackingPixels) {
                /** @type {?} */
                const pixels = (/** @type {?} */ (ifr.Results.data.trackingPixels));
                this.setPixels(pixels.map((/**
                 * @param {?} pixel
                 * @return {?}
                 */
                pixel => {
                    if (UrlUtils.isInFlightUrl(pixel.src) && pixel.src.indexOf('http') === -1) {
                        return {
                            src: `${this.settings.IFURLPrefix}${pixel.src}`
                        };
                    }
                    else {
                        return pixel;
                    }
                })));
            }
        }));
    }
    /**
     * @param {?} pixels
     * @return {?}
     */
    setPixels(pixels) {
        this.pixelsSubject.next(pixels);
    }
}
TrackingPixelsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TrackingPixelsService.ctorParameters = () => [
    { type: LastResponseService },
    { type: SettingsService }
];
if (false) {
    /** @type {?} */
    TrackingPixelsService.prototype.pixels;
    /**
     * @type {?}
     * @private
     */
    TrackingPixelsService.prototype.pixelsSubject;
    /**
     * @type {?}
     * @private
     */
    TrackingPixelsService.prototype.lastResponse;
    /**
     * @type {?}
     * @private
     */
    TrackingPixelsService.prototype.settings;
}
/**
 * @record
 */
function Pixel() { }
if (false) {
    /** @type {?} */
    Pixel.prototype.src;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TrackingPixelsComponent {
    /**
     * @param {?} service
     */
    constructor(service) {
        this.service = service;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.pixelSubscription = this.service.pixels.subscribe((/**
         * @param {?} pixels
         * @return {?}
         */
        pixels => {
            this.pixels = pixels;
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.pixelSubscription) {
            this.pixelSubscription.unsubscribe();
        }
    }
}
TrackingPixelsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-tracking-pixels',
                template: `<div *ngIf="pixels">
              <img *ngFor="let pixel of pixels" [src]="pixel.src" width="1px" height="1px" style="display:none;" aria-hidden="true">
             </div>`
            }] }
];
/** @nocollapse */
TrackingPixelsComponent.ctorParameters = () => [
    { type: TrackingPixelsService }
];
if (false) {
    /** @type {?} */
    TrackingPixelsComponent.prototype.pixels;
    /**
     * @type {?}
     * @private
     */
    TrackingPixelsComponent.prototype.pixelSubscription;
    /**
     * @type {?}
     * @private
     */
    TrackingPixelsComponent.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageContentComponent {
    constructor() { }
}
ImageContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-image-content',
                template: "<div class=\"row\">\n  <div class=\"col-lg-6 col-xl-7 order-2\" [ngClass]=\"{'order-lg-1': imgLeft}\">\n    <ui-responsive-img [src]=\"img\" [alt]=\"img.alt\"></ui-responsive-img>\n  </div>\n  <div class=\"col-lg-5 col-xl-4 order-1\" [ngClass]=\"{'order-lg-2 ml-lg-auto': imgLeft, 'mr-lg-auto': !imgLeft}\">\n    <h3>{{ title | translate }}</h3>\n    <div [innerHtml]=\"description | translate\"></div>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
ImageContentComponent.ctorParameters = () => [];
ImageContentComponent.propDecorators = {
    img: [{ type: Input }],
    title: [{ type: Input }],
    description: [{ type: Input }],
    imgLeft: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ImageContentComponent.prototype.img;
    /** @type {?} */
    ImageContentComponent.prototype.title;
    /** @type {?} */
    ImageContentComponent.prototype.description;
    /** @type {?} */
    ImageContentComponent.prototype.imgLeft;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const Direction = {
    Up: 'Up',
    Down: 'Down',
};
class ScrollService {
    constructor() {
        this.scroll$ = fromEvent(window, 'scroll').pipe(map((/**
         * @return {?}
         */
        () => window.pageYOffset)), pairwise(), map((/**
         * @param {?} __0
         * @return {?}
         */
        ([y1, y2]) => (y2 < y1 ? Direction.Up : Direction.Down))), share());
        this.goingUp$ = this.scroll$.pipe(filter((/**
         * @param {?} direction
         * @return {?}
         */
        direction => direction === Direction.Up)));
        this.goingDown$ = this.scroll$.pipe(filter((/**
         * @param {?} direction
         * @return {?}
         */
        direction => direction === Direction.Down)));
    }
}
ScrollService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ScrollService.ctorParameters = () => [];
/** @nocollapse */ ScrollService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(); }, token: ScrollService, providedIn: "root" });
if (false) {
    /** @type {?} */
    ScrollService.prototype.scroll$;
    /** @type {?} */
    ScrollService.prototype.goingUp$;
    /** @type {?} */
    ScrollService.prototype.goingDown$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Element {
    /**
     * @param {?} selector
     * @return {?}
     */
    static getElementSize(selector) {
        /** @type {?} */
        const el = document.querySelector(selector);
        return el ? el.getBoundingClientRect().bottom : 0;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StickyNavbarComponent {
    /**
     * @param {?} scroll
     * @param {?} renderer
     */
    constructor(scroll, renderer) {
        this.scroll = scroll;
        this.renderer = renderer;
        this.YThreshold = 60;
        this.isVisible = true;
    }
    /**
     * @return {?}
     */
    get toggle() {
        return this.isVisible ? 'visible' : 'hidden';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.showInternal = false;
        this.isActive = false;
        this.isTop = true;
        this.scroll.goingUp$.subscribe((/**
         * @return {?}
         */
        () => {
            this.isVisible = true;
            this.isTop = window.pageYOffset < this.YThreshold;
        }));
        this.scroll.goingDown$.subscribe((/**
         * @return {?}
         */
        () => {
            this.isVisible = true;
            this.isTop = window.pageYOffset < this.YThreshold;
        }));
        this.scroll.scroll$.subscribe((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const pos = Element.getElementSize('ui-sticky-navbar');
            if (pos !== this.stickpos) {
                this.stickpos = pos;
                this.setSticky(pos);
            }
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @private
     * @param {?} pos
     * @return {?}
     */
    setSticky(pos) {
        /** @type {?} */
        const sticky = document.querySelectorAll(`.sticky-top`);
        if (sticky) {
            Array.from(sticky).forEach((/**
             * @param {?} element
             * @return {?}
             */
            (element) => {
                this.renderer.setStyle(element, 'top', `${this.stickpos}px`);
            }));
        }
    }
}
StickyNavbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-sticky-navbar',
                template: `<div [class.active]="!isTop"><ng-content></ng-content></div>`,
                animations: [
                    trigger('toggle', [
                        state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
                        state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => *', animate('200ms ease-in'))
                    ])
                ]
            }] }
];
/** @nocollapse */
StickyNavbarComponent.ctorParameters = () => [
    { type: ScrollService },
    { type: Renderer2 }
];
StickyNavbarComponent.propDecorators = {
    YThreshold: [{ type: Input }],
    toggle: [{ type: HostBinding, args: ['@toggle',] }]
};
if (false) {
    /** @type {?} */
    StickyNavbarComponent.prototype.YThreshold;
    /** @type {?} */
    StickyNavbarComponent.prototype.isFixed;
    /** @type {?} */
    StickyNavbarComponent.prototype.isActive;
    /** @type {?} */
    StickyNavbarComponent.prototype.showInternal;
    /** @type {?} */
    StickyNavbarComponent.prototype.section;
    /** @type {?} */
    StickyNavbarComponent.prototype.isTop;
    /** @type {?} */
    StickyNavbarComponent.prototype.stickpos;
    /**
     * @type {?}
     * @private
     */
    StickyNavbarComponent.prototype.isVisible;
    /**
     * @type {?}
     * @private
     */
    StickyNavbarComponent.prototype.scroll;
    /**
     * @type {?}
     * @private
     */
    StickyNavbarComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const StorageMethod = {
    Cookie: 'cookie',
    SessionStorage: 'session',
    LocalStorage: 'local',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StorageService {
    constructor() {
        this.defaultStorageMethod = StorageMethod.Cookie;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} storageMethod
     * @param {?=} expires
     * @return {?}
     */
    set(key, value, storageMethod = this.defaultStorageMethod, expires) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                this.setSessionStorage(key, value);
                break;
            case StorageMethod.LocalStorage:
                this.setLocalStorage(key, value);
                break;
            default:
                this.setCookie(key, value, expires);
        }
    }
    /**
     * @param {?} key
     * @param {?=} storageMethod
     * @return {?}
     */
    get(key, storageMethod = this.defaultStorageMethod) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                return this.getSessionStorage(key);
            case StorageMethod.LocalStorage:
                return this.getLocalStorage(key);
            default:
                return this.getCookie(key);
        }
    }
    /**
     * @param {?} key
     * @param {?=} storageMethod
     * @return {?}
     */
    check(key, storageMethod = this.defaultStorageMethod) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                return this.checkSessionStorage(key);
            case StorageMethod.LocalStorage:
                return this.checkLocalStorage(key);
            default:
                return this.checkCookie(key);
        }
    }
    /*
      * Cookie
      */
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} expires
     * @return {?}
     */
    setCookie(key, value, expires) {
        if (this.checkCookieEnabled()) {
            try {
                /** @type {?} */
                let cookieValue = `${key}=${value}`;
                if (expires) {
                    cookieValue += `;expires='${expires.toUTCString()}'`;
                }
                document.cookie = cookieValue;
                return true;
            }
            catch (e) {
                return false;
            }
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getCookie(key) {
        if (this.checkCookieEnabled()) {
            try {
                /** @type {?} */
                const decodedCookie = decodeURIComponent(document.cookie);
                /** @type {?} */
                const pairs = decodedCookie.split(/;\s*/);
                /** @type {?} */
                const prefix = `${key}=`;
                for (const pair of pairs) {
                    if (pair.indexOf(prefix) === 0) {
                        return pair.substring(prefix.length);
                    }
                }
            }
            catch (e) { }
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    checkCookie(key) {
        try {
            return this.checkCookieEnabled() && document.cookie.split(';').filter((/**
             * @param {?} item
             * @return {?}
             */
            (item) => item.trim().startsWith(key))).length > 0;
        }
        catch (e) {
            return false;
        }
    }
    /**
     * @return {?}
     */
    checkCookieEnabled() {
        if (navigator.cookieEnabled) {
            return true;
        }
        else {
            console.warn('Request to access cookies was blocked because of custom cookie permission.');
            return false;
        }
    }
    /*
      * SessionStorage
      */
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setSessionStorage(key, value) {
        if (sessionStorage) {
            sessionStorage.setItem(key, value);
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getSessionStorage(key) {
        if (sessionStorage) {
            try {
                return sessionStorage.getItem(key);
            }
            catch (e) { }
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    checkSessionStorage(key) {
        if (sessionStorage) {
            try {
                return sessionStorage.getItem(key) !== null;
            }
            catch (e) {
                return false;
            }
        }
    }
    /*
      * LocalStorage
      */
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    setLocalStorage(key, value) {
        if (localStorage) {
            try {
                localStorage.setItem(key, value);
                return true;
            }
            catch (e) {
                return false;
            }
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getLocalStorage(key) {
        if (localStorage) {
            return localStorage.getItem(key);
        }
    }
    /**
     * @param {?} key
     * @return {?}
     */
    checkLocalStorage(key) {
        if (localStorage) {
            return localStorage.getItem(key) !== null;
        }
    }
}
StorageService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
StorageService.ctorParameters = () => [];
/** @nocollapse */ StorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    StorageService.prototype.defaultStorageMethod;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieAdvisoryBannerComponent {
    /**
     * @param {?} service
     */
    constructor(service) {
        this.service = service;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.service.check('userCookieConsent', this.storageMethod)) {
            this.isVisible = true;
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.disclaimerRoute &&
            changes.disclaimerRoute.currentValue &&
            changes.disclaimerRoute.currentValue.indexOf('http') === 0) {
            this.isExternal = true;
        }
    }
    /**
     * @return {?}
     */
    closeBanner() {
        this.isVisible = false;
        this.service.set('userCookieConsent', 'true', this.storageMethod);
    }
}
CookieAdvisoryBannerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cookie-advisory-banner',
                template: "<div *ngIf=\"isVisible\">\n  <div>\n    <p>{{ 'ui.cookie.cookie_message' | translate }}\n      <span>\n        <a *ngIf=\"!isExternal; else external\" [routerLink]=\"[disclaimerRoute]\">{{ 'ui.cookie.learn_more' | translate }}</a>\n        <ng-template #external>\n          <a [href]=\"disclaimerRoute\" target=\"_blank\">{{ 'ui.cookie.learn_more' | translate }}</a>\n        </ng-template>\n      </span>.\n    </p>\n  </div>\n  <div>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"closeBanner()\">\n      {{ 'ui.cookie_banner.accept' | translate }}\n    </button>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
CookieAdvisoryBannerComponent.ctorParameters = () => [
    { type: StorageService }
];
CookieAdvisoryBannerComponent.propDecorators = {
    storageMethod: [{ type: Input }],
    disclaimerRoute: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CookieAdvisoryBannerComponent.prototype.isVisible;
    /** @type {?} */
    CookieAdvisoryBannerComponent.prototype.storageMethod;
    /** @type {?} */
    CookieAdvisoryBannerComponent.prototype.disclaimerRoute;
    /** @type {?} */
    CookieAdvisoryBannerComponent.prototype.isExternal;
    /**
     * @type {?}
     * @private
     */
    CookieAdvisoryBannerComponent.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieExplicitBannerComponent {
    /**
     * @param {?} consentService
     * @param {?} router
     */
    constructor(consentService, router) {
        this.consentService = consentService;
        this.router = router;
        this.storageMethod = StorageMethod.Cookie;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.router.events.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event instanceof NavigationEnd && this.consentService.get('userCookieConsent') !== 'true') {
                this.isVisible = true;
            }
        }));
        if (!this.consentService.check('userCookieConsent', this.storageMethod)) {
            this.consentService.set('userCookieConsent', 'false', this.storageMethod);
        }
        this.isVisible = this.consentService.get('userCookieConsent', this.storageMethod) !== 'true';
    }
    /**
     * @return {?}
     */
    accept() {
        this.isVisible = false;
        this.consentService.set('userCookieConsent', 'true', this.storageMethod);
    }
    /**
     * @return {?}
     */
    decline() {
        this.isVisible = false;
        this.consentService.set('userCookieConsent', 'false', this.storageMethod);
    }
}
CookieExplicitBannerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cookie-explicit-banner',
                template: "<div *ngIf=\"isVisible\">\n  <div>\n    <p>{{ 'ui.cookie.cookie_message' | translate }}\n      <span><a [routerLink]=\"[disclaimerRoute]\">{{ 'ui.cookie.learn_more' | translate }}</a></span>.\n    </p>\n  </div>\n  <div>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"accept()\">\n      {{ 'ui.cookie_banner.accept' | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"decline()\">\n      {{ 'ui.cookie_banner.decline' | translate }}\n    </button>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
CookieExplicitBannerComponent.ctorParameters = () => [
    { type: StorageService },
    { type: Router }
];
CookieExplicitBannerComponent.propDecorators = {
    storageMethod: [{ type: Input }],
    disclaimerRoute: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CookieExplicitBannerComponent.prototype.isVisible;
    /** @type {?} */
    CookieExplicitBannerComponent.prototype.storageMethod;
    /** @type {?} */
    CookieExplicitBannerComponent.prototype.disclaimerRoute;
    /**
     * @type {?}
     * @private
     */
    CookieExplicitBannerComponent.prototype.consentService;
    /**
     * @type {?}
     * @private
     */
    CookieExplicitBannerComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CookieStatementComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
CookieStatementComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cookie-statement',
                template: "<div class=\"container\">\n  <h1>{{ 'ui.cookie_statement.title' | translate }}</h1>\n  <p [innerHTML]=\"'ui.cookie_statement.statement' | translate\"></p>\n</div>"
            }] }
];
/** @nocollapse */
CookieStatementComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PopoverDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.showToggle = false;
    }
    /**
     * @return {?}
     */
    onClick() {
        this.showToggle = !this.showToggle;
        if (this.showToggle) {
            this.showPopover();
        }
        else {
            this.hidePopover();
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    onBlur(evt) {
        if (evt.relatedTarget && this.popover && this.popover.contains((/** @type {?} */ (evt.relatedTarget)))) {
            return;
        }
        if (this.showToggle) {
            this.showToggle = !this.showToggle;
            this.hidePopover();
        }
    }
    /**
     * @return {?}
     */
    showPopover() {
        if (!this.popper) {
            this.popper = new Popper(this.el.nativeElement, this.popover, {
                placement: this.placement ? this.placement : 'top'
            });
            this.renderer.removeClass(this.popover, 'fade');
            this.renderer.addClass(this.popover, 'show');
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const rect = this.popover.getBoundingClientRect();
                /** @type {?} */
                const arrow = this.popover.querySelector('.arrow');
                /** @type {?} */
                const rectArrow = arrow.getBoundingClientRect();
                if (!this.placement || this.placement === 'top' || this.placement === 'bottom') {
                    /** @type {?} */
                    const left = rect.width / 2 - rectArrow.width / 2;
                    this.renderer.setStyle(this.popover.querySelector('.arrow'), 'left', `${left}px`);
                }
                else {
                    /** @type {?} */
                    const top = rect.height / 2 - rectArrow.height / 2;
                    this.renderer.setStyle(this.popover.querySelector('.arrow'), 'top', `${top}px`);
                }
            }));
        }
        else {
            this.renderer.removeClass(this.popover, 'fade');
            this.renderer.addClass(this.popover, 'show');
        }
    }
    /**
     * @return {?}
     */
    hidePopover() {
        if (this.popper) {
            this.renderer.removeClass(this.popover, 'show');
            this.renderer.addClass(this.popover, 'fade');
        }
    }
    /**
     * @return {?}
     */
    destroyPopover() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = undefined;
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.description && !changes.description.isFirstChange && this.popover) {
            this.destroyPopover();
            this.createPopover();
        }
        if (changes.title && !changes.title.isFirstChange && this.popover) {
            this.destroyPopover();
            this.createPopover();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.createPopover();
    }
    /**
     * @return {?}
     */
    createPopover() {
        /** @type {?} */
        const container = this.container && ((/** @type {?} */ (this.container))).nativeElement ? ((/** @type {?} */ (this.container))).nativeElement : this.container;
        this.popover = this.renderer.createElement('div');
        this.popover.classList.add('if-popover-container', 'popover', 'fade', `bs-popover-${this.placement ? this.placement : 'top'}`);
        this.updateDescription();
        this.renderer.appendChild(container ? container : document.body, this.popover);
        if (!((/** @type {?} */ (this.el.nativeElement))).getAttribute('tabindex')) {
            this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '-1');
        }
        this.renderer.setAttribute(this.popover, 'tabindex', '-1');
        this.popover.addEventListener('focusout', (/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => { this.onBlur(evt); }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyPopover();
        /** @type {?} */
        const container = this.container && ((/** @type {?} */ (this.container))).nativeElement ? ((/** @type {?} */ (this.container))).nativeElement : this.container;
        this.renderer.removeChild(container ? container : document.body, this.popover);
    }
    /**
     * @return {?}
     */
    updateDescription() {
        /** @type {?} */
        const t = this.title ? `<div class="popover-header">${this.title}</div>` : '';
        /** @type {?} */
        const d = this.description ? `<div class="popover-body">${this.description}</div>` : '';
        this.popover.innerHTML = `<div class="arrow"></div>${t}${d}`;
    }
}
PopoverDirective.decorators = [
    { type: Directive, args: [{
                selector: '[uiPopover]'
            },] }
];
/** @nocollapse */
PopoverDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
PopoverDirective.propDecorators = {
    title: [{ type: Input, args: ['popoverTitle',] }],
    description: [{ type: Input, args: ['popoverDescription',] }],
    placement: [{ type: Input }],
    container: [{ type: Input, args: ['popoverContainer',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    PopoverDirective.prototype.title;
    /** @type {?} */
    PopoverDirective.prototype.description;
    /** @type {?} */
    PopoverDirective.prototype.placement;
    /** @type {?} */
    PopoverDirective.prototype.container;
    /** @type {?} */
    PopoverDirective.prototype.showToggle;
    /** @type {?} */
    PopoverDirective.prototype.popover;
    /** @type {?} */
    PopoverDirective.prototype.popper;
    /**
     * @type {?}
     * @private
     */
    PopoverDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    PopoverDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenericEditComponent {
    /**
     * @param {?} eleRef
     */
    constructor(eleRef) {
        this.state = 'active';
        this.showInline = false;
        this.invalidFieldSelector = 'ui-generic-edit .form-control.ng-invalid';
        this.saveClicked = new EventEmitter();
        this.deleteClicked = new EventEmitter();
        this.cancelClicked = new EventEmitter();
        this.genericAction = new EventEmitter();
        this.eleRef = eleRef;
    }
    /**
     * @return {?}
     */
    save() {
        this.saveClicked.emit(this.edit.page.actions.save);
    }
    /**
     * @return {?}
     */
    delete() {
        this.deleteClicked.emit(this.edit.page.actions.delete);
    }
    /**
     * @return {?}
     */
    cancel() {
        this.cancelClicked.emit(this.edit.page.actions.cancel);
    }
    /**
     * @param {?} action
     * @return {?}
     */
    action(action) {
        this.genericAction.emit(action);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        let header = this.eleRef.nativeElement.querySelector('header>h1');
        if (header) {
            header.focus();
        }
    }
}
GenericEditComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-generic-edit',
                template: "<article class=\"w-100\" *ngIf=\"edit\" aria-live=\"polite\" role=\"region\">\n  <div [ngClass]=\"{'card p-4': !showInline}\" [@cardAnimate]=\"state\">\n    <header class=\"d-flex flex-row align-items-start\" *ngIf=\"!showInline\">\n      <h1 tabindex=\"-1\">{{edit.header}}</h1>\n      <button type=\"button\" class=\"btn btn-outline-primary rounded-circle ml-auto\" (click)=\"cancel();\">\n        <i class=\"ifc-icon ifc-remove pt-1 font-weight-bold\"></i>\n      </button>\n    </header>\n    <div>\n      <ui-error-box [error]=\"edit.errors\" [invalidFieldSelector]=\"invalidFieldSelector\"></ui-error-box>\n      <ng-container *ngFor=\"let field of edit.page.content\">\n        <ui-select *ngIf=\"field.nodeType === 'select'\" [field]=\"field\" [form]=\"form\"></ui-select>\n        <div class=\"row\">\n          <div class=\"col-12 py-2\">\n            <h4 *ngIf=\"field.nodeType === 'span'\">{{field.text}}</h4>\n            <ui-input *ngIf=\"field.nodeType === 'input' && field.type === 'text'\" [field]=\"field\" [form]=\"form\">\n            </ui-input>\n            <ui-input-date *ngIf=\"field.nodeType === 'input' && field.type === 'date'\" [field]=\"field\" [form]=\"form\">\n            </ui-input-date>\n            <ui-checkbox-radio\n              *ngIf=\"field.nodeType === 'input' && (field.type === 'checkbox' || field.type === 'radio')\"\n              [field]=\"field\" [form]=\"form\" (change)=\"action(field)\"></ui-checkbox-radio>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n    <div class=\"mt-5\" *ngIf=\"edit.page.actions; let actions\">\n      <ui-button-group [primaryAction]=\"actions.save\" [secondaryAction]=\"actions.cancel\"\n        [tertiaryAction]=\"actions.delete\" (primaryClick)=\"save()\" (secondaryClick)=\"cancel()\"\n        (tertiaryClick)=\"delete()\"></ui-button-group>\n    </div>\n    <ui-hiddens [fields]=\"edit.hiddens\" [form]=\"form\"></ui-hiddens>\n  </div>\n</article>",
                animations: [
                    trigger('cardAnimate', [
                        state('void', style({
                            transform: 'scale(0)',
                            opacity: '0.6',
                        })),
                        state('*', style({
                            transform: 'scale(1.0)',
                            opacity: '1'
                        })),
                        transition('void => *', animate('400ms ease-out', keyframes([
                            style({ opacity: '0.6', transform: 'scale(0)', offset: 0 }),
                            style({ opacity: '0.95', transform: 'scale(0.88)', offset: 0.6 }),
                            style({ opacity: '1', transform: 'scale(1.05)', offset: 0.8 }),
                            style({ transform: 'scale(1.03)', offset: 0.92 }),
                            style({ transform: 'scale(1)', offset: 1.0 })
                        ]))),
                    ])
                ]
            }] }
];
/** @nocollapse */
GenericEditComponent.ctorParameters = () => [
    { type: ElementRef }
];
GenericEditComponent.propDecorators = {
    edit: [{ type: Input }],
    form: [{ type: Input }],
    showInline: [{ type: Input }],
    invalidFieldSelector: [{ type: Input }],
    saveClicked: [{ type: Output }],
    deleteClicked: [{ type: Output }],
    cancelClicked: [{ type: Output }],
    genericAction: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    GenericEditComponent.prototype.state;
    /** @type {?} */
    GenericEditComponent.prototype.edit;
    /** @type {?} */
    GenericEditComponent.prototype.form;
    /** @type {?} */
    GenericEditComponent.prototype.showInline;
    /** @type {?} */
    GenericEditComponent.prototype.invalidFieldSelector;
    /** @type {?} */
    GenericEditComponent.prototype.saveClicked;
    /** @type {?} */
    GenericEditComponent.prototype.deleteClicked;
    /** @type {?} */
    GenericEditComponent.prototype.cancelClicked;
    /** @type {?} */
    GenericEditComponent.prototype.genericAction;
    /** @type {?} */
    GenericEditComponent.prototype.eleRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FooterComponent {
    constructor() {
        this.year = (new Date()).getFullYear().toString();
        this.footerParams = {
            year: this.year,
            copyrightHolder: this.copyrightHolder
        };
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.footerParams = {
            year: changes.year ? changes.year.currentValue : this.year,
            copyrightHolder: changes.copyrightHolder ? changes.copyrightHolder.currentValue : this.copyrightHolder
        };
    }
}
FooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-footer',
                template: `<footer>
                    <header>
                        <div class="logo"></div>
                    </header>
                    <div aria-label="copyright" class="p-5">
                        <ng-container *ngIf="copyrightHolder; else noCompany">{{'ui.footer.copyright'| translate: footerParams}}</ng-container>
                        <ng-template #noCompany>{{'ui.copyright_no_company' | translate: footerParams}}</ng-template>
                    </div>
                </footer>`
            }] }
];
FooterComponent.propDecorators = {
    year: [{ type: Input }],
    copyrightHolder: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FooterComponent.prototype.year;
    /** @type {?} */
    FooterComponent.prototype.copyrightHolder;
    /** @type {?} */
    FooterComponent.prototype.footerParams;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        field.value = $event.currentTarget.value;
        if (field.options) {
            field.options.forEach((/**
             * @param {?} opt
             * @return {?}
             */
            (opt) => {
                opt.selected = field.value === opt.value;
            }));
        }
        $event.preventDefault();
        $event.stopPropagation();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.field) {
            this.setup();
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['field']) {
            super.updateOriginalValue();
        }
        if (changes['field'] && !changes['field'].firstChange) {
            this.setup();
        }
    }
    /**
     * @private
     * @return {?}
     */
    setup() {
        if (this.field.nodeType === 'select') {
            /** @type {?} */
            let isSelected = false;
            if (this.field.options && this.field.options.length) {
                this.field.options.forEach((/**
                 * @param {?} option
                 * @param {?} index
                 * @return {?}
                 */
                (option, index) => {
                    option.ifId = this.field.extraAttributes && this.field.extraAttributes.ifId ? this.field.extraAttributes.ifId + '-option-' + index : 'option-' + index;
                    if (option.selected) {
                        this.field.value = option.value;
                        isSelected = true;
                    }
                }));
                if (!isSelected) {
                    this.field.value = this.field.options[0].value;
                    this.field.options[0].selected = true;
                }
            }
        }
        if (this.field.value && this.field.value !== '-1' && this.field.value !== '-1000') {
            this.FormCtrl.setValue(this.field.value);
        }
        else {
            this.FormCtrl.setValue('');
        }
        this.checkForError();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
}
SelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-select',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <select ifPII *ngIf=\"field && field.nodeType === 'select'\" [attr.aria-invalid]=\"hasError\" [id]=\"field.id\" class=\"form-control\" [required]=\"field.required\"\n      [formControlName]=\"field.name\" (change)=\"changeOccurred($event, field)\" (blur)=\"checkForError()\"\n      [attr.data-if-id]=\"field.extraAttributes? field.extraAttributes.ifId: undefined\"\n       [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" [attr.aria-describedby]=\"field.id + '_error_req ' + field.id + '_error_custom ' + field.id + '_help'\">\n      <option *ngFor=\"let option of field.options\" [value]=\"option.value | translate\" [selected]=\"option.selected\" [attr.data-if-id]=\"option.ifId \">{{option.text | translate}}</option>\n    </select>\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
SelectComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SelectComponent.prototype.field;
    /** @type {?} */
    SelectComponent.prototype.change;
    /** @type {?} */
    SelectComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HiddensComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setupHiddens(this.fields);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.fields) {
            this.fields.forEach((/**
             * @param {?} field
             * @return {?}
             */
            (field) => {
                if (this.form.contains(field.name)) {
                    this.form.removeControl(field.name);
                }
            }));
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.fields) {
            if (changes.fields.previousValue && Array.isArray(changes.fields.previousValue)) {
                changes.fields.previousValue.forEach((/**
                 * @param {?} field
                 * @return {?}
                 */
                (field) => {
                    if (this.form.contains(field.name)) {
                        this.form.removeControl(field.name);
                    }
                }));
            }
            this.setupHiddens(changes.fields.currentValue);
        }
    }
    /**
     * @private
     * @param {?} fields
     * @return {?}
     */
    setupHiddens(fields) {
        if (fields) {
            fields.forEach((/**
             * @param {?} field
             * @return {?}
             */
            (field) => {
                if (!this.form.contains(field.name)) {
                    this.form.addControl(field.name, new FormControl());
                }
                /** @type {?} */
                const control = this.form.controls[field.name];
                if (field.required) {
                    control.setValidators(Validators.required);
                }
                control.setValue(field.value ? field.value : '');
                if (field.disabled) {
                    control.disable();
                }
            }));
        }
    }
}
HiddensComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-hiddens',
                template: "<div [formGroup]=\"form\">\n  <input ifPII type=\"hidden\" *ngFor=\"let field of fields\" [id]=\"field.id\" [formControlName]=\"field.name\" />\n</div>\n"
            }] }
];
/** @nocollapse */
HiddensComponent.ctorParameters = () => [];
HiddensComponent.propDecorators = {
    fields: [{ type: Input }],
    form: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    HiddensComponent.prototype.fields;
    /** @type {?} */
    HiddensComponent.prototype.form;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RadioComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.checked = $event.target.checked;
        if (field.checked) {
            // bugfix: Edge is not automatically updating the state of the form
            this.FormCtrl.setValue($event.target.value);
        }
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        if (this.field.checked) {
            this.FormCtrl.setValue(this.field.value);
        }
    }
}
RadioComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-radio',
                template: `
  <div class="custom-control custom-radio" *ngIf="field?.type === 'radio'" [formGroup]="form">
  <input
    class="custom-control-input"
    (change)="changeOccurred($event, field)"
    [formControlName]="field.name"
    [type]="field.type"
    [name]="field.name"
    [id]="field.id"
    [value]="field?.value"
    [checked]="field.checked"
    [attr.data-if-id]="field.extraAttributes?.ifId"
    ifPII />
  <label [for]="field.id" class="custom-control-label"
    [ngClass]="{error: hasError, required : field.required}" [innerHTML]="field.label | translate"></label>
  <div *ngIf="hasError" class="badge badge-danger">{{errorMessage}}</div>
</div>
  `
            }] }
];
RadioComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    RadioComponent.prototype.field;
    /** @type {?} */
    RadioComponent.prototype.change;
    /** @type {?} */
    RadioComponent.prototype.hasError;
    /** @type {?} */
    RadioComponent.prototype.errorMessage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckRadioComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    changeOccurred($event) {
        this.change.emit($event);
    }
}
CheckRadioComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-checkbox-radio',
                template: "<ng-container *ngIf=\"field?.type === 'checkbox'\">\n  <ui-checkbox [field]=\"field\" [form]=\"form\" (change)=\"changeOccurred($event)\" [validators]=\"validators\" [asyncValidators]=\"asyncValidators\"></ui-checkbox>\n</ng-container>\n\n<ng-container *ngIf=\"field?.type === 'radio'\">\n  <ui-radio [field]=\"field\" [form]=\"form\" (change)=\"changeOccurred($event)\" [validators]=\"validators\" [asyncValidators]=\"asyncValidators\"></ui-radio>\n</ng-container>"
            }] }
];
CheckRadioComponent.propDecorators = {
    form: [{ type: Input }],
    field: [{ type: Input }],
    validators: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CheckRadioComponent.prototype.form;
    /** @type {?} */
    CheckRadioComponent.prototype.field;
    /** @type {?} */
    CheckRadioComponent.prototype.validators;
    /** @type {?} */
    CheckRadioComponent.prototype.asyncValidators;
    /** @type {?} */
    CheckRadioComponent.prototype.change;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TextAreaComponent extends FieldComponent {
    constructor() {
        super();
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.syncFieldToForm();
        this.checkForError();
        if (this.field.disabled) {
            this.FormCtrl.disable();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        /** @type {?} */
        const val = this.field.html || this.field.value;
        if (val) {
            this.FormCtrl.setValue(val);
        }
        else {
            this.FormCtrl.setValue('');
        }
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        field.value = $event.currentTarget.value;
        field.html = field.value;
        this.syncFieldToForm();
        $event.preventDefault();
        $event.stopPropagation();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
}
TextAreaComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-textarea',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <textarea ifPII class=\"form-control\" [id]=\"field.id\" [formControlName]=\"field.name\" [name]=\"field.name\" (input)=\"changeOccurred($event, field)\" [required]=\"field.required\"\n      [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" (blur)=\"checkForError()\" [maxlength]=\"field.maxlength\" [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n      [attr.aria-describedby]=\"field.id + '_error_req ' + field.id + '_error_custom ' + field.id + '_help'\" [attr.aria-invalid]=\"hasError\">\n          </textarea>\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
/** @nocollapse */
TextAreaComponent.ctorParameters = () => [];
TextAreaComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    TextAreaComponent.prototype.field;
    /** @type {?} */
    TextAreaComponent.prototype.change;
    /** @type {?} */
    TextAreaComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectButtonsComponent extends FieldComponent {
    constructor() {
        super();
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
        if (this.form.contains(this.field.name)) {
            this.form.removeControl(this.field.name);
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let isSelected = false;
        this.field.options.forEach((/**
         * @param {?} option
         * @param {?} index
         * @return {?}
         */
        (option, index) => {
            option.ifId = this.field.extraAttributes && this.field.extraAttributes.ifId ? this.field.extraAttributes.ifId + '-option-' + index : 'option-' + index;
            if (option.selected) {
                this.field.value = option.value;
                isSelected = true;
            }
        }));
        if (!isSelected) {
            this.field.value = null;
        }
        this.FormCtrl.setValue(this.field.value);
        this.checkForError();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @param {?} $event
     * @param {?} res
     * @return {?}
     */
    updateResponseField($event, res) {
        this.FormCtrl.setValue(res);
        this.field.value = res;
        this.change.emit(this.field);
        $event.preventDefault();
    }
}
SelectButtonsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-select-buttons',
                template: "<div class=\"form-group\" *ngIf=\"field\" [formGroup]=\"form\">\n  <label *ngIf=\"field.label\" [for]=\"field.id\" [class.required]=\"field.required\">{{field.label}}</label>\n  <div>\n    <div class=\"btn-group btn-group-justified btn-group-yesno\" role=\"radio\">\n      <div class=\"btn-group\" *ngFor=\"let option of field.options\">\n        <button class=\"btn\" [attr.aria-checked]=\"option.value === field.value\" [attr.aria-describedby]=\"field.id+'-desc'\" (click)=\"updateResponseField($event, option.value)\"\n          [ngClass]=\"{'btn-outline-primary primary': option.primary, 'btn-outline-secondary secondary' : !option.primary, 'active' : option.value === field.value}\"\n          [attr.data-if-id]=\"option.ifId\" >\n          {{option.text}}</button>\n      </div>\n    </div>\n    <input type=\"hidden\" [id]=\"field.id\" [formControlName]=\"field.name\" (change)=\"changeOccurred($event, field)\" (blur)=\"checkForError()\">\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
SelectButtonsComponent.ctorParameters = () => [];
SelectButtonsComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SelectButtonsComponent.prototype.field;
    /** @type {?} */
    SelectButtonsComponent.prototype.change;
    /** @type {?} */
    SelectButtonsComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BreadcrumbsService {
    constructor() {
        this.breadCrumbSubject = new BehaviorSubject([]);
        this.crumbs = this.breadCrumbSubject.asObservable();
    }
    /**
     * @param {?} crumbs
     * @return {?}
     */
    set(crumbs) {
        this.breadCrumbSubject.next(crumbs);
    }
    /**
     * @return {?}
     */
    clear() {
        this.breadCrumbSubject.next(null);
    }
}
BreadcrumbsService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
BreadcrumbsService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    BreadcrumbsService.prototype.crumbs;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbsService.prototype.breadCrumbSubject;
}
class BreadcrumbItem {
    constructor() {
        this.isActive = false;
        this.queryParamsHandling = null;
    }
}
if (false) {
    /** @type {?} */
    BreadcrumbItem.prototype.icon;
    /** @type {?} */
    BreadcrumbItem.prototype.text;
    /** @type {?} */
    BreadcrumbItem.prototype.screenReaderOnlyText;
    /** @type {?} */
    BreadcrumbItem.prototype.route;
    /** @type {?} */
    BreadcrumbItem.prototype.isActive;
    /** @type {?} */
    BreadcrumbItem.prototype.queryParamsHandling;
    /** @type {?} */
    BreadcrumbItem.prototype.queryParams;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BreadcrumbsComponent {
    /**
     * @param {?} breadcrumbsService
     */
    constructor(breadcrumbsService) {
        this.breadcrumbsService = breadcrumbsService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.breadcrumbSubscription = this.breadcrumbsService.crumbs.subscribe((/**
         * @param {?} crumbs
         * @return {?}
         */
        crumbs => {
            this.breadcrumbs = crumbs;
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.breadcrumbSubscription) {
            this.breadcrumbSubscription.unsubscribe();
        }
    }
}
BreadcrumbsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-breadcrumbs',
                template: "<ng-container *ngIf=\"breadcrumbs?.length\">\n  <nav>\n    <div class=\"breadcrumb container py-2 mb-0\" *ngIf=\"breadcrumbs\">\n      <div *ngFor=\"let crumb of breadcrumbs\" class=\"breadcrumb-item\" [class.active]=\"crumb.isActive\">\n        <a *ngIf=\"!crumb.isActive\" [routerLink]=\"crumb.route\" [queryParamsHandling]=\"crumb.queryParamsHandling\" [queryParams]=\"crumb.queryParams\"><i *ngIf=\"crumb?.icon\" aria-hidden=\"true\" class=\"{{crumb.icon}}\" ></i>{{crumb.text | translate}} <span *ngIf=\"crumb?.screenReaderOnlyText\" class=\"sr-only\">{{crumb.screenReaderOnlyText | translate}}</span></a>\n        <span *ngIf=\"crumb.isActive\"><i class=\"{{crumb.icon}}\"></i>{{crumb.text | translate}}<span *ngIf=\"crumb?.screenReaderOnlyText\" class=\"sr-only\">{{crumb.screenReaderOnlyText | translate}}</span></span>\n      </div>\n    </div>\n  </nav>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
BreadcrumbsComponent.ctorParameters = () => [
    { type: BreadcrumbsService }
];
if (false) {
    /** @type {?} */
    BreadcrumbsComponent.prototype.breadcrumbs;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbsComponent.prototype.breadcrumbSubscription;
    /**
     * @type {?}
     * @private
     */
    BreadcrumbsComponent.prototype.breadcrumbsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ButtonDirective {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.field) {
            if (!this.field.type) {
                this.field.type = 'button';
            }
            /** @type {?} */
            const btn = this.el.nativeElement;
            if (btn) {
                /** @type {?} */
                const changes = new Map();
                ButtonDirective.Properties.forEach((/**
                 * @param {?} k
                 * @return {?}
                 */
                k => {
                    if (this.field[k] !== btn[k] && (this.field[k] || btn[k])) {
                        changes.set(k, this.field[k]);
                    }
                }));
                if (changes.size) {
                    changes.forEach((/**
                     * @param {?} value
                     * @param {?} key
                     * @return {?}
                     */
                    (value, key) => {
                        this.renderer.setProperty(btn, key, value);
                    }));
                }
            }
        }
    }
}
ButtonDirective.Properties = ['id', 'name', 'required', 'disabled', 'type'];
ButtonDirective.decorators = [
    { type: Directive, args: [{ selector: '[base-button]' },] }
];
/** @nocollapse */
ButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ButtonDirective.propDecorators = {
    field: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ButtonDirective.Properties;
    /** @type {?} */
    ButtonDirective.prototype.field;
    /**
     * @type {?}
     * @private
     */
    ButtonDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ButtonDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputDirective {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.field) {
            if (!this.field.type) {
                this.field.type = 'text';
            }
            /** @type {?} */
            const input = this.el.nativeElement;
            if (input) {
                /** @type {?} */
                const propertyChanges = new Map();
                /** @type {?} */
                const attributeChanges = new Map();
                InputDirective.Properties.forEach((/**
                 * @param {?} k
                 * @return {?}
                 */
                k => {
                    if (this.field[k] !== input[k] && (this.field[k] || input[k])) {
                        propertyChanges.set(k, this.field[k]);
                    }
                }));
                InputDirective.Attributes.forEach((/**
                 * @param {?} k
                 * @return {?}
                 */
                k => {
                    // type equality on purpose so maxlength of 255 equals "255"
                    // tslint:disable-next-line: triple-equals
                    if (this.field[k] != input.getAttribute(k) && (this.field[k] || input.getAttribute(k))) {
                        attributeChanges.set(k, this.field[k]);
                    }
                }));
                if (propertyChanges.size) {
                    propertyChanges.forEach((/**
                     * @param {?} value
                     * @param {?} key
                     * @return {?}
                     */
                    (value, key) => {
                        if (value === false || value === 'false') {
                            this.renderer.setProperty(input, key, null);
                        }
                        else {
                            this.renderer.setProperty(input, key, value || value === 0 ? value.toString() : '');
                        }
                    }));
                }
                if (attributeChanges.size) {
                    attributeChanges.forEach((/**
                     * @param {?} value
                     * @param {?} key
                     * @return {?}
                     */
                    (value, key) => {
                        if (value === false || value === 'false') {
                            this.renderer.removeAttribute(input, key);
                        }
                        else {
                            this.renderer.setAttribute(input, key, value || value === 0 ? (/** @type {?} */ (value)) : '');
                        }
                    }));
                }
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        /** @type {?} */
        const input = this.el.nativeElement;
        this.renderer.setProperty(input, 'value', this.field.value);
    }
}
InputDirective.Attributes = ['id', 'name', 'type', 'maxlength', 'minlength',
    'autocomplete', 'autocapitalize', 'autocorrect'];
InputDirective.Properties = ['disabled', 'required', 'checked'];
InputDirective.decorators = [
    { type: Directive, args: [{ selector: '[base-input]' },] }
];
/** @nocollapse */
InputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
InputDirective.propDecorators = {
    field: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InputDirective.Attributes;
    /** @type {?} */
    InputDirective.Properties;
    /** @type {?} */
    InputDirective.prototype.field;
    /**
     * @type {?}
     * @private
     */
    InputDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    InputDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ColumnHeaderComponent extends FieldComponent {
    constructor() {
        super();
        this.action = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.action.complete();
    }
    /**
     * @param {?} field
     * @return {?}
     */
    onClick(field) {
        this.action.emit(field);
    }
    /**
     * @return {?}
     */
    checkForError() { }
}
ColumnHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-col-header',
                template: "<ng-container *ngIf=\"field\">\n  <span *ngIf=\"field.concat\">\n    {{field}}\n  </span>\n  <a *ngIf=\"field.nodeType === 'a'\" href=\"javascript:void(0)\" (click)=\"onClick(field)\">\n    {{field.text}}\n  </a>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
ColumnHeaderComponent.ctorParameters = () => [];
ColumnHeaderComponent.propDecorators = {
    field: [{ type: Input }],
    action: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ColumnHeaderComponent.prototype.field;
    /** @type {?} */
    ColumnHeaderComponent.prototype.action;
    /** @type {?} */
    ColumnHeaderComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormControlComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this.input = undefined;
        this.select = undefined;
        this.labelValue = undefined;
        /** @type {?} */
        const inputField = ((/** @type {?} */ (this.field)));
        if (!inputField.nodeType) {
            this.labelValue = (/** @type {?} */ (this.field));
            return;
        }
        if (inputField.nodeType === 'input') {
            this.input = (/** @type {?} */ (this.field));
        }
        if (inputField.nodeType === 'select') {
            this.select = (/** @type {?} */ (this.field));
        }
        if (inputField.nodeType === 'textarea') {
            this.textarea = (/** @type {?} */ (this.field));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} field
     * @return {?}
     */
    changeOccurred(field) {
        this.change.emit(field);
    }
}
FormControlComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-form-control',
                template: "<ng-container *ngIf=\"field\">\n  <span *ngIf=\"labelValue\">\n    <div class=\"form-field\">\n      <div class=\"label\">{{labelValue.label}}</div>\n      <div>{{labelValue.value}}</div>\n    </div>\n  </span>\n  <ng-container *ngIf=\"input && (input.type === 'text' || input.type === 'date')\">\n    <ui-input *ngIf=\"!input.dateFormat\" [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\">\n    </ui-input>\n    <ui-input-date *ngIf=\"input.dateFormat\" [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\"></ui-input-date>\n  </ng-container>\n  <ui-checkbox-radio *ngIf=\"input?.nodeType === 'input' && (input.type === 'checkbox' || input.type === 'radio')\"\n    [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\"></ui-checkbox-radio>\n  <ui-select *ngIf=\"select\" [field]=\"select\" [form]=\"form\">\n  </ui-select>\n  <ui-textarea *ngIf=\"textarea\" [field]=\"textarea\" [form]=\"form\"></ui-textarea>\n</ng-container>"
            }] }
];
/** @nocollapse */
FormControlComponent.ctorParameters = () => [];
FormControlComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    FormControlComponent.prototype.field;
    /** @type {?} */
    FormControlComponent.prototype.form;
    /** @type {?} */
    FormControlComponent.prototype.change;
    /** @type {?} */
    FormControlComponent.prototype.input;
    /** @type {?} */
    FormControlComponent.prototype.select;
    /** @type {?} */
    FormControlComponent.prototype.labelValue;
    /** @type {?} */
    FormControlComponent.prototype.textarea;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErrorBoxComponent {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this.invalidFieldSelector = 'app-root form .form-control.ng-invalid';
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.showError = changes.error && changes.error.currentValue && ((changes.error.currentValue.message && changes.error.currentValue.message.trim()) ||
            (changes.error.currentValue.title && changes.error.currentValue.title.trim()));
        if (this.showError) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const nodes = document.querySelectorAll(this.invalidFieldSelector);
                if (nodes) {
                    this.firstInvalidField = (/** @type {?} */ (nodes.item(0)));
                }
                this.el.nativeElement.querySelector('[id="errorBody"]').focus();
            }));
        }
    }
    /**
     * @return {?}
     */
    focusFirstInvalid() {
        if (this.firstInvalidField) {
            this.firstInvalidField.focus();
        }
    }
}
ErrorBoxComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-error-box',
                template: `<div role="region">
                <div class="row" *ngIf="showError">
                  <div class="col-lg-12">
                    <div class="alert alert-danger">
                      <div id="errorBody" aria-atomic="true" tabindex="-1">
                        <div class="h5" *ngIf="error?.title">
                          <i class="fa fa-lg fa-warning"></i>
                          <span [innerHtml]="error.title | translate"></span>
                        </div>
                        <p *ngIf="error?.message" [innerHtml]="error.message | translate"></p>
                      </div>
                      <div *ngIf="firstInvalidField" class="pt-3">
                      <a href="javascript:void(0);" (click)="focusFirstInvalid()">
                        {{'ui.error-box.go_to_label' | translate}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>`
            }] }
];
/** @nocollapse */
ErrorBoxComponent.ctorParameters = () => [
    { type: ElementRef }
];
ErrorBoxComponent.propDecorators = {
    error: [{ type: Input }],
    invalidFieldSelector: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ErrorBoxComponent.prototype.error;
    /** @type {?} */
    ErrorBoxComponent.prototype.invalidFieldSelector;
    /** @type {?} */
    ErrorBoxComponent.prototype.showError;
    /** @type {?} */
    ErrorBoxComponent.prototype.firstInvalidField;
    /**
     * @type {?}
     * @private
     */
    ErrorBoxComponent.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SROnlyLabelDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const field = this.el.nativeElement;
        /** @type {?} */
        const labels = field.querySelectorAll('label, .label');
        for (let i = 0; i < labels.length; i++) {
            labels[i].classList.add('sr-only');
        }
    }
}
SROnlyLabelDirective.decorators = [
    { type: Directive, args: [{ selector: '[sr-only-label]' },] }
];
/** @nocollapse */
SROnlyLabelDirective.ctorParameters = () => [
    { type: ElementRef }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SROnlyLabelDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormFieldComponent {
    constructor() { }
}
FormFieldComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-form-field',
                template: "<div class=\"form-group\" [formGroup]=\"form\">\n  <div class=\"form-group-inner\" *ngIf=\"field\">\n    <label class=\"form-control-label\" *ngIf=\"field.label\" [for]=\"field.id\" [class.required]=\"field.required\"\n      [innerHTML]=\"field.label | translate\"></label>\n    <ng-container [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{'field': field}\"></ng-container>\n  </div>\n  <div>\n      <span role=\"region\" aria-live=\"assertive\" class=\"d-block small form-control-feedback text-danger\">\n        <span *ngIf=\"hasError && !formCtrl?.errors?.customErrorMsg && field.required && !formCtrl.value\"\n          [id]=\"field.id + '_error_req'\"  aria-live=\"assertive\"  [innerHTML]=\"'ui.form_field.required_text' | translate\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.customErrorMsg\"  aria-live=\"assertive\"  [id]=\"field.id + '_error_custom'\" [innerHTML]=\"form.controls[this.field.name].errors.customErrorMsg | translate\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.minlength\"\n          [id]=\"field.id + '_error_minlength'\"  aria-live=\"assertive\"  [innerHTML]=\"'ui.form_field.min_length_required_text'| translate:{length: formCtrl?.errors?.minlength?.requiredLength}\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.email\"\n          [id]=\"field.id + '_error_email'\"  aria-live=\"assertive\"  [innerHTML]=\"'ui.form_field.invalid_email_text'| translate\"></span>\n      </span>\n      <span class=\"d-block small\" *ngIf=\"field.helperText\" class=\"form-text text-muted\" [id]=\"field.id + '_help'\"\n        [innerHTML]=\"field.helperText | translate\">\n      </span>\n    </div>\n</div>\n"
            }] }
];
/** @nocollapse */
FormFieldComponent.ctorParameters = () => [];
FormFieldComponent.propDecorators = {
    template: [{ type: ContentChild, args: [TemplateRef, { static: false },] }],
    field: [{ type: Input }],
    formCtrl: [{ type: Input }],
    form: [{ type: Input }],
    hasError: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FormFieldComponent.prototype.template;
    /** @type {?} */
    FormFieldComponent.prototype.field;
    /** @type {?} */
    FormFieldComponent.prototype.formCtrl;
    /** @type {?} */
    FormFieldComponent.prototype.form;
    /** @type {?} */
    FormFieldComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputDateComponent extends FieldComponent {
    /**
     * @param {?} elRef
     * @param {?} zone
     * @param {?} translate
     * @param {?} cd
     */
    constructor(elRef, zone, translate, cd) {
        super();
        this.elRef = elRef;
        this.zone = zone;
        this.translate = translate;
        this.cd = cd;
        this.validationDelay = 300;
        this.change = new EventEmitter();
        this.dateFormat = 'yyyy-MM-dd';
        this.oldvalue = '';
        this.minDate = new Date(1950, 0, 1);
        this.maxDate = addYears((new Date()).setHours(23, 59, 59), 10);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.field) {
            super.updateOriginalValue();
        }
        if (changes.field && changes.field.currentValue && !changes.field.isFirstChange()) {
            this.FormCtrl.setValue(changes.field.currentValue.value);
            this.changeAvailableRange(changes.field.currentValue.min, changes.field.currentValue.max);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            $(node).datepicker('destroy');
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.field) {
            this.defaultAriaDescribedByList = `${this.field.id}_error_req ${this.field.id}_error_custom ${this.field.id}_desc ${this.field.id}_help`;
            this.ariaDescribedByList = this.defaultAriaDescribedByList;
            this.setDateFormat();
            if (!this.field.placeholder) {
                this.field.placeholder = this.dateFormat.toUpperCase();
            }
            /** @type {?} */
            const formatExample = this.dateFormat
                .replace('MM', '01')
                .replace('dd', '31')
                .replace('yyyy', '2018');
            this.translate.get([
                'ui.input-date.expected_format_example',
                'ui.input-date.invalid_format_error',
                'ui.input-date.invalid_range_error'
            ], {
                example: formatExample,
                format: this.dateFormat
            }).pipe(take(1)).subscribe((/**
             * @param {?} text
             * @return {?}
             */
            text => {
                this.dateFormatDesc = text['ui.input-date.expected_format_example'];
                this.invalidFormatError = text['ui.input-date.invalid_format_error'];
                this.invalidRangeError = text['ui.input-date.invalid_range_error'];
            }));
            this.setMinMaxDate(this.field);
            /** @type {?} */
            const inputValidators = [];
            inputValidators.push(this.dateFormatValidator());
            if (this.asyncValidators) {
                if (Array.isArray(this.asyncValidators)) {
                    inputValidators.push(...this.asyncValidators);
                }
                else {
                    inputValidators.push(this.asyncValidators);
                }
            }
            this.asyncValidators = inputValidators;
            super.ngOnInit();
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            this.zone.runOutsideAngular((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const datepickerSettings = {
                    autoclose: false,
                    endDate: format(this.maxDate, this.dateFormat),
                    // bootstrap date picker expects the format to be lower case where month we expect to be upper in date-fns https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
                    format: this.dateFormat.toLowerCase(),
                    maxViewMode: this.config ? this.config.maxView : this.maxView,
                    minViewMode: this.config ? this.config.minView : this.minView,
                    startDate: this.config && this.config.startView ? this.config.startDate : format(this.minDate, this.dateFormat),
                    showOnFocus: false,
                    container: this.config && this.config.container ? this.config.container : 'body'
                };
                $(node)
                    .datepicker(datepickerSettings)
                    .on('show', (/**
                 * @return {?}
                 */
                () => {
                    this.timeSinceClose = null;
                    this.datepickerShowing = true;
                }))
                    .on('hide', (/**
                 * @param {?} evt
                 * @return {?}
                 */
                (evt) => {
                    this.datepickerShowing = false;
                    this.timeSinceClose = Date.now();
                }))
                    .on('changeDate', (/**
                 * @return {?}
                 */
                () => {
                    this.dateChanged();
                    if (this.datepickerShowing) {
                        this.toggle();
                    }
                }));
            }));
        }
    }
    /**
     * @param {?} startDate
     * @param {?} endDate
     * @return {?}
     */
    changeAvailableRange(startDate, endDate) {
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (!node) {
            return;
        }
        $(node).datepicker('setStartDate', startDate)
            .datepicker('setEndDate', endDate);
    }
    /**
     * @return {?}
     */
    dateFormatValidator() {
        return (/**
         * @param {?} control
         * @return {?}
         */
        (control) => {
            this.ariaDescribedByList = ''; // prevent JAWS+IE11 from reading outdated aria-describedby during validation
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const value = control.value;
                if (!value) {
                    return null;
                }
                return this.validateDate(value, this.dateFormat, this.minDate, this.maxDate);
            })));
        });
    }
    /**
     * @param {?} value
     * @param {?} formatString
     * @param {?} minRange
     * @param {?} maxRange
     * @return {?}
     */
    validateDate(value, formatString, minRange, maxRange) {
        /** @type {?} */
        const minDate = new Date(1867, 6, 1);
        /** @type {?} */
        const date = parse(value, formatString, minDate);
        if (!isValid(date) || compareAsc(date, minDate) < 1) {
            return {
                inValidDate: value,
                customErrorMsg: this.invalidFormatError
            };
        }
        if (!(compareAsc(date, minRange) >= 0 && compareAsc(date, maxRange) <= 0)) {
            return {
                inValidDate: value,
                customErrorMsg: this.invalidRangeError
                    .replace('{{date}}', format(date, formatString))
                    .replace('{{start}}', format(minRange, formatString))
                    .replace('{{end}}', format(maxRange, formatString))
            };
        }
        return null;
    }
    /**
     * @return {?}
     */
    toggle() {
        if (this.timeSinceClose && Date.now() - this.timeSinceClose < 250) {
            return;
        }
        /** @type {?} */
        const node = this.getDatePickerElement();
        if (node) {
            if (this.datepickerShowing) {
                $(node).datepicker('hide');
            }
            else {
                $(node).datepicker('show')
                    .focus();
            }
            this.timeSinceClose = null;
        }
    }
    /**
     * @return {?}
     */
    dateChanged() {
        /** @type {?} */
        const dp = this.getDatePickerElement();
        if (dp && this.field && dp.value !== this.field.value) {
            this.field.value = dp.value;
            this.FormCtrl.setValue(this.field.value);
            this.checkForError();
            this.hasError = false;
            this.cd.detectChanges();
            this.change.emit(this.field);
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.ariaDescribedByList = this.defaultAriaDescribedByList;
            }));
        }
    }
    /**
     * @private
     * @return {?}
     */
    getDatePickerElement() {
        if (this.datepickerChild) {
            return this.datepickerChild.nativeElement;
        }
    }
    /**
     * @private
     * @param {?} field
     * @return {?}
     */
    setMinMaxDate(field) {
        if (field.min) {
            if (field.min === 'today') {
                /** @type {?} */
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = this.tryGetDate(field.min);
            }
        }
        else if (this.config && this.config.minDate) {
            if (this.config.minDate === 'today') {
                /** @type {?} */
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = this.tryGetDate(this.config.minDate);
            }
        }
        if (field.max) {
            if (field.max === 'today') {
                this.maxDate = new Date();
            }
            else {
                this.maxDate = this.tryGetDate(field.max);
            }
        }
        else if (this.config && this.config.maxDate) {
            if (this.config.maxDate === 'today') {
                this.maxDate = new Date();
            }
            else {
                this.maxDate = this.tryGetDate(this.config.maxDate);
            }
        }
    }
    /**
     * @private
     * @param {?} possibleDate
     * @return {?}
     */
    tryGetDate(possibleDate) {
        if (typeof (possibleDate) === 'string') {
            return parse(possibleDate, this.dateFormat, new Date());
        }
        else if (typeof (possibleDate) === 'number') {
            return new Date(possibleDate);
        }
        else {
            return possibleDate;
        }
    }
    /**
     * @private
     * @return {?}
     */
    setDateFormat() {
        if (this.field && this.field.dateFormat) {
            this.dateFormat = this.field.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('YY', 'yy').replace('D', 'd');
        }
        else if (this.config && this.config.dateFormat) {
            this.dateFormat = this.config.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('YY', 'yy').replace('D', 'd');
        }
    }
}
InputDateComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-date',
                template: "<ui-form-field [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n  [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"input-group input-date\">\n      <span class=\"sr-only\" [id]=\"field.id + '_desc'\" [innerText]=\"dateFormatDesc\"></span>\n      <input ifPII #datepicker type=\"text\" class=\"form-control\" [attr.aria-invalid]=\"hasError\"\n        [attr.aria-describedby]=\"ariaDescribedByList ? ariaDescribedByList : ''\" (change)=\"dateChanged()\"\n        (blur)=\"checkForError()\" [formControlName]=\"field.name\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n        [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.name]=\"field.name\" [attr.id]=\"field.id\"\n        [required]=\"field.required && field.required !== 'false'\" [attr.disabled]=\"field.disabled? '': null\"\n        [attr.placeholder]=\"field.placeholder ? field.placeholder: ''\">\n      <button type=\"button\" tabindex=\"-1\" aria-hidden=\"true\" class=\"btn btn-primary input-group-addon\"\n        (click)=\"!field.disabled && toggle();\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n        <i class=\"ifc-icon ifc-calendar-grid\"></i>\n      </button>\n    </div>\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
/** @nocollapse */
InputDateComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: TranslateService },
    { type: ChangeDetectorRef }
];
InputDateComponent.propDecorators = {
    datepickerChild: [{ type: ViewChild, args: ['datepicker', { static: false },] }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validationDelay: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputDateComponent.prototype.datepickerChild;
    /** @type {?} */
    InputDateComponent.prototype.field;
    /** @type {?} */
    InputDateComponent.prototype.form;
    /** @type {?} */
    InputDateComponent.prototype.config;
    /** @type {?} */
    InputDateComponent.prototype.validationDelay;
    /** @type {?} */
    InputDateComponent.prototype.asyncValidators;
    /** @type {?} */
    InputDateComponent.prototype.change;
    /** @type {?} */
    InputDateComponent.prototype.hasError;
    /** @type {?} */
    InputDateComponent.prototype.defaultAriaDescribedByList;
    /** @type {?} */
    InputDateComponent.prototype.ariaDescribedByList;
    /** @type {?} */
    InputDateComponent.prototype.validators;
    /** @type {?} */
    InputDateComponent.prototype.datePicker;
    /** @type {?} */
    InputDateComponent.prototype.dateFormat;
    /** @type {?} */
    InputDateComponent.prototype.dateFormatDesc;
    /** @type {?} */
    InputDateComponent.prototype.invalidFormatError;
    /** @type {?} */
    InputDateComponent.prototype.invalidRangeError;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.minDate;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.maxDate;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.oldvalue;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.datepickerShowing;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.timeSinceClose;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.minView;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.maxView;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.zone;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidationCheckerComponent {
    /**
     * @param {?} changesRef
     */
    constructor(changesRef) {
        this.changesRef = changesRef;
        this.focusedNode = new EventEmitter();
        this.standardCountFilter = "app-root form .form-control.ng-invalid";
    }
    /**
     * @param {?} countFilter
     * @return {?}
     */
    static getCountOfInvalid(countFilter) {
        /** @type {?} */
        const nodes = document.querySelectorAll(countFilter);
        if (!nodes) {
            return 0;
        }
        else {
            return nodes.length;
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.formSubscription = this.form.statusChanges.subscribe((/**
         * @param {?} status
         * @return {?}
         */
        status => this.validateStatus(status)));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.validateStatus(this.form.status);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.formSubscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    focusFirstInvalid() {
        /** @type {?} */
        const nodes = document.querySelectorAll(this.countFilter ? this.countFilter : this.standardCountFilter);
        /** @type {?} */
        let node;
        if (this.restrictFocus) {
            for (let i = 0; i < nodes.length; i++) {
                /** @type {?} */
                const n = nodes[i];
                if (n.tagName === "input" &&
                    n["type"] &&
                    n["type"].toLowerCase() !== "hidden") {
                    node = n;
                    break;
                }
                else if (n.tagName === "select" || n.tagName === "textarea") {
                    node = n;
                    break;
                }
                else {
                    /** @type {?} */
                    const tmpNode = n.querySelector(`input:not([type=hidden])[required], select[required], textarea[required]`);
                    if (tmpNode) {
                        node = tmpNode;
                        break;
                    }
                }
            }
        }
        else {
            node = nodes[0];
        }
        if (node) {
            this.focusedNode.emit(node);
            node["focus"]();
            /** @type {?} */
            const header = document.querySelector("header");
            /** @type {?} */
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            /** @type {?} */
            const ypos = node.getBoundingClientRect().top +
                window.pageYOffset -
                (headerHeight + 35);
            window.scrollTo(0, ypos);
        }
    }
    /**
     * @private
     * @param {?} status
     * @return {?}
     */
    validateStatus(status) {
        if (status === "VALID") {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.showChecker = false;
                this.changesRef.markForCheck();
            }));
        }
        else if (status === "INVALID") {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.showChecker = true;
                /** @type {?} */
                const nodes = document.querySelectorAll(this.countFilter ? this.countFilter : this.standardCountFilter);
                this.setErrorStatus(nodes);
                if (nodes) {
                    this.countOfInvalid = nodes.length;
                }
                if (!nodes || nodes.length === 0) {
                    this.showChecker = false;
                }
                this.changesRef.markForCheck();
            }), 0);
        }
    }
    /**
     * @private
     * @param {?} nodes
     * @return {?}
     */
    setErrorStatus(nodes) {
        if (nodes) {
            for (let i = 0; nodes && i < nodes.length; i++) {
                if (((/** @type {?} */ (nodes[i]))).value) {
                    this.errorType = "invalid";
                    return;
                }
            }
        }
        this.errorType = "required";
    }
}
ValidationCheckerComponent.decorators = [
    { type: Component, args: [{
                selector: "ui-validation-checker",
                template: `
  <div *ngIf="showChecker" class="alert alert-info bg-white">
    {{'ui.validation.invalid_field_text' | translate}}
    <a href="javascript:void(0);" (click)="focusFirstInvalid()">
    {{'ui.validation.go_to_label' | translate}}
    </a>
  </div>
  `
            }] }
];
/** @nocollapse */
ValidationCheckerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ValidationCheckerComponent.propDecorators = {
    form: [{ type: Input }],
    countFilter: [{ type: Input }],
    restrictFocus: [{ type: Input }],
    focusedNode: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ValidationCheckerComponent.prototype.errorType;
    /** @type {?} */
    ValidationCheckerComponent.prototype.countOfInvalid;
    /** @type {?} */
    ValidationCheckerComponent.prototype.showChecker;
    /** @type {?} */
    ValidationCheckerComponent.prototype.form;
    /** @type {?} */
    ValidationCheckerComponent.prototype.countFilter;
    /** @type {?} */
    ValidationCheckerComponent.prototype.restrictFocus;
    /** @type {?} */
    ValidationCheckerComponent.prototype.focusedNode;
    /**
     * @type {?}
     * @private
     */
    ValidationCheckerComponent.prototype.formSubscription;
    /**
     * @type {?}
     * @private
     */
    ValidationCheckerComponent.prototype.standardCountFilter;
    /**
     * @type {?}
     * @private
     */
    ValidationCheckerComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HooksService {
    /**
     * @return {?}
     */
    get onChange() {
        return FieldComponent.onChangePreProcessorObservable;
    }
}
HooksService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckboxComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.checked = $event.target.checked;
        this.syncFieldToForm();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        /** @type {?} */
        const field = this.field;
        if (!field.checked && field.type === 'checkbox') {
            this.FormCtrl.setValue(null);
        }
        else if (field.checked) {
            /** @type {?} */
            const onVal = field.onValue || field.value || 'on';
            this.FormCtrl.setValue(onVal);
        }
    }
}
CheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-checkbox',
                template: `
  <div class="custom-control custom-checkbox" *ngIf="field?.type === 'checkbox'" [formGroup]="form">
    <input
      class="custom-control-input"
      (change)="changeOccurred($event, field)"
      [formControlName]="field.name"
      [name]="field.name"
      [id]="field.id"
      [type]="field.type"
      [checked]="field.checked"
      [attr.data-if-id]="field.extraAttributes?.ifId"
      ifPII />
    <label [for]="field.id" class="custom-control-label" [ngClass]="{error: hasError, required: field.required}"
      [innerHTML]="field.label | translate:{'srText': srText}">
    </label>
    <div *ngIf="hasError" class="badge badge-danger">{{errorMessage}}</div>
  </div>`
            }] }
];
CheckboxComponent.propDecorators = {
    field: [{ type: Input }],
    srText: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CheckboxComponent.prototype.field;
    /** @type {?} */
    CheckboxComponent.prototype.srText;
    /** @type {?} */
    CheckboxComponent.prototype.change;
    /** @type {?} */
    CheckboxComponent.prototype.hasError;
    /** @type {?} */
    CheckboxComponent.prototype.errorMessage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SkipToMainComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} $event
     * @return {?}
     */
    skipToMain($event) {
        $event.preventDefault();
        $event.stopPropagation();
        /** @type {?} */
        const node = (/** @type {?} */ (document.querySelector(`[uiSkipToMainAnchor]`)));
        if (node) {
            /** @type {?} */
            const rect = node.getBoundingClientRect();
            window.scrollTo(0, rect.top);
            /** @type {?} */
            const heading = (/** @type {?} */ (document.querySelector('h1,h2,h3,h4,h5,h6')));
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
            }
            else {
                node.setAttribute('tabindex', '-1');
                node.focus();
            }
        }
    }
}
SkipToMainComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-skip-to-main',
                template: "<div [class.card]=\"showSkip\" [class.sr-only]=\"!showSkip\" tabindex=\"-1\" (focusin)=\"showSkip=true\" (focusout)=\"showSkip=false\">\n    <a href=\"javascript:void(0);\" (click)=\"skipToMain($event)\">{{ 'ui.skip-to-main.link' | translate }}</a>\n</div>"
            }] }
];
/** @nocollapse */
SkipToMainComponent.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    SkipToMainComponent.prototype.showSkip;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContainerLayoutComponent {
}
ContainerLayoutComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-container-layout',
                template: "<div class=\"container\">\n  <router-outlet></router-outlet>\n</div>\n"
            }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PageLayoutComponent {
}
PageLayoutComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-page-layout',
                template: "<div>\n  <header *ngIf=\"headerTemplate\">\n    <ui-skip-to-main></ui-skip-to-main>\n    <ng-container [ngTemplateOutlet]=\"headerTemplate\" [ngTemplateOutletContext]=\"{'header': header}\">\n    </ng-container>\n  </header>\n  <!-- role=\"main\" included for IE11 compat -->\n  <main role=\"main\" uiSkipToMainAnchor>\n    <router-outlet></router-outlet>\n  </main>\n</div>\n<ui-footer *ngIf=\"!footerTemplate\"></ui-footer>\n<footer *ngIf=\"footerTemplate\">\n  <ng-container [ngTemplateOutlet]=\"footerTemplate\" [ngTemplateOutletContext]=\"{'footer': footer}\">\n  </ng-container>\n</footer>\n"
            }] }
];
PageLayoutComponent.propDecorators = {
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate', { static: false },] }],
    footerTemplate: [{ type: ContentChild, args: ['footerTemplate', { static: false },] }],
    header: [{ type: Input }],
    footer: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PageLayoutComponent.prototype.headerTemplate;
    /** @type {?} */
    PageLayoutComponent.prototype.footerTemplate;
    /** @type {?} */
    PageLayoutComponent.prototype.header;
    /** @type {?} */
    PageLayoutComponent.prototype.footer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NavBarComponent {
    /**
     * @param {?} renderer
     */
    constructor(renderer) {
        this.renderer = renderer;
        this.signout = new EventEmitter;
        this.signin = new EventEmitter;
    }
    /**
     * @param {?=} active
     * @return {?}
     */
    toggleNavbar(active) {
        if (active !== undefined) {
            this.isActive = active;
        }
        else {
            this.isActive = !this.isActive;
        }
        /** @type {?} */
        const self = this;
        if (self.isActive) {
            window.addEventListener('resize', handleResize);
        }
        else {
            window.removeEventListener('resize', handleResize);
        }
        /**
         * @return {?}
         */
        function handleResize() {
            if (self.isActive) {
                self.toggleNavbar();
            }
            return true;
        }
        /** @type {?} */
        const action = this.isActive ? 'addClass' : 'removeClass';
        this.renderer[action](document.body, 'nav-mode');
    }
}
NavBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-navbar',
                template: "<div id=\"navbar\" class=\"container px-0\">\n    <nav class=\"navbar navbar-expand-lg\">\n        <a class=\"navbar-brand header py-2 pr-2\" [routerLink]=\"['/']\" *ngIf=\"header\" (click)=\"toggleNavbar(false)\">\n            <img *ngIf=\"header.logoSrc\" src=\"{{header.logoSrc}}\" class=\"img-fluid mh-100\" [alt]=\"header.siteName\">\n            <div *ngIf=\"!header.logoSrc\" class=\"logo\"><span class=\"sr-only\">{{header.siteName}}</span></div>\n        </a>\n        <button (click)=\"toggleNavbar()\" id=\"navbar-toggler\" *ngIf=\"navLinks\" class=\"navbar-toggler\" type=\"button\"\n            aria-controls=\"siteMenu\" [attr.aria-expanded]=\"isActive\" aria-label=\"Toggle navigation\">\n            <i class=\"ifc-icon ifc-menu ifc-icon-2\"></i>\n        </button>\n        <div class=\"navbar-collapse collapse\" [ngClass]=\"{'show': isActive}\" id=\"siteMenu\" *ngIf=\"navLinks\">\n            <ul class=\"nav navbar-nav pl-lg-2 pl-xl-5 w-100\">\n                <li class=\"nav-item\" *ngFor=\"let navLink of navLinks\">\n                    <a class=\"mx-2 mx-xl-3 nav-link\" [routerLink]=\"navLink.routerLink\"\n                        [queryParams]=\"navLink.queryParams\" routerLinkActive=\"active\"\n                        [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"toggleNavbar(false)\"><i\n                            *ngIf=\"navLink.icon\" class=\"ifc-icon {{navLink.icon}} mr-2 align-middle\"></i><span\n                            class=\"align-middle\">{{navLink.text\n                    | translate }}</span></a>\n                </li>\n                <ng-container *ngIf=\"isLoggedIn !== undefined\">\n                    <li class=\"nav-item ml-lg-auto\" *ngIf=\"isLoggedIn\">\n                        <a class=\"px-2 mx-xl-3 nav-link\" href=\"javascript:void(0)\"\n                            (click)=\"signout.emit(); toggleNavbar(false)\"><i\n                                class=\"ifc-icon ifc-logout mr-2 align-middle d-none d-lg-inline-block\"></i><span\n                                class=\"align-middle\">{{ 'ui.navbar.signout' | translate }}</span></a>\n                    </li>\n                    <li class=\"nav-item ml-lg-auto\" *ngIf=\"!isLoggedIn\">\n                        <a class=\"mx-2 mx-xl-3 nav-link\" href=\"javascript:void(0)\"\n                            (click)=\"signin.emit(); toggleNavbar(false)\"><i\n                                class=\"ifc-icon ifc-log-in mr-2 align-middle d-none d-lg-inline-block\"></i><span\n                                class=\"align-middle\">{{ 'ui.navbar.signin' | translate }}</span></a>\n                    </li>\n                </ng-container>\n            </ul>\n        </div>\n    </nav>\n</div>"
            }] }
];
/** @nocollapse */
NavBarComponent.ctorParameters = () => [
    { type: Renderer2 }
];
NavBarComponent.propDecorators = {
    isLoggedIn: [{ type: Input }],
    navLinks: [{ type: Input }],
    header: [{ type: Input }],
    signout: [{ type: Output }],
    signin: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    NavBarComponent.prototype.isLoggedIn;
    /** @type {?} */
    NavBarComponent.prototype.navLinks;
    /** @type {?} */
    NavBarComponent.prototype.header;
    /** @type {?} */
    NavBarComponent.prototype.signout;
    /** @type {?} */
    NavBarComponent.prototype.signin;
    /** @type {?} */
    NavBarComponent.prototype.isActive;
    /**
     * @type {?}
     * @private
     */
    NavBarComponent.prototype.renderer;
}
/**
 * @record
 */
function NavbarLink() { }
if (false) {
    /** @type {?} */
    NavbarLink.prototype.routerLink;
    /** @type {?|undefined} */
    NavbarLink.prototype.queryParams;
    /** @type {?} */
    NavbarLink.prototype.text;
    /** @type {?|undefined} */
    NavbarLink.prototype.icon;
}
/**
 * @record
 */
function NavInfo() { }
if (false) {
    /** @type {?|undefined} */
    NavInfo.prototype.logoSrc;
    /** @type {?} */
    NavInfo.prototype.siteName;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Header() { }
if (false) {
    /** @type {?} */
    Header.prototype.title;
    /** @type {?|undefined} */
    Header.prototype.description;
    /** @type {?|undefined} */
    Header.prototype.video;
    /** @type {?|undefined} */
    Header.prototype.img;
}
class HeaderComponent {
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.header.currentValue) {
            if (changes.header.currentValue.header && typeof (changes.header.currentValue.img) !== 'string') {
                if (this.headerSubscription) {
                    this.headerSubscription.unsubscribe();
                }
                this.headerSubscription = changes.header.currentValue.img.subscribe((/**
                 * @param {?} img
                 * @return {?}
                 */
                img => this.bannerImg = img));
            }
            else {
                this.bannerImg = changes.header.currentValue.img;
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.headerSubscription) {
            this.headerSubscription.unsubscribe();
        }
    }
}
HeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-header',
                template: "<div *ngIf=\"header || headerTitleTemplate || headerTemplate\" [class.darken]=\"header?.video\" [class.bg-header]=\"!header?.video\"\n  [ngStyle]=\"{ 'background': bannerImg ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(' + bannerImg + ')' : '','background-size': 'cover'}\">\n  <video *ngIf=\"header?.video\" class=\"v-bg\" id=\"bgvid\" playsinline autoplay muted loop>\n    <source src=\"{{header?.video}}\" type=\"video/mp4\">\n  </video>\n  <div class=\"container\">\n    <header>\n      <h1 *ngIf=\"header?.title\">{{header?.title | translate}}</h1>\n      <div class=\"h4\" *ngIf=\"header?.description\">{{header?.description | translate}}</div>\n      <ng-container *ngIf=\"headerTitleTemplate\" [ngTemplateOutlet]=\"headerTitleTemplate\"\n        [ngTemplateOutletContext]=\"{'headerContext': headerContext}\"></ng-container>\n    </header>\n  </div>\n  <ng-container *ngIf=\"headerTemplate\" [ngTemplateOutlet]=\"headerTemplate\"\n    [ngTemplateOutletContext]=\"{'headerContext': headerContext}\"></ng-container>\n</div>\n"
            }] }
];
HeaderComponent.propDecorators = {
    header: [{ type: Input }],
    headerContext: [{ type: Input }],
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate', { static: false },] }],
    headerTitleTemplate: [{ type: ContentChild, args: ['headerTitleTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    HeaderComponent.prototype.bannerImg;
    /** @type {?} */
    HeaderComponent.prototype.header;
    /** @type {?} */
    HeaderComponent.prototype.headerContext;
    /** @type {?} */
    HeaderComponent.prototype.headerTemplate;
    /** @type {?} */
    HeaderComponent.prototype.headerTitleTemplate;
    /**
     * @type {?}
     * @private
     */
    HeaderComponent.prototype.headerSubscription;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ResponsiveTableComponent {
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.table.nativeOrdering) {
            this.headings = this.table.nativeOrdering;
        }
        else {
            this.headings = Object.keys(this.table.headings);
        }
    }
}
ResponsiveTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-responsive-table',
                template: "<table *ngIf=\"table\" class=\"table table-striped table-responsive border-0\">\n    <thead>\n        <tr>\n            <th *ngFor=\"let heading of headings\" [innerText]=\"table.headings[heading]?.text || table.headings[heading]\">\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let row of table.rows\">\n            <td *ngFor=\"let key of headings\"\n                [attr.data-label]=\"table.headings[key]?.text || table.headings[key]\">\n                {{row[key]}}\n            </td>\n        </tr>\n    </tbody>\n</table>\n"
            }] }
];
ResponsiveTableComponent.propDecorators = {
    table: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ResponsiveTableComponent.prototype.table;
    /** @type {?} */
    ResponsiveTableComponent.prototype.headings;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTypeaheadComponent extends FieldComponent {
    /**
     * @param {?} el
     * @param {?} cd
     */
    constructor(el, cd) {
        super();
        this.el = el;
        this.cd = cd;
        this.queryEntered = new EventEmitter();
        this.selectionMade = new EventEmitter();
        this.isLoading = false;
        this.selectedMatchIdx = -1;
        this.filterParams = {
            minSearchLength: 3,
            caseSensitive: false
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.optionsObservable) {
            this.resultsSubscription = this.optionsObservable.subscribe((/**
             * @param {?} matches
             * @return {?}
             */
            matches => {
                this.matches = matches;
                if (this.matches.length === 0 && this.filterParams.closeWhenNoResults) {
                    this.matches = undefined;
                    this.isLoading = false;
                }
            }));
        }
        this.syncFieldToForm();
    }
    /**
     * @return {?}
     */
    syncFieldToForm() {
        if (this.field.value) {
            this.FormCtrl.setValue(this.field.value);
        }
        else {
            this.FormCtrl.setValue('');
        }
    }
    /**
     * @return {?}
     */
    validate() {
        /** @type {?} */
        let validators = (/** @type {?} */ ([]));
        if (this.selectionValidators) {
            validators = validators.concat(this.selectionValidators);
        }
        if (this.field.required) {
            validators.push(Validators.required);
        }
        if (this.params.disallowFreeInput) {
            validators.push((/**
             * @return {?}
             */
            () => this.checkSelectionInOptionSet(this.FormCtrl)));
        }
        for (const validator of validators) {
            /** @type {?} */
            const err = validator(this.FormCtrl);
            if (err) {
                return err;
            }
        }
    }
    /**
     * @param {?} currentControl
     * @return {?}
     */
    checkSelectionInOptionSet(currentControl) {
        /** @type {?} */
        let value = currentControl.value;
        if (!this.params.caseSensitive) {
            value = value.toLowerCase();
        }
        if (!value || !this.options) {
            return null;
        }
        if (typeof this.options[0] === 'string' &&
            ((/** @type {?} */ (this.options))).map((/**
             * @param {?} op
             * @return {?}
             */
            op => this.params.caseSensitive ? op : op.toLowerCase())).indexOf(value) === -1) {
            return {
                customErrorMsg: `ui.input-typeahead.invalid_selection_error`
            };
        }
        if (((/** @type {?} */ (this.options[0]))).id
            && !this.options
                .some((/**
             * @param {?} option
             * @return {?}
             */
            option => {
                /** @type {?} */
                const id = this.params.caseSensitive ? option.id : option.id.toLowerCase();
                /** @type {?} */
                const text = this.params.caseSensitive ? option.text : option.text.toLowerCase();
                return id === value || (option.useText && text === value);
            }))) {
            return {
                customErrorMsg: `ui.input-typeahead.invalid_selection_error`
            };
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.resultsSubscription) {
            this.resultsSubscription.unsubscribe();
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['field'] && !changes['field'].firstChange) {
            this.syncFieldToForm();
        }
        this.checkForError();
        Object.assign(this.filterParams, this.params);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onChange(event) {
        super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
        /** @type {?} */
        const newValue = event.target.value.trim();
        this.field.value = newValue;
        this.selectedMatchIdx = -1;
        this.isLoading = this.field.value.length > 0;
        if (this.field.value.length < this.filterParams.minSearchLength) {
            this.matches = undefined;
            this.cd.detectChanges();
            return;
        }
        if (!this.resultsSubscription) {
            this.matches = this.search(this.field.value, this.options);
            if (this.matches.length === 0 && this.filterParams.closeWhenNoResults) {
                this.matches = undefined;
                this.isLoading = false;
            }
            this.cd.detectChanges();
            return;
        }
        this.selectedMatchIdx = -1;
        this.queryEntered.emit(event);
    }
    /**
     * @param {?} match
     * @param {?=} close
     * @return {?}
     */
    setMatch(match, close = false) {
        if (typeof match === 'string') {
            this.field.value = match;
        }
        else if (match && ((/** @type {?} */ (match))).id) {
            this.field.value = match.useText ? match.text : match.id;
        }
        this.syncFieldToForm();
        if (close) {
            this.FormCtrl.setErrors(this.validate());
            this.isLoading = false;
            this.matches = undefined;
            this.selectionMade.emit(match);
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    handleKeypress(event) {
        /** @type {?} */
        const key = event.keyCode;
        if (!this.matches) {
            return;
        }
        if (key !== 38 && key !== 40 && key !== 13) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (key === 38) {
            this.selectedMatchIdx--;
            if (this.selectedMatchIdx < 0) {
                this.selectedMatchIdx = this.matches.length - 1;
            }
            this.scrollItemIntoView(this.listitems.toArray()[this.selectedMatchIdx]);
        }
        else if (key === 40) {
            this.selectedMatchIdx++;
            if (this.selectedMatchIdx === this.matches.length) {
                this.selectedMatchIdx = 0;
            }
            this.scrollItemIntoView(this.listitems.toArray()[this.selectedMatchIdx]);
        }
        /** @type {?} */
        const close = key === 13;
        if (this.selectedMatchIdx < 0) {
            this.selectedMatchIdx = 0;
        }
        this.setMatch(this.matches[this.selectedMatchIdx], close);
    }
    /**
     * @param {?} search
     * @param {?} options
     * @return {?}
     */
    search(search, options) {
        if (search.length < this.filterParams.minSearchLength) {
            return undefined;
        }
        /** @type {?} */
        const searchValue = !this.filterParams.caseSensitive ? search.toLowerCase() : search;
        if (typeof options[0] === 'string') {
            return ((/** @type {?} */ (options))).filter((/**
             * @param {?} option
             * @return {?}
             */
            option => this.matchText(searchValue, option, this.filterParams.caseSensitive)));
        }
        else {
            return ((/** @type {?} */ (options))).filter((/**
             * @param {?} option
             * @return {?}
             */
            option => this.matchText(searchValue, option.text, this.filterParams.caseSensitive) || this.matchId(searchValue, option.id)));
        }
    }
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    scrollItemIntoView(item) {
        /** @type {?} */
        const element = item.nativeElement;
        /** @type {?} */
        const container = this.el.nativeElement.querySelector('.autocomplete-matches');
        container.scrollTop = element.offsetTop;
    }
    /**
     * @private
     * @param {?} search
     * @param {?} option
     * @param {?} caseSensitive
     * @return {?}
     */
    matchText(search, option, caseSensitive) {
        /** @type {?} */
        const text = !caseSensitive ? option.toLowerCase() : option;
        /** @type {?} */
        const words = text.split(' ');
        return words.some((/**
         * @param {?} word
         * @return {?}
         */
        word => word.indexOf(search) === 0));
    }
    /**
     * @private
     * @param {?} search
     * @param {?} id
     * @return {?}
     */
    matchId(search, id) {
        return id.toLowerCase().indexOf(search) === 0;
    }
}
InputTypeaheadComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-typeahead',
                template: "<div class=\"d-flex flex-column\" *ngIf=\"field\">\n  <div class=\"form-group\">\n    <label class=\"form-control-label\" *ngIf=\"field.label\" [for]=\"field.id\" [class.required]=\"field.required\"\n      [innerHTML]=\"field.label | translate\"></label>\n    <input type=\"search\" class=\"form-control\" [class.results-visible]=\"matches\" [class.is-invalid]=\"hasError\"\n      autocomplete=\"off\" [id]=\"field.id\" [name]=\"field.id\" [value]=\"field.value\"\n      [attr.placeholder]=\"field.placeholder ? (field.placeholder | translate) : ''\" [required]=\"field.required\" (keydown)=\"handleKeypress($event)\"\n      (input)=\"onChange($event)\" (blur)=\"setMatch(field.value,true)\" [formControl]=\"FormCtrl\"\n      [attr.aria-expanded]=\"matches?.length\" aria-autocomplete=\"both\"\n      aria-owns=\"resultsList\" [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.aria-invalid]=\"hasError\"\n      [attr.aria-describedby]=\"field.id + '_error_req ' + field.id + '_error_custom ' + field.id + '_help'\">\n    <div class=\"d-block small\" class=\"form-control-feedback text-danger\" role=\"region\" aria-live=\"assertive\">\n      <span *ngIf=\"hasError && !FormCtrl?.errors?.customErrorMsg && field.required && !FormCtrl.value\"\n        aria-live=\"assertive\" [id]=\"field.id + '_error_req'\">{{'ui.form_field.required_text' | translate}}</span>\n      <span *ngIf=\"hasError && FormCtrl?.errors?.customErrorMsg\" aria-live=\"assertive\"\n        [id]=\"field.id + '_error_custom'\">{{form.controls[this.field.name].errors.customErrorMsg | translate:FormCtrl}}</span>\n    </div>\n    <span class=\"d-block small\" *ngIf=\"field.helperText\" [id]=\"field.id + '_help'\" class=\"form-text text-muted\"\n      [innerHTML]=\"field.helperText | translate\">\n    </span>\n  </div>\n  <div role=\"region\" aria-live=\"assertive\">\n    <div class=\"autocomplete-matches w-100\" *ngIf=\"isLoading\">\n      <span class=\"sr-only\" role=\"status\" *ngIf=\"matches?.length\">{{'ui.input-typeahead.results' | translate}}</span>\n      <ul id=\"resultsList\" class=\"list-group\" role=\"listbox\">\n        <ng-container *ngIf=\"!matches\">\n          <li class=\"list-group-item d-flex flex-row align-items-center\" role=\"option\">\n            <ui-loading-spinner></ui-loading-spinner>\n            <span class=\"small ml-2 font-italic\"\n              role=\"alert\">{{'ui.input-typeahead.search' | translate:filterParams}}</span>\n          </li>\n        </ng-container>\n        <ng-container *ngIf=\"matches?.length > 0\">\n          <li #listitems class=\"list-group-item py-0\" [attr.aria-selected]=\"i === selectedMatchIdx\"\n            *ngFor=\"let match of matches; let i = index\" role=\"option\" (mousedown)=\"setMatch(match, true)\"\n            tabindex=\"-1\">\n            <ng-container *ngIf=\"customOption; else defaultOption\" [ngTemplateOutlet]=\"customOption\"\n              [ngTemplateOutletContext]=\"{'customOptionContext': customOptionContext}\"></ng-container>\n            <ng-template #defaultOption>\n              <ng-container *ngIf=\"match.id; else textResult\">\n                <div class=\"row py-3\">\n                  <div class=\"col-4 mr-2 font-weight-bold border-right result-id\">\n                    {{match.id}}</div>\n                  <div class=\"col ml-2\">{{match.text}}</div>\n                </div>\n              </ng-container>\n              <ng-template #textResult>\n                <div class=\"py-3\">{{match}}</div>\n              </ng-template>\n            </ng-template>\n          </li>\n        </ng-container>\n        <ng-container *ngIf=\"matches?.length === 0\">\n          <li class=\"list-group-item small text-muted\" role=\"option\">\n            <span role=\"alert\">{{'ui.input-typeahead.empty' | translate}}</span>\n          </li>\n        </ng-container>\n      </ul>\n    </div>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
InputTypeaheadComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
InputTypeaheadComponent.propDecorators = {
    field: [{ type: Input }],
    options: [{ type: Input }],
    optionsObservable: [{ type: Input }],
    params: [{ type: Input }],
    customOptionContext: [{ type: Input }],
    selectionValidators: [{ type: Input }],
    queryEntered: [{ type: Output }],
    selectionMade: [{ type: Output }],
    customOption: [{ type: ContentChild, args: ['customOption', { static: false },] }],
    listitems: [{ type: ViewChildren, args: ['listitems',] }]
};
if (false) {
    /** @type {?} */
    InputTypeaheadComponent.prototype.field;
    /** @type {?} */
    InputTypeaheadComponent.prototype.options;
    /** @type {?} */
    InputTypeaheadComponent.prototype.optionsObservable;
    /** @type {?} */
    InputTypeaheadComponent.prototype.params;
    /** @type {?} */
    InputTypeaheadComponent.prototype.customOptionContext;
    /** @type {?} */
    InputTypeaheadComponent.prototype.selectionValidators;
    /** @type {?} */
    InputTypeaheadComponent.prototype.queryEntered;
    /** @type {?} */
    InputTypeaheadComponent.prototype.selectionMade;
    /** @type {?} */
    InputTypeaheadComponent.prototype.customOption;
    /** @type {?} */
    InputTypeaheadComponent.prototype.listitems;
    /** @type {?} */
    InputTypeaheadComponent.prototype.hasError;
    /** @type {?} */
    InputTypeaheadComponent.prototype.isLoading;
    /** @type {?} */
    InputTypeaheadComponent.prototype.matches;
    /** @type {?} */
    InputTypeaheadComponent.prototype.selectedMatchIdx;
    /** @type {?} */
    InputTypeaheadComponent.prototype.resultsSubscription;
    /** @type {?} */
    InputTypeaheadComponent.prototype.filterParams;
    /**
     * @type {?}
     * @private
     */
    InputTypeaheadComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    InputTypeaheadComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SearchComponent {
    constructor() {
        this.search = new EventEmitter();
        this.showAdvancedFilters = false;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.search.complete();
    }
}
SearchComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-search',
                template: "<div class=\"card\">\n    <div class=\"card-body\">\n        <h2 class=\"mb-3\">{{title | translate}}</h2>\n        <div class=\"row\">\n            <div class=\"col pr-0\">\n                <ui-input sr-only-label [field]=\"primarySearch\" [form]=\"form\" (keyup.enter)=\"search.emit()\"></ui-input>\n            </div>\n            <div class=\"mr-3 ml-0\">\n                <button class=\"btn btn-primary\" type=\"button\" (click)=\"search.emit()\">\n                    <i class=\"ifc-icon ifc-search mx-2 align-middle\"></i> <span\n                        class=\"sr-only\">{{'ui.search.search_btn_label' | translate}}</span>\n                </button>\n            </div>\n        </div>\n        <div *ngIf=\"filters?.length\">\n            <a role=\"button\" (click)=\"showAdvancedFilters = !showAdvancedFilters\" href=\"javascript:void(0)\"\n                [attr.aria-expanded]=\"showAdvancedFilters\" class=\"small\">\n                <span class=\"align-middle\">{{'ui.search.advanced_filters_label' | translate}}</span>\n                <i class=\"ifc-icon align-middle ml-2\" [class.ifc-chevron-down]=\"showAdvancedFilters\"\n                    [class.ifc-chevron-right]=\"!showAdvancedFilters\"></i>\n            </a>\n        </div>\n        <div class=\"collapse in show\" id=\"advancedSearch\" *ngIf=\"showAdvancedFilters\"\n            [attr.aria-expanded]=\"showAdvancedFilters\">\n            <div class=\"row pt-3\">\n                <div class=\"col-12 col-sm-6 col-md-3\" *ngFor=\"let filter of filters\">\n                    <ui-form-control *ngIf=\"filter\" [field]=\"filter\" [form]=\"form\"></ui-form-control>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"
            }] }
];
SearchComponent.propDecorators = {
    title: [{ type: Input }],
    primarySearch: [{ type: Input }],
    form: [{ type: Input }],
    filters: [{ type: Input }],
    search: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SearchComponent.prototype.title;
    /** @type {?} */
    SearchComponent.prototype.primarySearch;
    /** @type {?} */
    SearchComponent.prototype.form;
    /** @type {?} */
    SearchComponent.prototype.filters;
    /** @type {?} */
    SearchComponent.prototype.search;
    /** @type {?} */
    SearchComponent.prototype.showAdvancedFilters;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckboxGroupComponent {
    /**
     * @param {?} changesRef
     */
    constructor(changesRef) {
        this.changesRef = changesRef;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.fieldset) {
            this.elements = this.fieldset.elements.map((/**
             * @param {?} el
             * @param {?} idx
             * @return {?}
             */
            (el, idx) => {
                el.ifId = this.fieldset.extraAttributes && this.fieldset.extraAttributes.ifId ? this.fieldset.extraAttributes.ifId + '-option-' + idx : 'option-' + idx;
                /** @type {?} */
                const e = Object.assign({}, el);
                e.control = new FormControl(e.checked ? e.value : '');
                return e;
            }));
            if (this.elements && this.elements.length) {
                if (this.fieldset && !this.fieldset.name) {
                    this.fieldset.name = this.fieldset.elements[0].name;
                }
                this.form.addControl(this.fieldset.name, new FormArray(this.elements.map((/**
                 * @param {?} el
                 * @return {?}
                 */
                (el) => el.control)), this.fieldset.required ? this.customRequiredValidator() : undefined));
            }
        }
    }
    /**
     * @return {?}
     */
    customRequiredValidator() {
        return (/**
         * @param {?} controls
         * @return {?}
         */
        (controls) => {
            /** @type {?} */
            const hasValue = controls.value.some((/**
             * @param {?} val
             * @return {?}
             */
            val => !!val));
            return hasValue ? null : { type: 'required' };
        });
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        field.control.setValue($event.target.checked ? field.value : '');
        this.changesRef.markForCheck();
    }
}
CheckboxGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-checkbox-group',
                template: "<ng-container *ngIf=\"fieldset\">\n  <fieldset class=\"form-group\" tabindex=\"-1\" [class.error]=\"form.controls[fieldset.name].errors && fieldset.required\" [formGroup]=\"form\">\n    <legend class=\"form-control-label\" [class.required]=\"fieldset.required\">{{fieldset.legend }}</legend>\n\n    <div class=\"custom-control custom-checkbox\" *ngFor=\"let field of elements\">\n      <input\n        ifPII\n        class=\"custom-control-input\"\n        (change)=\"changeOccurred($event, field)\"\n        [formControl]=\"field.control\"\n        [name]=\"field.name\"\n        [id]=\"field.id\"\n        [type]=\"field.type\"\n        [checked]=\"field.checked\"\n        [attr.data-if-id]=\"field.ifId\"/>\n      <label\n        [for]=\"field.id\"\n        class=\"custom-control-label\"\n        [innerHTML]=\"field.label\"></label>\n    </div>\n\n    <small class=\"d-block form-control-feedback mt-1 text-danger\" *ngIf=\"fieldset?.name\">\n      <span role=\"alert\" *ngIf=\"form.controls[fieldset.name] && form.controls[fieldset.name].touched && form.controls[fieldset.name].errors\">{{'ui.form_field.required_text' | translate}}</span>\n    </small>\n  </fieldset>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
CheckboxGroupComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CheckboxGroupComponent.propDecorators = {
    form: [{ type: Input }],
    fieldset: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    CheckboxGroupComponent.prototype.hasValue;
    /** @type {?} */
    CheckboxGroupComponent.prototype.elements;
    /** @type {?} */
    CheckboxGroupComponent.prototype.form;
    /** @type {?} */
    CheckboxGroupComponent.prototype.fieldset;
    /**
     * @type {?}
     * @private
     */
    CheckboxGroupComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificationComponent {
    /**
     * @param {?} notificationService
     */
    constructor(notificationService) {
        this.notificationService = notificationService;
        this.messageExpireInterval = 1000; // ms
        this.alertExpireInterval = 1000; // ms
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.messageSubscription = this.notificationService.message.subscribe((/**
         * @param {?} message
         * @return {?}
         */
        (message) => {
            this.setMessageTimeOut(message);
        }));
        this.alertSubscription = this.notificationService.alert.subscribe((/**
         * @param {?} alert
         * @return {?}
         */
        (alert) => {
            if (alert) {
                this.setAlertTimeOut(alert);
            }
        }));
    }
    /**
     * @param {?} message
     * @return {?}
     */
    setMessageTimeOut(message) {
        if (message.msg || !this.message) {
            this.message = message.msg;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.message = '';
            }), message.delay ? message.delay : this.messageExpireInterval);
        }
    }
    /**
     * @param {?} alert
     * @return {?}
     */
    setAlertTimeOut(alert) {
        this.alert = alert.msg;
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.alert = '';
        }), alert.delay ? alert.delay : this.alertExpireInterval);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
        if (this.alertSubscription) {
            this.alertSubscription.unsubscribe();
        }
    }
}
NotificationComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-notification',
                template: "<div class=\"sr-only\" role=\"status\" aria-live=\"assertive\" [innerHTML]=\"message\"></div>\n<div *ngIf=\"alert\" class=\"sr-only\" role=\"alert\" [innerHTML]=\"alert\"></div>\n"
            }] }
];
/** @nocollapse */
NotificationComponent.ctorParameters = () => [
    { type: NotificationService }
];
NotificationComponent.propDecorators = {
    message: [{ type: Input }],
    messageExpireInterval: [{ type: Input }],
    alert: [{ type: Input }],
    alertExpireInterval: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    NotificationComponent.prototype.message;
    /** @type {?} */
    NotificationComponent.prototype.messageExpireInterval;
    /** @type {?} */
    NotificationComponent.prototype.alert;
    /** @type {?} */
    NotificationComponent.prototype.alertExpireInterval;
    /**
     * @type {?}
     * @private
     */
    NotificationComponent.prototype.messageSubscription;
    /**
     * @type {?}
     * @private
     */
    NotificationComponent.prototype.alertSubscription;
    /**
     * @type {?}
     * @private
     */
    NotificationComponent.prototype.notificationService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 * Filters a list of controls based on property
 * Usage:
 *   value | controlsFilter:{property: string, value: any}
 * Example:
 *   *ngFor=" let field of (formFields | controlsFilter:{'property': 'required', 'value': true})"
 */
class ControlsFilterPipe {
    /**
     * @param {?} arr
     * @param {?} filter
     * @return {?}
     */
    transform(arr, filter) {
        if (!arr || arr.length === 0) {
            return [];
        }
        return arr.filter((/**
         * @param {?} f
         * @return {?}
         */
        f => f[filter.property] === filter.value));
    }
}
ControlsFilterPipe.decorators = [
    { type: Pipe, args: [{ name: 'controlsFilter' },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MaintenanceComponent {
    /**
     * @param {?} translate
     * @param {?} titleService
     * @param {?} lastResponseService
     */
    constructor(translate, titleService, lastResponseService) {
        this.translate = translate;
        this.titleService = titleService;
        this.lastResponseService = lastResponseService;
        this.page = {};
        this.translate.get([
            'ui.maintenance.default_title',
            'ui.maintenance.default_message'
        ]).subscribe((/**
         * @param {?} maintenanceTexts
         * @return {?}
         */
        maintenanceTexts => {
            this.page.title = maintenanceTexts['ui.maintenance.default_title'];
            this.page.message = maintenanceTexts['ui.maintenance.default_message'];
            this.page.homeRoute = '/';
            if (this.lastResponseService.ifResponse) {
                /** @type {?} */
                const response = this.lastResponseService.ifResponse;
                /** @type {?} */
                const lastResponseData = response.Results.data;
                if (lastResponseData) {
                    Object.keys(lastResponseData).some((/**
                     * @param {?} key
                     * @return {?}
                     */
                    key => {
                        if (lastResponseData[key].maintenanceMessage) {
                            this.page.message = lastResponseData[key].maintenanceMessage;
                            return true;
                        }
                    }));
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.titleService.setTitle(this.page.title);
    }
}
MaintenanceComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-maintenance',
                template: "<div *ngIf=\"page\">\n    <div class=\"card text-center p-4\">\n        <div class=\"card-body\">\n            <h1 [innerHTML]=\"page.title\"></h1>\n            <p [innerHTML]=\"page.message\"></p>\n            <a class=\"btn btn-primary btn-block\"\n                [routerLink]=\"[page.homeRoute]\">{{'ui.maintenance.home' | translate}}</a>\n        </div>\n    </div>\n</div>"
            }] }
];
/** @nocollapse */
MaintenanceComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: Title },
    { type: LastResponseService }
];
if (false) {
    /** @type {?} */
    MaintenanceComponent.prototype.page;
    /**
     * @type {?}
     * @private
     */
    MaintenanceComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    MaintenanceComponent.prototype.titleService;
    /**
     * @type {?}
     * @private
     */
    MaintenanceComponent.prototype.lastResponseService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function YesNo() { }
if (false) {
    /** @type {?} */
    YesNo.prototype.yes;
    /** @type {?} */
    YesNo.prototype.no;
}
class YesNoComponent extends FieldComponent {
    constructor() {
        super();
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.field) {
            this.checkForError();
            if (this.field.value) {
                this.FormCtrl.setValue(this.field.value);
            }
            else {
                this.FormCtrl.setValue('');
            }
            if (this.field.disabled) {
                this.FormCtrl.disable();
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} $event
     * @param {?} yesNo
     * @return {?}
     */
    updateResponseField($event, yesNo) {
        this.field.value = yesNo.value;
        this.FormCtrl.setValue(yesNo.value);
        super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
        this.change.emit(this.field);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    checkRequired($event) {
        if ($event.currentTarget.contains($event.relatedTarget)) {
            return;
        }
        if (this.field.required && !this.field.value) {
            this.hasError = true;
        }
    }
}
YesNoComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-yes-no',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n  [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"btn-group\" role=\"radiogroup\" [class.ng-invalid]=\"!field.value\" tabindex=\"-1\"\n      (focusout)=\"checkRequired($event)\">\n      <button type=\"button\" role=\"radio\" class=\"btn btn-outline-secondary px-5\" [attr.aria-describedby]=\"field.id\"\n        (click)=\"updateResponseField($event, field.no)\"  [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-no' : 'no'\"\n        [class.active]=\"field?.value === field?.no?.value\">{{ field?.no?.label | translate }}</button>\n      <button type=\"button\" role=\"radio\" class=\"btn btn-outline-primary px-5\" [attr.aria-describedby]=\"field.id\"\n        (click)=\"updateResponseField($event, field.yes)\" [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-yes' : 'yes'\"\n        [class.active]=\"field?.value === field?.yes?.value\">{{ field?.yes?.label | translate }}</button>\n    </div>\n    <input type=\"hidden\" [formControlName]=\"field.name\">\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
/** @nocollapse */
YesNoComponent.ctorParameters = () => [];
YesNoComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    YesNoComponent.prototype.field;
    /** @type {?} */
    YesNoComponent.prototype.change;
    /** @type {?} */
    YesNoComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function CarouselOptions() { }
if (false) {
    /** @type {?|undefined} */
    CarouselOptions.prototype.interval;
    /** @type {?|undefined} */
    CarouselOptions.prototype.keyboard;
    /** @type {?|undefined} */
    CarouselOptions.prototype.pause;
    /** @type {?|undefined} */
    CarouselOptions.prototype.ride;
    /** @type {?|undefined} */
    CarouselOptions.prototype.wrap;
}
class CarouselComponent {
    constructor() {
        this.slideChange = new EventEmitter();
        this.defaultOptions = {
            interval: 2000,
            keyboard: true,
            pause: 'hover',
            ride: false,
            wrap: true
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.active = 0;
        this.carouselOptions = Object.assign(this.defaultOptions, this.carouselOptions);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.carousel && this.carousel.nativeElement) {
            this.$carousel = $(this.carousel.nativeElement).carousel(this.carouselOptions);
        }
    }
    /**
     * @return {?}
     */
    next() {
        if (this.$carousel) {
            if (!this.items[this.active + 1]) {
                this.active = 0;
            }
            else {
                this.active++;
            }
            this.$carousel.carousel('pause');
            this.$carousel.carousel('next');
            this.slideChange.emit(this.items[this.active]);
        }
    }
    /**
     * @return {?}
     */
    prev() {
        if (this.$carousel) {
            if (!this.items[this.active - 1]) {
                this.active = this.items.length - 1;
            }
            else {
                this.active--;
            }
            this.$carousel.carousel('pause');
            this.$carousel.carousel('prev');
            this.slideChange.emit(this.items[this.active]);
        }
    }
    /**
     * @param {?} idx
     * @return {?}
     */
    goToSlide(idx) {
        if (this.$carousel) {
            this.active = idx;
            this.$carousel.carousel('pause');
            this.$carousel.carousel(idx);
            this.slideChange.emit(this.items[this.active]);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.$carousel) {
            this.$carousel.carousel('dispose');
        }
    }
    /**
     * @param {?} $event
     * @param {?} index
     * @return {?}
     */
    keydownClick($event, index) {
        if ($event.which === 13 || $event.which === 32) {
            /** @type {?} */
            let event;
            if (typeof (MouseEvent) === 'function') {
                event = new MouseEvent('click', { bubbles: true });
            }
            else {
                event = document.createEvent('MouseEvent');
                event.initEvent('click', true, true);
            }
            $event.target.dispatchEvent(event);
        }
    }
}
CarouselComponent.TYPE = 'carousel';
CarouselComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-carousel',
                template: "<ng-container *ngIf=\"items\">\n  <div class=\"carousel slide\" role=\"region\" #carousel>\n    <ng-container *ngTemplateOutlet=\"carouselTitle\"></ng-container>\n    <div class=\"carousel-inner container\" aria-live=\"polite\">\n      <ng-container *ngFor=\"let item of items; index as idx\">\n        <div class=\"carousel-item\" [class.active]=\"idx === 0\">\n          <ng-container\n            *ngTemplateOutlet=\"carouselItemTemplate; context: { item: item, next: next.bind(this), prev: prev.bind(this), goToSlide: goToSlide.bind(this), index: idx }\">\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n\n    <ng-container *ngIf=\"!hideIndicators\">\n      <ol class=\"carousel-indicators\">\n        <li *ngFor=\"let item of items; index as idx\" [class.active]=\"idx === 0\">\n          <button type=\"button\" (click)=\"goToSlide(idx)\">\n            <span class=\"sr-only\">{{ 'ui.carousel.go-to-slide' | translate:{num: (idx+1)} }}</span>\n          </button>\n        </li>\n      </ol>\n    </ng-container>\n\n    <button class=\"btn btn-link carousel-control-prev\" type=\"button\" (click)=\"prev()\">\n      <i class=\"ifc-icon ifc-chevron-left ifc-icon-3 pl-3\" aria-hidden=\"true\"></i>\n      <span class=\"sr-only\">{{ 'ui.carousel.previous' | translate }}</span>\n    </button>\n    <button class=\"btn btn-link carousel-control-next\" type=\"button\" (click)=\"next()\">\n      <i class=\"ifc-icon ifc-chevron-right ifc-icon-3 pr-3\" aria-hidden=\"true\"></i>\n      <span class=\"sr-only\">{{ 'ui.carousel.next' | translate }}</span>\n    </button>\n  </div>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
CarouselComponent.ctorParameters = () => [];
CarouselComponent.propDecorators = {
    carousel: [{ type: ViewChild, args: ['carousel', { static: false },] }],
    carouselItemTemplate: [{ type: ContentChild, args: ['carouselItemTemplate', { static: false },] }],
    carouselTitle: [{ type: ContentChild, args: ['carouselTitle', { static: false },] }],
    items: [{ type: Input }],
    carouselOptions: [{ type: Input }],
    hideIndicators: [{ type: Input }],
    slideChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    CarouselComponent.TYPE;
    /** @type {?} */
    CarouselComponent.prototype.active;
    /** @type {?} */
    CarouselComponent.prototype.carousel;
    /** @type {?} */
    CarouselComponent.prototype.carouselItemTemplate;
    /** @type {?} */
    CarouselComponent.prototype.carouselTitle;
    /** @type {?} */
    CarouselComponent.prototype.items;
    /** @type {?} */
    CarouselComponent.prototype.carouselOptions;
    /** @type {?} */
    CarouselComponent.prototype.hideIndicators;
    /** @type {?} */
    CarouselComponent.prototype.slideChange;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.defaultOptions;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.$carousel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToggleSwitchDirective {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    onChange(evt) {
        if (evt.checked) {
            /** @type {?} */
            const checkbox = evt.setAttribute ? evt : this.el.nativeElement.querySelector(`input[type="checkbox"][id="${evt.id}"]`);
            this.renderer.setAttribute(checkbox, 'aria-checked', evt.checked);
        }
        else if (evt.target) {
            this.renderer.setAttribute(evt.target, 'aria-checked', evt.target.checked);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const field = this.el.nativeElement;
        /** @type {?} */
        const checkboxes = field.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((/**
         * @param {?} checkbox
         * @return {?}
         */
        checkbox => {
            this.renderer.setAttribute(checkbox, 'role', 'switch');
            this.renderer.setAttribute(checkbox, 'aria-checked', checkbox['checked']);
        }));
    }
}
ToggleSwitchDirective.decorators = [
    { type: Directive, args: [{ selector: '[toggle-switch]' },] }
];
/** @nocollapse */
ToggleSwitchDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ToggleSwitchDirective.propDecorators = {
    onChange: [{ type: HostListener, args: ['change', ['$event'],] }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    ToggleSwitchDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ToggleSwitchDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MessageLoaderComponent {
    constructor() { }
}
MessageLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-loading-message-spinner',
                template: `
  <div class="text-center">
    <ui-loading-spinner></ui-loading-spinner>
    <div *ngIf="loadingMessage" class="font-weight-bold" [@fadeIn]>{{loadingMessage | translate}}</div>
  </div>
  `,
                animations: [
                    trigger('fadeIn', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('1s', style({ opacity: 1 }))
                        ])
                    ])
                ]
            }] }
];
/** @nocollapse */
MessageLoaderComponent.ctorParameters = () => [];
MessageLoaderComponent.propDecorators = {
    loadingMessage: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    MessageLoaderComponent.prototype.loadingMessage;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MultiSelectToCheckboxComponent {
    /**
     * @param {?} changesRef
     */
    constructor(changesRef) {
        this.changesRef = changesRef;
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.field && this.field.extraAttributes && this.field.extraAttributes.multiple) {
            this.required = this.field.required;
            /** @type {?} */
            const elements = this.field.options.filter((/**
             * @param {?} option
             * @return {?}
             */
            option => option.value)).map((/**
             * @param {?} option
             * @param {?} idx
             * @return {?}
             */
            (option, idx) => {
                if (option.selected) {
                    this.hasValue = true;
                }
                return {
                    id: this.field.id + idx,
                    name: this.field.name,
                    ifId: this.field.extraAttributes ? this.field.extraAttributes.ifId + "-option-" + idx : undefined,
                    nodeType: 'input',
                    type: 'checkbox',
                    checked: option.selected,
                    required: false,
                    label: option.text,
                    value: option.value,
                    control: new FormControl(option.selected ? option.value : '')
                };
            }));
            this.form.addControl(this.field.name, new FormArray(elements.map((/**
             * @param {?} el
             * @return {?}
             */
            el => el.control)), this.customRequiredValidator()));
            this.fieldset = {
                legend: this.field.label,
                elements: (/** @type {?} */ (elements)),
                nodeType: 'fieldset',
                extraAttributes: {
                    ifId: this.field.extraAttributes ? this.field.extraAttributes.ifId : undefined
                }
            };
        }
    }
    /**
     * @return {?}
     */
    customRequiredValidator() {
        return (/**
         * @param {?} controls
         * @return {?}
         */
        (controls) => {
            /** @type {?} */
            const hasValue = controls.value.some((/**
             * @param {?} val
             * @return {?}
             */
            val => !!val));
            return hasValue ? null : { type: 'required' };
        });
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        field.control.setValue($event.target.checked ? field.value : '');
        this.changesRef.markForCheck();
        $event.preventDefault();
        $event.stopPropagation();
        this.change.emit($event);
    }
}
MultiSelectToCheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-multi-select-to-checkbox',
                template: "<ng-container *ngIf=\"fieldset\">\n  <fieldset class=\"form-group\" tabindex=\"-1\" [class.error]=\"hasError && required\" [formGroup]=\"form\">\n    <legend class=\"form-control-label\" [class.required]=\"required\">{{fieldset.legend | translate}}</legend>\n    <div>\n      <div class=\"custom-control custom-checkbox\" *ngFor=\"let field of fieldset.elements\">\n        <input\n          ifPII\n          class=\"custom-control-input\"\n          (change)=\"changeOccurred($event, field)\"\n          [formControl]=\"field.control\"\n          [name]=\"field.name\"\n          [id]=\"field.id\"\n          [type]=\"field.type\"\n          [checked]=\"field.checked\"\n          [attr.data-if-id]=\"field.ifId\"/>\n        <label\n          [for]=\"field.id\"\n          class=\"custom-control-label\"\n          [ngClass]=\"{error: hasError, required : field.required}\">\n          {{field.label | translate}}</label>\n        </div>\n    </div>\n    <small class=\"d-block form-control-feedback mt-1 text-danger\" role=\"alert\" *ngIf=\"form.controls[field.name] && form.controls[field.name].touched && form.controls[field.name].errors\">\n        {{'ui.form_field.required_text' | translate}}\n    </small>\n  </fieldset>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
MultiSelectToCheckboxComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
MultiSelectToCheckboxComponent.propDecorators = {
    form: [{ type: Input }],
    field: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.fieldset;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.required;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.hasError;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.hasValue;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.form;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.field;
    /** @type {?} */
    MultiSelectToCheckboxComponent.prototype.change;
    /**
     * @type {?}
     * @private
     */
    MultiSelectToCheckboxComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RadioSliderComponent {
    constructor() {
        this.slidechange = new EventEmitter$1();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.field) {
            if (!this.form.contains(this.field.name)) {
                this.form.addControl(this.field.name, new FormControl());
            }
            this.min = 0;
            this.max = this.field.elements.length - 1;
            this.value = this.setValue(this.field).toString();
            this.activeSliderWidth = this.getActiveSliderWidth(parseInt(this.value, 10), this.field.elements.length);
            this.active = this.field.elements[this.value].label;
        }
    }
    /**
     * @param {?} ref
     * @return {?}
     */
    changeRange(ref) {
        this.value = ref.value;
        this.activeSliderWidth = this.getActiveSliderWidth(parseInt(this.value, 10), this.field.elements.length);
        this.active = this.field.elements[this.value].label;
        this.form.controls[this.field.name].setValue(this.field.elements[this.value].value);
        this.slidechange.emit(this.value);
    }
    /**
     * @param {?} value
     * @param {?} length
     * @return {?}
     */
    getActiveSliderWidth(value, length) {
        return value * (100 / (length - 1));
    }
    /**
     * @param {?} radios
     * @return {?}
     */
    setValue(radios) {
        /** @type {?} */
        let val = 0;
        /** @type {?} */
        const checkedRadio = radios.elements.find((/**
         * @param {?} field
         * @param {?} idx
         * @return {?}
         */
        (field, idx) => {
            if (field.checked) {
                val = idx;
                return true;
            }
        }));
        if (checkedRadio && this.form.contains(radios.name)) {
            this.form.controls[radios.name].setValue(((/** @type {?} */ (checkedRadio))).value);
        }
        return val;
    }
}
RadioSliderComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-radio-slider',
                template: "<ng-container *ngIf=\"field\">\n    <div class=\"row align-items-start py-2 py-sm-3\" [formGroup]=\"form\">\n      <div class=\"col-sm-4 col-md-12 col-lg-4 col-xl-12\">\n        <label [for]=\"field.id\">{{field?.legend | translate }}</label>\n      </div>\n      <div class=\"col-sm-8 col-md-12 col-lg-8 col-xl-12\">\n        <div class=\"slider\">\n          <input ifPII type=\"range\" #ref [id]=\"field.id\" (input)=\"changeRange(ref)\" (change)=\"changeRange(ref)\" [style.background-size]=\"activeSliderWidth+'% 100%'\"\n            min=\"0\" [max]=\"max\" [value]=\"value\" step=\"1\">\n          <input ifPII type=\"hidden\" [formControlName]=\"field.name\">\n          <span>{{active | translate }}</span>\n        </div>\n      </div>\n    </div>\n</ng-container>\n"
            }] }
];
RadioSliderComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    slidechange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    RadioSliderComponent.prototype.field;
    /** @type {?} */
    RadioSliderComponent.prototype.form;
    /** @type {?} */
    RadioSliderComponent.prototype.slidechange;
    /** @type {?} */
    RadioSliderComponent.prototype.step;
    /** @type {?} */
    RadioSliderComponent.prototype.min;
    /** @type {?} */
    RadioSliderComponent.prototype.max;
    /** @type {?} */
    RadioSliderComponent.prototype.value;
    /** @type {?} */
    RadioSliderComponent.prototype.activeSliderWidth;
    /** @type {?} */
    RadioSliderComponent.prototype.active;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsService {
    constructor() {
        this.stepClickedSubject = new Subject();
        this.stepsToggle = new Subject();
        this.stepsSubject = new BehaviorSubject(undefined);
        this.stepClickedEvent = this.stepClickedSubject.asObservable();
        this.watchToggle = this.stepsToggle.asObservable();
        this.steps = this.stepsSubject.asObservable();
    }
    /**
     * @param {?} steps
     * @return {?}
     */
    updateStepList(steps) {
        this.stepList = steps;
        this.stepsSubject.next(this.stepList);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    stepClicked(e) {
        this.stepClickedSubject.next(e);
    }
    /**
     * @param {?} isShown
     * @return {?}
     */
    stepToggle(isShown) {
        this.stepsToggle.next(isShown);
    }
}
StepsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
StepsService.ctorParameters = () => [];
/** @nocollapse */ StepsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StepsService_Factory() { return new StepsService(); }, token: StepsService, providedIn: "root" });
if (false) {
    /** @type {?} */
    StepsService.prototype.stepClickedEvent;
    /** @type {?} */
    StepsService.prototype.watchToggle;
    /** @type {?} */
    StepsService.prototype.steps;
    /**
     * @type {?}
     * @private
     */
    StepsService.prototype.stepClickedSubject;
    /**
     * @type {?}
     * @private
     */
    StepsService.prototype.stepsToggle;
    /**
     * @type {?}
     * @private
     */
    StepsService.prototype.stepsSubject;
    /**
     * @type {?}
     * @private
     */
    StepsService.prototype.stepList;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsComponent {
    /**
     * @param {?} stepsService
     */
    constructor(stepsService) {
        this.stepsService = stepsService;
        this.stepClick = new EventEmitter();
        this.hasStepData = new EventEmitter();
        this.completed = StepStatus.completed;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.stepList && changes.stepList.currentValue) {
            /** @type {?} */
            const change = changes.stepList.currentValue;
            this.hasStepData.emit(!!change && change.length > 0);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.stepClick.complete();
        this.hasStepData.complete();
    }
    /**
     * @param {?} $event
     * @param {?} step
     * @return {?}
     */
    stepClicked($event, step) {
        $event.stopPropagation();
        $event.preventDefault();
        if (step.link && (step.link.id || step.link.name)) {
            /** @type {?} */
            const e = Object.assign({}, step);
            e.originalEvent = $event;
            this.stepList.forEach((/**
             * @param {?} s
             * @return {?}
             */
            (s) => {
                s.active = false;
            }));
            step.active = true;
            this.stepClick.emit(e);
            this.stepsService.stepClicked(e);
            this.stepsService.stepToggle(false);
        }
    }
    /**
     * @param {?} step
     * @return {?}
     */
    checkOverdue(step) {
        if (!step) {
            return;
        }
        if (step.status && step.status === StepStatus.pending && step.dueDate) {
            /** @type {?} */
            const today = Date.now();
            /** @type {?} */
            const dueDate = Date.parse(step.dueDate);
            return dueDate < today;
        }
        return false;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    keydownSwitchToStep($event) {
        if ($event.which === 13 || $event.which === 32) {
            /** @type {?} */
            let event;
            if (typeof (MouseEvent) === 'function') {
                event = new MouseEvent('click', { bubbles: true });
            }
            else {
                event = document.createEvent('MouseEvent');
                event.initEvent('click', true, true);
            }
            $event.target.dispatchEvent(event);
        }
    }
}
StepsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-steps',
                template: "<section class=\"sticky-top\">\n  <ul class=\"list-group steps\" *ngIf=\"stepList\">\n    <li role=\"navigation\" [attr.tabindex]=\"step.status === completed? '0': '-1'\" [class.active]=\"step.active\" [class.disabled]=\"step.disabled || readOnly\" [class.overdue]=\"checkOverdue(step)\"\n      [class.completed]=\"step.status === completed\" class=\"list-group-item list-group-item-action d-flex\"\n      *ngFor=\"let step of stepList\" (click)=\" !readOnly && stepClicked($event, step)\" (keydown)=\"keydownSwitchToStep($event)\">\n      <span class=\"h4 m-0\"> {{step.text | translate}} </span>\n    </li>\n  </ul>\n</section>\n"
            }] }
];
/** @nocollapse */
StepsComponent.ctorParameters = () => [
    { type: StepsService }
];
StepsComponent.propDecorators = {
    stepList: [{ type: Input }],
    readOnly: [{ type: Input }],
    stepClick: [{ type: Output }],
    hasStepData: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    StepsComponent.prototype.stepList;
    /** @type {?} */
    StepsComponent.prototype.readOnly;
    /** @type {?} */
    StepsComponent.prototype.stepClick;
    /** @type {?} */
    StepsComponent.prototype.hasStepData;
    /** @type {?} */
    StepsComponent.prototype.completed;
    /**
     * @type {?}
     * @private
     */
    StepsComponent.prototype.stepsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsHeaderComponent {
    /**
     * @param {?} stepsService
     */
    constructor(stepsService) {
        this.stepsService = stepsService;
        this.isShown = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.stepsService.watchToggle.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        (state) => this.isShown = state));
    }
    /**
     * @return {?}
     */
    getPercentageWidth() {
        if (this.stepList) {
            /** @type {?} */
            const p = this.getPercentage() * 100;
            return `${p}%`;
        }
        else {
            return '0';
        }
    }
    /**
     * @return {?}
     */
    getPercentage() {
        /** @type {?} */
        const total = this.stepList.length;
        /** @type {?} */
        const currIndex = this.getActive();
        return currIndex / total;
    }
    /**
     * @return {?}
     */
    getActive() {
        /** @type {?} */
        const curr = this.stepList.findIndex((/**
         * @param {?} step
         * @return {?}
         */
        (step) => step.active)) + 1;
        return curr;
    }
    /**
     * @return {?}
     */
    toggleSteps() {
        this.stepsService.stepToggle(!this.isShown);
    }
}
StepsHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-steps-header',
                template: "<nav class=\"breadcrumb p-0 d-md-none mb-0\" *ngIf=\"stepList\">\n  <a id=\"steps-toggle\" href=\"javascript:void(0);\" (click)=\"toggleSteps()\" class=\"breadcrumb-item p-3\">\n    <i class=\"ifc-icon align-middle mr-1\" [ngClass]=\"{'ifc-circle-add': !isShown, 'ifc-circle-remove': isShown}\"></i>\n    <span class=\"counter align-middle\">{{'ui.steps.step_num_of_total' | translate: { 'current': getActive(), 'total': stepList.length } }}</span>\n  </a>\n</nav>\n<div class=\"progress d-md-none\" *ngIf=\"stepList\">\n  <div class=\"progress-bar\" role=\"progressbar\" [style.width]=\"getPercentageWidth()\"  [attr.aria-valuenow]=\"getPercentage()\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\n</div>\n"
            }] }
];
/** @nocollapse */
StepsHeaderComponent.ctorParameters = () => [
    { type: StepsService }
];
StepsHeaderComponent.propDecorators = {
    stepList: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    StepsHeaderComponent.prototype.stepList;
    /** @type {?} */
    StepsHeaderComponent.prototype.isShown;
    /**
     * @type {?}
     * @private
     */
    StepsHeaderComponent.prototype.stepsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTimePipe {
    /**
     * @param {?} input
     * @return {?}
     */
    transform(input) {
        input.type = 'time';
        input.value = this.convertTo24HourFormat(input.value);
        return input;
    }
    /**
     * @private
     * @param {?} time
     * @return {?}
     */
    convertTo24HourFormat(time) {
        if (!time) {
            return;
        }
        /** @type {?} */
        const timePattern = /([0-9]+:[0-9]+)(AM|PM)/;
        /** @type {?} */
        const timeParts = time.match(timePattern);
        if (!timeParts) {
            return time;
        }
        /** @type {?} */
        const hourMinuteString = timeParts[1];
        /** @type {?} */
        const AMPM = timeParts[2];
        if (AMPM === 'AM') {
            return hourMinuteString.length === 5 ? hourMinuteString : `0${hourMinuteString}`;
        }
        /** @type {?} */
        const hourString = hourMinuteString.substring(0, hourMinuteString.indexOf(':'));
        /** @type {?} */
        const hour = parseInt(hourString, 10) + 12;
        /** @type {?} */
        const minute = hourMinuteString.substring(hourMinuteString.indexOf(':'));
        return `${hour}${minute}`;
    }
}
InputTimePipe.decorators = [
    { type: Pipe, args: [{
                name: 'inputTime'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTimeComponent {
    /**
     * @param {?} renderer
     * @param {?} inputTimePipe
     */
    constructor(renderer, inputTimePipe) {
        this.renderer = renderer;
        this.inputTimePipe = inputTimePipe;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isTimeInputSupported()) {
            this.inputTimePipe.transform(this.field);
        }
    }
    /**
     * @private
     * @return {?}
     */
    isTimeInputSupported() {
        /** @type {?} */
        const testInput = (/** @type {?} */ (this.renderer.createElement('input')));
        /** @type {?} */
        const invalidValue = 'testvalue';
        this.renderer.setAttribute(testInput, 'type', 'time');
        this.renderer.setAttribute(testInput, 'value', invalidValue);
        /** @type {?} */
        const timeSupported = testInput.value !== invalidValue && testInput.getAttribute('type') === 'time';
        return timeSupported;
    }
}
InputTimeComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-time',
                template: `<ui-input [field]="field" [form]="form"></ui-input>`,
                providers: [InputTimePipe]
            }] }
];
/** @nocollapse */
InputTimeComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: InputTimePipe }
];
InputTimeComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InputTimeComponent.prototype.field;
    /** @type {?} */
    InputTimeComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    InputTimeComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    InputTimeComponent.prototype.inputTimePipe;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputGroupComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        this.btnClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
        this.blur.complete();
    }
    /**
     * @param {?} $event
     * @param {?} field
     * @return {?}
     */
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        this.form.value[field.name] = field.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    /**
     * @param {?} field
     * @return {?}
     */
    handleBlur(field) {
        this.blur.emit(field);
    }
    /**
     * @param {?} event
     * @param {?} btn
     * @param {?} field
     * @return {?}
     */
    handleClick(event, btn, field) {
        this.btnClick.emit({ field, button: btn });
        event.stopPropagation();
    }
}
InputGroupComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-group',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n  [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"input-group\">\n      <input ifPII base-input class=\"form-control\" [formControlName]=\"field?.name\"\n        (input)=\"changeOccurred($event, field)\" [field]=\"field\" (blur)=\"handleBlur(field)\"\n        [attr.data-if-id]=\"field?.extraAttributes?.ifId\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" />\n      <button base-button class=\"input-group-addon\" [field]=\"button\"\n        (click)=\"handleClick($event, button, field)\">\n        <i *ngIf=\"icon\" class=\"{{icon}} p-2\"></i>\n        <span [class.sr-only]=\"icon\">{{button.text | translate}}</span>\n      </button>\n    </div>\n  </ng-template>\n</ui-form-field>\n"
            }] }
];
InputGroupComponent.propDecorators = {
    icon: [{ type: Input }],
    button: [{ type: Input }],
    field: [{ type: Input }],
    change: [{ type: Output }],
    blur: [{ type: Output }],
    btnClick: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputGroupComponent.prototype.icon;
    /** @type {?} */
    InputGroupComponent.prototype.button;
    /** @type {?} */
    InputGroupComponent.prototype.field;
    /** @type {?} */
    InputGroupComponent.prototype.change;
    /** @type {?} */
    InputGroupComponent.prototype.blur;
    /** @type {?} */
    InputGroupComponent.prototype.btnClick;
    /** @type {?} */
    InputGroupComponent.prototype.hasError;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BrowserDetectionComponent {
    /**
     * @param {?} service
     * @param {?} changesRef
     */
    constructor(service, changesRef) {
        this.service = service;
        this.changesRef = changesRef;
        this.notSatisfied = true;
        this.showDialog = false;
        this.storageMethod = StorageMethod.Cookie;
        this.browserInfo = [
            {
                key: 'firefox',
                name: 'ui.browser-detection.firefox',
                os: 'ui.browser-detection.os.macwin',
                link: 'https://www.mozilla.org/en-US/firefox/new/?redirect_source=firefox-com',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-firefox.svg',
                modern: true
            },
            {
                key: 'chrome',
                name: 'ui.browser-detection.chrome',
                os: 'ui.browser-detection.os.macwin',
                link: 'https://www.google.com/chrome/',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-chrome.svg',
                modern: true
            },
            {
                key: 'safari',
                name: 'ui.browser-detection.safari',
                os: 'ui.browser-detection.os.mac',
                link: 'https://www.apple.com/safari/',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-safari.svg',
                modern: true
            },
            {
                key: 'edge',
                name: 'ui.browser-detection.edge',
                os: 'ui.browser-detection.os.win',
                link: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-edge.svg',
                modern: true
            },
            {
                key: 'internet explorer',
                name: 'ui.browser-detection.ie',
                os: 'ui.browser-detection.os.win',
                link: 'https://support.microsoft.com/en-us/help/17621/internet-explorer-downloads',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-ie.svg',
                modern: false
            }
        ];
        this.defaultBrowserConstraints = {
            windows: {
                ie: '>=11'
            },
            mobile: {
                safari: '>=11'
            },
            chrome: '>=70',
            edge: '>=17',
            firefox: '>=70',
            safari: '>=11',
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.browser = getParser(window.navigator.userAgent);
        this.details = this.browser.getBrowser();
        if (!this.service.check(BrowserDetectionComponent.BROWSER_DETECTION_KEY, this.storageMethod)) {
            if (this.browserConstraints) {
                this.notSatisfied = !this.browser.satisfies(this.browserConstraints);
                this.supportedBrowserInfo = this.browserInfo.filter((/**
                 * @param {?} bi
                 * @return {?}
                 */
                bi => {
                    return this.browserConstraints[bi.key] ||
                        (this.browserConstraints.windows && this.browserConstraints.windows[bi.key]) ||
                        (this.browserConstraints.mobile && this.browserConstraints.mobile[bi.key]);
                }));
            }
            else {
                this.notSatisfied = !this.browser.satisfies(this.defaultBrowserConstraints);
                this.supportedBrowserInfo = this.browserInfo;
            }
            this.browserInfo.some((/**
             * @param {?} b
             * @return {?}
             */
            b => {
                if (this.details.name.toLowerCase() === b.key) {
                    this.currentBrowserInfo = b;
                    return true;
                }
            }));
            this.isSupported = this.currentBrowserInfo && this.supportedBrowserInfo.find((/**
             * @param {?} sbi
             * @return {?}
             */
            sbi => sbi.key === this.currentBrowserInfo.key));
            this.showDialog = this.notSatisfied;
        }
    }
    /**
     * @return {?}
     */
    dismiss() {
        this.showDialog = false;
        this.service.set(BrowserDetectionComponent.BROWSER_DETECTION_KEY, 'dismiss', this.storageMethod);
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.notSatisfied = false;
            this.changesRef.markForCheck();
        }), 700);
    }
}
BrowserDetectionComponent.BROWSER_DETECTION_KEY = 'uiBrowserDialog';
BrowserDetectionComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-browser-detection',
                template: "<ng-container *ngIf=\"notSatisfied\">\n  <section class=\"d-flex flex-column justify-content-between\" [@toggle]=\"showDialog?  'visible': 'hidden'\">\n    <div class=\"card-body p-4 pt-5 text-center position-relative\">\n      <h1>\n        <span *ngIf=\"isSupported; else unsupportedTitle\">\n          {{ 'ui.browser-detection.title' | translate }}\n        </span>\n        <ng-template #unsupportedTitle>\n          <span>\n            {{ 'ui.browser-detection.unsupported_title' | translate }}\n          </span>\n        </ng-template>\n      </h1>\n      <button type=\"button\" class=\"m-2 btn btn-outline-primary border-0\"\n        (click)=\"dismiss()\" [title]=\"'ui.browser-detection.dismiss' | translate\"><i class=\"ifc-icon ifc-remove\"></i></button>\n      <p>\n        <span *ngIf=\"isSupported; else unsupportedDescription\">\n          {{ 'ui.browser-detection.description' | translate:{'browser': details?.name, version: details?.version} }}\n        </span>\n        <ng-template #unsupportedDescription>\n          <span>\n            {{ 'ui.browser-detection.unsupported_description' | translate:{'browser': details?.name, version: details?.version} }}\n          </span>\n        </ng-template>\n      </p>\n      <div class=\"text-center px-4\">\n        <a *ngIf=\"currentBrowserInfo?.modern && isSupported\" [href]=\"currentBrowserInfo?.link\" target=\"_blank\">\n          <img width=\"60\" [src]=\"currentBrowserInfo.icon\" [title]=\"currentBrowserInfo.name | translate\">\n          <div class=\"pt-2\">{{'ui.browser-detection.update'|translate:{'browser': details?.name} }}</div>\n        </a>\n      </div>\n\n\n    </div>\n    <div class=\"card-footer text-center px-1 py-3\">\n      <h2 class=\"mb-4\">\n        <span *ngIf=\"currentBrowserInfo?.modern && isSupported; else upgrade\">\n          {{'ui.browser-detection.optional'| translate }}\n        </span>\n        <ng-template #upgrade>\n          <span>\n            {{ 'ui.browser-detection.try'| translate }}\n          </span>\n        </ng-template>\n      </h2>\n\n      <div *ngIf=\"supportedBrowserInfo\" class=\"d-flex flex-row justify-content-center align-items-center\">\n\n        <ng-container *ngFor=\"let bi of supportedBrowserInfo\">\n          <ng-container *ngIf=\"bi.modern && (!currentBrowserInfo || bi.key !== currentBrowserInfo.key)\">\n            <div class=\"text-center px-1 px-md-4\">\n              <a [href]=\"bi.link\" target=\"_blank\">\n                <img width=\"40\" [src]=\"bi.icon\" [title]=\"bi.name | translate\">\n                <div class=\"pt-2\">{{ 'ui.browser-detection.install' | translate: { browser: bi.name | translate } }}</div>\n              </a>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n\n    </div>\n  </section>\n</ng-container>\n",
                animations: [
                    trigger('toggle', [
                        state('*', style({ opacity: 0, transform: 'translateY(-100%)' })),
                        state('hidden', style({ opacity: 0, transform: 'translateY(100%)' })),
                        state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => visible', animate('0.2s ease-in')),
                        transition('* => hidden', animate('0.3s ease-in'))
                    ])
                ]
            }] }
];
/** @nocollapse */
BrowserDetectionComponent.ctorParameters = () => [
    { type: StorageService },
    { type: ChangeDetectorRef }
];
BrowserDetectionComponent.propDecorators = {
    browserConstraints: [{ type: Input }],
    storageMethod: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    BrowserDetectionComponent.BROWSER_DETECTION_KEY;
    /** @type {?} */
    BrowserDetectionComponent.prototype.browser;
    /** @type {?} */
    BrowserDetectionComponent.prototype.details;
    /** @type {?} */
    BrowserDetectionComponent.prototype.notSatisfied;
    /** @type {?} */
    BrowserDetectionComponent.prototype.currentBrowserInfo;
    /** @type {?} */
    BrowserDetectionComponent.prototype.supportedBrowserInfo;
    /** @type {?} */
    BrowserDetectionComponent.prototype.isSupported;
    /** @type {?} */
    BrowserDetectionComponent.prototype.showDialog;
    /** @type {?} */
    BrowserDetectionComponent.prototype.browserConstraints;
    /** @type {?} */
    BrowserDetectionComponent.prototype.storageMethod;
    /** @type {?} */
    BrowserDetectionComponent.prototype.browserInfo;
    /**
     * @type {?}
     * @private
     */
    BrowserDetectionComponent.prototype.defaultBrowserConstraints;
    /**
     * @type {?}
     * @private
     */
    BrowserDetectionComponent.prototype.service;
    /**
     * @type {?}
     * @private
     */
    BrowserDetectionComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProgressBarComponent {
    constructor() {
        this.valueFormat = '1.2-2';
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this.updatePercentComplete();
    }
    /**
     * @return {?}
     */
    updatePercentComplete() {
        this.percentComplete = (this.complete / this.total) * 100;
    }
}
ProgressBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-progress-bar',
                template: "<div class=\"progress\">\n    <div class=\"progress-bar bg-success\" role=\"progressbar\"\n        [attr.aria-valuenow]=\"percentComplete | number:valueFormat\"\n        [ngStyle]=\"{'width': percentComplete + '%'}\"\n        aria-valuemin=\"0\" aria-valuemax=\"100\">\n        <div *ngIf=\"showProgressLabel\" class=\"progressBarLabel\">\n            {{this.percentComplete}}%\n        </div>\n    </div>\n</div>\n"
            }] }
];
/** @nocollapse */
ProgressBarComponent.ctorParameters = () => [];
ProgressBarComponent.propDecorators = {
    total: [{ type: Input }],
    complete: [{ type: Input }],
    valueFormat: [{ type: Input }],
    showProgressLabel: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProgressBarComponent.prototype.total;
    /** @type {?} */
    ProgressBarComponent.prototype.complete;
    /** @type {?} */
    ProgressBarComponent.prototype.valueFormat;
    /** @type {?} */
    ProgressBarComponent.prototype.showProgressLabel;
    /** @type {?} */
    ProgressBarComponent.prototype.percentComplete;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MultiSelectDropdownComponent extends FieldComponent {
    /**
     * @param {?} changesRef
     * @param {?} translate
     */
    constructor(changesRef, translate) {
        super();
        this.changesRef = changesRef;
        this.translate = translate;
        this.change = new EventEmitter();
        this.btnClick = new EventEmitter();
        this.selected = new EventEmitter();
        this.listToggle = false;
        this.dropdownActiveIndex = -1;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        super.ngOnInit();
        this.updateLists();
    }
    /**
     * @return {?}
     */
    updateLists() {
        this.dropdownSet = this.field.options.filter((/**
         * @param {?} op
         * @return {?}
         */
        op => op.value && !op.selected)).map((/**
         * @param {?} op
         * @return {?}
         */
        op => Object.assign({}, op)));
        this.selectedSet = this.field.options.filter((/**
         * @param {?} op
         * @return {?}
         */
        op => op.value && op.selected)).map((/**
         * @param {?} op
         * @return {?}
         */
        op => Object.assign({}, op)));
        if (this.FormCtrl) {
            /** @type {?} */
            const value = [];
            this.selectedSet.forEach((/**
             * @param {?} op
             * @return {?}
             */
            op => {
                value.push(op.value);
            }));
            value.length ? this.FormCtrl.setValue(value) : this.FormCtrl.setValue('');
        }
    }
    /**
     * @param {?} selected
     * @return {?}
     */
    addSelected(selected) {
        this.field.options.some((/**
         * @param {?} op
         * @return {?}
         */
        op => {
            if (op.value === selected.value) {
                op.selected = true;
                return true;
            }
        }));
        this.updateLists();
    }
    /**
     * @param {?} selected
     * @return {?}
     */
    removeSelected(selected) {
        this.field.options.some((/**
         * @param {?} op
         * @return {?}
         */
        op => {
            if (op.value === selected.value) {
                op.selected = false;
                return true;
            }
        }));
        this.updateLists();
    }
    /**
     * @return {?}
     */
    removeAllSelected() {
        this.field.options.forEach((/**
         * @param {?} op
         * @return {?}
         */
        op => op.selected = false));
        this.updateLists();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() { }
    /**
     * @param {?=} $event
     * @return {?}
     */
    closeList($event) {
        if ($event && $event.currentTarget && ((/** @type {?} */ ($event.currentTarget))).contains((/** @type {?} */ ($event.relatedTarget)))) {
            return true;
        }
        if (this.input.nativeElement) {
            this.input.nativeElement.value = '';
        }
        this.listToggle = false;
        this.filterBy = '';
        this.dropdownActiveIndex = -1;
        if (this.selectedSet.length === 0) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.hasError = true;
            }));
        }
        this.changesRef.markForCheck();
    }
    /**
     * @param {?} $event
     * @param {?} input
     * @return {?}
     */
    iterateList($event, input) {
        if ($event.which === 27 || $event.which === 9) { // escape or tab keys
            this.closeList();
            return;
        }
        if ($event.which !== 9 && $event.which !== 13) {
            this.listToggle = true;
        }
        /** @type {?} */
        let dropdownSet = this.dropdownSet;
        if (this.filterBy) {
            dropdownSet = this.dropdownSet.filter((/**
             * @param {?} op
             * @return {?}
             */
            op => op.text.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1));
        }
        if (dropdownSet.length > 0 && this.dropdownActiveIndex !== undefined) {
            if ($event.which === 38) {
                // up
                $event.preventDefault();
                $event.stopPropagation();
                this.dropdownActiveIndex = this.dropdownActiveIndex - 1 < 0 ? dropdownSet.length - 1 : this.dropdownActiveIndex - 1;
                if (this.listitems && this.listitems.toArray()[this.dropdownActiveIndex]) {
                    this.listitems.toArray()[this.dropdownActiveIndex].nativeElement.scrollIntoView(false);
                }
                if (this.dropdownActiveIndex >= 0 && this.dropdownActiveIndex < dropdownSet.length) {
                    this.input.nativeElement.value = dropdownSet[this.dropdownActiveIndex].text;
                }
                this.changesRef.markForCheck();
                return true;
            }
            else if ($event.which === 40) {
                // down
                $event.preventDefault();
                $event.stopPropagation();
                this.dropdownActiveIndex = this.dropdownActiveIndex + 1 > dropdownSet.length ? 0 : this.dropdownActiveIndex + 1;
                if (this.listitems && this.listitems.toArray()[this.dropdownActiveIndex]) {
                    this.listitems.toArray()[this.dropdownActiveIndex].nativeElement.scrollIntoView(false);
                }
                if (this.dropdownActiveIndex >= 0 && this.dropdownActiveIndex < dropdownSet.length) {
                    this.input.nativeElement.value = dropdownSet[this.dropdownActiveIndex].text;
                }
                this.changesRef.markForCheck();
                return true;
            }
            else if ($event.which === 13) {
                // enter
                $event.preventDefault();
                $event.stopPropagation();
                if (this.listToggle && dropdownSet && this.dropdownActiveIndex !== undefined && dropdownSet[this.dropdownActiveIndex]) {
                    this.addSelected(dropdownSet[this.dropdownActiveIndex]);
                    this.dropdownActiveIndex = 0;
                    this.filterBy = '';
                    input.value = '';
                    this.listToggle = false;
                }
                return true;
            }
            else {
                this.dropdownActiveIndex = 0;
            }
        }
    }
    /**
     * @param {?} selected
     * @param {?} input
     * @param {?=} idx
     * @return {?}
     */
    updateInput(selected, input, idx) {
        this.addSelected(selected);
        this.dropdownActiveIndex = idx ? idx : -1;
        this.listToggle = false;
        this.filterBy = '';
        input.value = '';
        this.change.emit(selected);
        this.selected.emit(input);
    }
    /**
     * @param {?} $event
     * @param {?} input
     * @return {?}
     */
    btnClickAction($event, input) {
        this.btnClick.emit({
            event: UIEvent,
            value: input.value,
            input: input
        });
        this.closeList(undefined);
    }
    /**
     * @param {?} index
     * @param {?} selected
     * @return {?}
     */
    trackBySelected(index, selected) {
        return selected.value;
    }
}
MultiSelectDropdownComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-multi-select-dropdown',
                template: "<ng-container *ngIf=\"field\">\n\n  <div class=\"form-group\" tabindex=\"-1\" (focusout)=\"closeList($event);\">\n    <ng-container *ngIf=\"selectedSet && selectedSet.length>0\">\n      <div class=\"d-flex flex-row align-items-center\" role=\"region\">\n        <span class=\"mr-3 sr-only\">{{ 'ui.controls.multi-select-dropdown.selected_options' | translate }}</span>\n        <span class=\"d-flex flex-row align-items-center mr-3\"\n          *ngFor=\"let selected of selectedSet; trackBy: trackBySelected\">\n          <span>{{selected.text | translate }}</span>\n          <a href=\"javascript:void(0);\" class=\"ml-2\" role=\"button\" (click)=\"removeSelected(selected);\"\n            title=\"{{'ui.controls.multi-select-dropdown.remove_option' | translate: {'optionName': selected.text} }}\">\n            <i class=\"ifc-icon ifc-remove align-middle\"></i>\n            <span\n              class=\"sr-only\">{{'ui.controls.multi-select-dropdown.remove_option' | translate: {'optionName': selected.text } }}</span>\n          </a>\n        </span>\n        <span class=\"ml-auto pr-2\" *ngIf=\"selectedSet!.length>0\">\n          <button type=\"button\" class=\"btn btn-outline-primary btn-sm\" (click)=\"removeAllSelected();\"\n            [title]=\"'ui.controls.multi-select-dropdown.clear_all' | translate\">\n            <span>{{'ui.controls.multi-select-dropdown.clear_all' | translate}}</span>\n          </button>\n        </span>\n      </div>\n    </ng-container>\n    <ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n      [hasError]=\"hasError\">\n      <ng-template #template let-field=\"field\">\n        <div class=\"input-group\" [ngClass]=\"{'input-group-lg': showBtn }\">\n          <input #dropdownInput ifPII [id]=\"field.id\" class=\"form-control\" type=\"text\"\n            (keydown)=\"iterateList($event, dropdownInput)\" (focus)=\"listToggle=true;dropdownActiveIndex=0;\"\n            (input)=\"filterBy=$event.currentTarget.value;\" autocomplete=\"off\"\n            placeholder=\"{{'ui.controls.multi-select-dropdown.placeholder' | translate}}\" aria-autocomplete=\"list\"\n            [attr.aria-expanded]=\"!!dropdownSet && !!dropdownSet?.length\" role=\"combobox\"\n            [value]=\"selectedQuery?.text\" />\n\n          <div class=\"input-group-append\">\n            <i class=\"ifc-icon ifc-triangle-down\"></i>\n            <button *ngIf=\"showBtn\" class=\"btn btn-primary\" type=\"button\" base-button [title]=\"btnTitle | translate\"\n              (click)=\"btnClickAction($event, dropdownInput)\">\n              <i *ngIf=\"btnIconCss\" class=\"{{btnIconCss}}\"></i>\n            </button>\n            <i *ngIf=\"!showBtn && btnIconCss\" class=\"{{btnIconCss}}\"></i>\n          </div>\n\n        </div>\n        <input type=\"hidden\" [formControlName]=\"field.name\">\n        <div class=\"dropdown-list-container\">\n          <div class=\"dropdown-list\">\n            <div class=\"dropdown-up-list\">\n              <ul class=\"list-group\" [id]=\"field.id+'_list'\" role=\"listbox\" *ngIf=\"listToggle && dropdownSet\">\n\n                <ng-container *ngIf=\"dropdownSet?.length > 0\">\n                  <li #listitems *ngFor=\"let item of dropdownSet | optionFilter:{filter: filterBy}; let idx=index\"\n                    role=\"option\" class=\"list-group-item list-group-item-action\"\n                    [class.active]=\"dropdownActiveIndex === idx\" (click)=\"updateInput(item, dropdownInput, idx)\"\n                    tabindex=\"-1\">\n                    {{item.text | translate}}\n                  </li>\n                </ng-container>\n                <ng-container *ngIf=\"dropdownSet?.length === 0\">\n                  <li class=\"list-group-item small text-muted\" role=\"option\">\n                    {{'ui.controls.multi-select-dropdown.empty' | translate}}</li>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"dropdownSet?.length > 0 && (dropdownSet | optionFilter:{filter: filterBy}).length === 0\">\n                  <li class=\"list-group-item small text-muted\" role=\"option\">\n                    {{'ui.controls.multi-select-dropdown.no_match' | translate}}</li>\n                </ng-container>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n\n    </ui-form-field>\n\n  </div>\n\n</ng-container>\n"
            }] }
];
/** @nocollapse */
MultiSelectDropdownComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService }
];
MultiSelectDropdownComponent.propDecorators = {
    input: [{ type: ViewChild, args: ['dropdownInput', { static: false },] }],
    field: [{ type: Input }],
    showBtn: [{ type: Input }],
    btnTitle: [{ type: Input }],
    btnIconCss: [{ type: Input }],
    placeholder: [{ type: Input }],
    change: [{ type: Output }],
    btnClick: [{ type: Output }],
    selected: [{ type: Output }],
    listitems: [{ type: ViewChildren, args: ['listitems',] }]
};
if (false) {
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.hasError;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.input;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.field;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.showBtn;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.btnTitle;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.btnIconCss;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.placeholder;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.change;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.btnClick;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.selected;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.listitems;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.dropdownSet;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.selectedSet;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.listToggle;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.dropdownActiveIndex;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.selectedQuery;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.filterBy;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.isloading;
    /** @type {?} */
    MultiSelectDropdownComponent.prototype.lastInputValue;
    /**
     * @type {?}
     * @private
     */
    MultiSelectDropdownComponent.prototype.changesRef;
    /**
     * @type {?}
     * @private
     */
    MultiSelectDropdownComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class OptionFilterPipe {
    /**
     * @param {?} options
     * @param {?} filterBy
     * @return {?}
     */
    transform(options, filterBy) {
        if (!filterBy.filter) {
            return options;
        }
        else {
            return options.filter((/**
             * @param {?} op
             * @return {?}
             */
            op => op.text.toLowerCase().indexOf(filterBy.filter.toLowerCase()) > -1));
        }
    }
}
OptionFilterPipe.decorators = [
    { type: Pipe, args: [{ name: 'optionFilter' },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalDialogDirective {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.isAlertDialog = false;
        this.focusedElementSelector = 'input:not([disabled]):not([type="hidden"]),select:not([disabled]), button:not([disabled]), a';
        this.unlistens = [];
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const host = this.el.nativeElement;
        this.renderer.setAttribute(host, 'aria-modal', 'true');
        this.renderer.setAttribute(host, 'role', this.isAlertDialog ? 'alertdialog' : 'dialog');
        /** @type {?} */
        const firstFocusableElement = this.el.nativeElement.querySelector(this.focusedElementSelector);
        if (firstFocusableElement) {
            this.unlistens.push(this.renderer.listen(firstFocusableElement, 'keydown.shift.tab', (/**
             * @return {?}
             */
            () => {
                event.preventDefault();
                this.returnFocusToEnd();
            })));
        }
        /** @type {?} */
        const lastFocusableElement = this.el.nativeElement.querySelector(`[id="${this.lastFocusableElementId}"]`);
        if (lastFocusableElement) {
            this.unlistens.push(this.renderer.listen(lastFocusableElement, 'keydown.tab', (/**
             * @return {?}
             */
            () => {
                event.preventDefault();
                this.returnFocusToStart();
            })));
        }
        this.returnFocusToStart();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.unlistens && this.unlistens.length) {
            this.unlistens.forEach((/**
             * @param {?} unlisten
             * @return {?}
             */
            unlisten => unlisten()));
        }
    }
    /**
     * @return {?}
     */
    returnFocusToStart() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const focusElement = this.el.nativeElement.querySelector(this.focusedElementSelector);
            if (focusElement) {
                focusElement.focus();
            }
        }));
    }
    /**
     * @return {?}
     */
    returnFocusToEnd() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const focusElement = this.el.nativeElement.querySelector(`[id="${this.lastFocusableElementId}"]`);
            if (focusElement) {
                focusElement.focus();
            }
        }));
    }
}
ModalDialogDirective.decorators = [
    { type: Directive, args: [{
                selector: '[uiModalDialog]'
            },] }
];
/** @nocollapse */
ModalDialogDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ModalDialogDirective.propDecorators = {
    isAlertDialog: [{ type: Input }],
    focusedElementSelector: [{ type: Input }],
    lastFocusableElementId: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ModalDialogDirective.prototype.isAlertDialog;
    /** @type {?} */
    ModalDialogDirective.prototype.focusedElementSelector;
    /** @type {?} */
    ModalDialogDirective.prototype.lastFocusableElementId;
    /** @type {?} */
    ModalDialogDirective.prototype.unlistens;
    /**
     * @type {?}
     * @private
     */
    ModalDialogDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    ModalDialogDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToggletipDirective {
    /**
     * @param {?} renderer
     * @param {?} el
     */
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.showToggle = false;
    }
    /**
     * @return {?}
     */
    onClick() {
        if (!this.showToggle) {
            this.showToggle = true;
        }
        this.showToggletip();
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    onBlur(evt) {
        if (evt.relatedTarget && this.toggletip && this.toggletip.contains((/** @type {?} */ (evt.relatedTarget)))) {
            return;
        }
        if (this.showToggle) {
            this.showToggle = !this.showToggle;
            this.hideToggletip();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.toggletip = this.renderer.selectRootElement('.toggletip');
        this.createToggletip();
    }
    /**
     * @return {?}
     */
    createToggletip() {
        this.toggletip.classList.add('if-popover-container', 'popover', 'data-toggletip', 'fade', `bs-popover-${this.placement ? this.placement : 'top'}`);
        this.updateToggletipInfo();
        this.renderer.appendChild(document.body, this.toggletip);
        if (!((/** @type {?} */ (this.el.nativeElement))).getAttribute('tabindex')) {
            this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '-1');
        }
        this.renderer.setAttribute(this.toggletip, 'tabindex', '-1');
        this.toggletip.addEventListener('focusout', (/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => { this.onBlur(evt); }));
    }
    /**
     * @return {?}
     */
    updateToggletipInfo() {
        /** @type {?} */
        const content = this.description ? `<div class="popover-body">${this.description}</div>` : '';
        this.toggletip.innerHTML = `<div class="arrow"></div>${content}`;
        /** @type {?} */
        const rect = this.toggletip.getBoundingClientRect();
        /** @type {?} */
        const arrow = this.toggletip.querySelector('.arrow');
        /** @type {?} */
        const rectArrow = arrow.getBoundingClientRect();
        if (!this.placement || this.placement === 'top' || this.placement === 'bottom') {
            /** @type {?} */
            const left = rect.width / 2 - rectArrow.width / 2;
            this.renderer.setStyle(this.toggletip.querySelector('.arrow'), 'left', `${left}px`);
        }
        else {
            /** @type {?} */
            const top = rect.height / 2 - rectArrow.height / 2;
            this.renderer.setStyle(this.toggletip.querySelector('.arrow'), 'top', `${top}px`);
        }
    }
    /**
     * @return {?}
     */
    showToggletip() {
        this.updateToggletipInfo();
        if (!this.popper) {
            this.popper = new Popper(this.el.nativeElement, this.toggletip, {
                placement: this.placement ? this.placement : 'top'
            });
        }
        this.renderer.removeClass(this.toggletip, 'fade');
        this.renderer.addClass(this.toggletip, 'show');
    }
    /**
     * @return {?}
     */
    hideToggletip() {
        if (this.popper) {
            this.renderer.removeClass(this.toggletip, 'show');
            this.renderer.addClass(this.toggletip, 'fade');
        }
    }
    /**
     * @return {?}
     */
    destroyToggletip() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = undefined;
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.description && !changes.description.isFirstChange && this.toggletip) {
            this.destroyToggletip();
            this.createToggletip();
        }
        if (changes.title && !changes.title.isFirstChange && this.toggletip) {
            this.destroyToggletip();
            this.createToggletip();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyToggletip();
        this.renderer.removeChild(document.body, this.toggletip);
    }
}
ToggletipDirective.decorators = [
    { type: Directive, args: [{
                selector: '[uiToggletip]'
            },] }
];
/** @nocollapse */
ToggletipDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
ToggletipDirective.propDecorators = {
    description: [{ type: Input, args: ['popoverDescription',] }],
    placement: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    ToggletipDirective.prototype.description;
    /** @type {?} */
    ToggletipDirective.prototype.placement;
    /** @type {?} */
    ToggletipDirective.prototype.showToggle;
    /** @type {?} */
    ToggletipDirective.prototype.toggletip;
    /** @type {?} */
    ToggletipDirective.prototype.popper;
    /**
     * @type {?}
     * @private
     */
    ToggletipDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    ToggletipDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.iconClass) {
            this.tooltipIconClass = "ifc-icon ifc-info";
        }
        else {
            this.tooltipIconClass = this.iconClass;
        }
        if (!this.description) {
            this.tooltipDescription = "This is an info button";
        }
        else {
            this.tooltipDescription = this.description;
        }
    }
}
TooltipComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-tooltip',
                template: "<button \n    uiToggletip\n    [popoverDescription]=\"tooltipDescription\" \n    [placement]=\"placement\"\n    aria-describedby=\"toggletip\"\n    base-button \n    data-toggle=\"popover\"\n    [class]=\"btnClass\" \n    [field]=\"btnFields\">\n    <i class=\"{{tooltipIconClass}} px-1 py-1 align-middle\"></i> \n    <span class=\"sr-only sr-only-focusable\">{{btnName | translate}}</span>\n</button>\n<div id=\"toggletip\" class=\"toggletip\" aria-live=\"assertive\" role=\"tooltip\"></div>"
            }] }
];
/** @nocollapse */
TooltipComponent.ctorParameters = () => [];
TooltipComponent.propDecorators = {
    description: [{ type: Input }],
    placement: [{ type: Input }],
    btnName: [{ type: Input }],
    btnFields: [{ type: Input }],
    btnClass: [{ type: Input }],
    iconClass: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TooltipComponent.prototype.description;
    /** @type {?} */
    TooltipComponent.prototype.placement;
    /** @type {?} */
    TooltipComponent.prototype.btnName;
    /** @type {?} */
    TooltipComponent.prototype.btnFields;
    /** @type {?} */
    TooltipComponent.prototype.btnClass;
    /** @type {?} */
    TooltipComponent.prototype.iconClass;
    /** @type {?} */
    TooltipComponent.prototype.tooltipIconClass;
    /** @type {?} */
    TooltipComponent.prototype.tooltipDescription;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InlineTimePickerComponent {
    /**
     * @param {?} renderer
     * @param {?} el
     * @param {?} changesRef
     */
    constructor(renderer, el, changesRef) {
        this.renderer = renderer;
        this.el = el;
        this.changesRef = changesRef;
        this.initialized = false;
        this.defaultClockTransition = 500;
        this.defaultTransitionDelayBetweenHandClick = 250;
        this.change = new EventEmitter();
        this.close = new EventEmitter();
        this.showToggle = false;
        this.dialRadius = 80;
        this.outerRadius = 65;
        this.innerRadius = 38;
        this.tickRadius = 12;
        this.diameter = 160;
        this.duration = 1;
        this.svgSupported = 'SVGAngle' in window &&
            ((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const el = document.createElement('div');
                el.innerHTML = '<svg/>';
                el.innerHTML = '';
                return true;
            }))();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.initialized = false;
        this.initialTimeValue = this.input.value;
        this.timepicker = this.popoverContainer.nativeElement;
        /** @type {?} */
        const touchSupported = 'ontouchstart' in window;
        this.mousedownEvent = `mousedown${touchSupported ? ' touchstart' : ''}`;
        this.mousemoveEvent = `mousemove.clockpicker${touchSupported ? ' touchmove.clockpicker' : ''}`;
        this.mouseupEvent = `mouseup.clockpicker${touchSupported ? ' touchend.clockpicker' : ''}`;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} amPM
     * @return {?}
     */
    setAMPM(amPM) {
        this.AMorPM = amPM;
        if (this.config.ampmSubmit) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.doneFunc();
            }), this.duration / 2);
        }
        this.updateTimepicker();
        this.changesRef.detectChanges();
        this.changeTimeEvent();
    }
    /**
     * @param {?} twelveHour
     * @return {?}
     */
    clockDesign(twelveHour) {
        /** @type {?} */
        const tickTpl = $('<div class="clockpicker-tick"></div>');
        //hour view
        if (twelveHour) {
            for (let i = 0; i < 12; i++) {
                /** @type {?} */
                const tick = tickTpl.clone();
                /** @type {?} */
                const radian = (i / 6) * Math.PI;
                /** @type {?} */
                const radius = this.outerRadius;
                tick.css('font-size', '120%');
                tick.css({
                    left: this.dialRadius + Math.sin(radian) * radius - this.tickRadius,
                    top: this.dialRadius - Math.cos(radian) * radius - this.tickRadius
                });
                $(tick).html(i === 0 ? 12 : i);
                $(this.hoursView).append(tick);
                $(tick).on(this.mousedownEvent, (/**
                 * @param {?} e
                 * @return {?}
                 */
                (e) => {
                    this.mouseDown(e, true);
                }));
            }
        }
        else {
            for (let i = 0; i < 24; i++) {
                /** @type {?} */
                const tick = tickTpl.clone();
                /** @type {?} */
                const radian = (i / 6) * Math.PI;
                /** @type {?} */
                const inner = i > 0 && i < 13;
                /** @type {?} */
                const radius = inner ? this.innerRadius : this.outerRadius;
                $(tick).css({
                    left: this.dialRadius + Math.sin(radian) * radius - this.tickRadius,
                    top: this.dialRadius - Math.cos(radian) * radius - this.tickRadius
                });
                if (inner) {
                    $(tick).css('font-size', '120%');
                }
                $(tick).html(i === 0 ? '00' : i);
                $(this.hoursView).append(tick);
                $(tick).on(this.mousedownEvent, (/**
                 * @param {?} e
                 * @return {?}
                 */
                (e) => {
                    this.mouseDown(e, true);
                }));
            }
        }
        //Minute Vie
        for (let i = 0; i < 60; i += 5) {
            /** @type {?} */
            const tickMinute = tickTpl.clone();
            /** @type {?} */
            const radian = (i / 30) * Math.PI;
            $(tickMinute).css({
                left: this.dialRadius + Math.sin(radian) * this.outerRadius - this.tickRadius,
                top: this.dialRadius - Math.cos(radian) * this.outerRadius - this.tickRadius
            });
            $(tickMinute).css('font-size', '120%');
            $(tickMinute).html(this.leadingZero(i, false));
            $(this.minutesView).append(tickMinute);
            $(tickMinute).on(this.mousedownEvent, onmousedown);
            $(tickMinute).on(this.mousedownEvent, (/**
             * @param {?} e
             * @return {?}
             */
            (e) => {
                this.mouseDown(e, true);
            }));
        }
        $(this.plate).on(this.mousedownEvent, (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            if ($(e.target).closest('.clockpicker-tick').length === 0) {
                this.mouseDown(e, true);
            }
        }));
    }
    /**
     * @param {?} e
     * @param {?} space
     * @return {?}
     */
    mouseDown(e, space) {
        /** @type {?} */
        const offset = $(this.plate).offset();
        /** @type {?} */
        const isTouch = /^touch/.test(e.type);
        /** @type {?} */
        const x0 = offset.left + this.dialRadius;
        /** @type {?} */
        const y0 = offset.top + this.dialRadius;
        /** @type {?} */
        const dx = (isTouch ? e.originalEvent.touches[0] : e).pageX - x0;
        /** @type {?} */
        const dy = (isTouch ? e.originalEvent.touches[0] : e).pageY - y0;
        /** @type {?} */
        const z = Math.sqrt(dx * dx + dy * dy);
        /** @type {?} */
        let moved = false;
        // When clicking on minutes view space, check the mouse position
        if (space &&
            (z < this.outerRadius - this.tickRadius || z > this.outerRadius + this.tickRadius)) {
            return;
        }
        e.preventDefault();
        // Set cursor style of body after 200ms
        this.movingTimer = setTimeout((/**
         * @return {?}
         */
        function () {
            document.body.classList.add('clockpicker-moving');
        }), 200);
        // Place the canvas to top
        $(this.plate).append(this.canvas);
        // Clock
        this.setHand(dx, dy, true);
        // Mousemove on document
        $(document).off(this.mousemoveEvent).on(this.mousemoveEvent, (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            e.preventDefault();
            /** @type {?} */
            const isTouch = /^touch/.test(e.type);
            /** @type {?} */
            const x = (isTouch ? e.originalEvent.touches[0] : e).pageX - x0;
            /** @type {?} */
            const y = (isTouch ? e.originalEvent.touches[0] : e).pageY - y0;
            if (!moved && x === dx && y === dy) {
                // Clicking in chrome on windows will trigger a mousemove event
                return;
            }
            moved = true;
            this.setHand(x, y, true);
        }));
        // Mouseup on document
        $(document).off(this.mouseupEvent).on(this.mouseupEvent, (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            $(document).off(this.mouseupEvent);
            e.preventDefault();
            /** @type {?} */
            const isTouch = /^touch/.test(e.type);
            /** @type {?} */
            const x = (isTouch ? e.originalEvent.changedTouches[0] : e).pageX - x0;
            /** @type {?} */
            const y = (isTouch ? e.originalEvent.changedTouches[0] : e).pageY - y0;
            if ((space || moved) && x === dx && y === dy) {
                this.setHand(x, y, false);
            }
            if (this.currentView === 'hour') {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.toggleView('minutes');
                }), this.defaultTransitionDelayBetweenHandClick);
            }
            $(this.plate).prepend(this.canvas);
            // Reset cursor style of body
            clearTimeout(this.movingTimer);
            document.body.classList.remove('clockpicker-moving');
            // Unbind mousemove event
            $(document).off(this.mousemoveEvent);
        }));
    }
    /**
     * @return {?}
     */
    drawClock() {
        if (this.svgSupported) {
            /** @type {?} */
            const canvas = this.timepicker.querySelector('.clockpicker-canvas');
            /** @type {?} */
            const svg = this.createSvgElement('svg');
            svg.setAttribute('class', 'clockpicker-svg');
            svg.setAttribute('width', this.diameter);
            svg.setAttribute('height', this.diameter);
            /** @type {?} */
            const g = this.createSvgElement('g');
            g.setAttribute('transform', `translate(${this.dialRadius},${this.dialRadius})`);
            /** @type {?} */
            const bearing = this.createSvgElement('circle');
            bearing.setAttribute('class', 'clockpicker-canvas-bearing');
            bearing.setAttribute('cx', 0);
            bearing.setAttribute('cy', 0);
            bearing.setAttribute('r', 3);
            /** @type {?} */
            const hand = this.createSvgElement('line');
            hand.setAttribute('x1', 0);
            hand.setAttribute('y1', 0);
            /** @type {?} */
            const bg = this.createSvgElement('circle');
            bg.setAttribute('class', 'clockpicker-canvas-bg');
            bg.setAttribute('r', this.tickRadius);
            /** @type {?} */
            const fg = this.createSvgElement('circle');
            fg.setAttribute('class', 'clockpicker-canvas-fg');
            fg.setAttribute('r', 3.5);
            g.appendChild(hand);
            g.appendChild(bg);
            g.appendChild(fg);
            g.appendChild(bearing);
            svg.appendChild(g);
            canvas.appendChild(svg);
            this.hand = hand;
            this.bg = bg;
            this.fg = fg;
            this.bearing = bearing;
            this.g = g;
            this.canvas = canvas;
            this.toggleView('hour', 0);
        }
    }
    /**
     * @param {?} name
     * @return {?}
     */
    createSvgElement(name) {
        return this.renderer.createElement(name, 'http://www.w3.org/2000/svg');
    }
    /**
     * @param {?} value
     * @return {?}
     */
    parseInputValue(value) {
        if (value === 'now') {
            value = (this.config.is24HourFormat) ? format(Date.now(), 'HH:mm') : format(Date.now(), 'hh:mma');
        }
        if (value instanceof Date) {
            value = value.getHours() + ':' + value.getMinutes();
        }
        value = value.split(':');
        // Minutes can have AM/PM that needs to be removed
        this.hours = parseInt(value[0], 10);
        if (isNaN(this.hours)) {
            this.hours = 0;
        }
        this.minutes = parseInt(value[1], 10);
        if (isNaN(this.minutes)) {
            this.minutes = 0;
        }
        this.hours = Math.round(this.hours);
        this.minutes = Math.round(this.minutes);
        this.oldHours = this.hours;
        this.oldMinutes = this.minutes;
        if (!this.config.is24HourFormat) {
            /** @type {?} */
            const period = `${value[1]}`.replace(/\d+/g, '').toLowerCase();
            if (period) {
                this.AMorPM = period === 'am' ? 'AM' : 'PM';
            }
            else {
                this.AMorPM = this.hours < 12 ? 'AM' : 'PM';
            }
        }
    }
    /**
     * @param {?} view
     * @param {?=} delay
     * @return {?}
     */
    toggleView(view, delay = this.defaultClockTransition) {
        this.isHours = view === 'hour';
        /** @type {?} */
        const nextView = this.isHours ? this.hoursView : this.minutesView;
        /** @type {?} */
        const hideView = this.isHours ? this.minutesView : this.hoursView;
        this.currentView = view;
        // Visibility
        hideView.classList.add('clockpicker-dial-out');
        nextView.classList.remove('clockpicker-dial-out');
        nextView.classList.remove('invisible');
        nextView.classList.add('visible');
        // Reset clock hand
        this.resetClock(delay); // supposed tobe delay here
        // After transitions ended
        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout((/**
         * @return {?}
         */
        function () {
            hideView.classList.remove('visible');
            hideView.classList.add('invisible');
        }), delay);
    }
    /**
     * @param {?} delay
     * @return {?}
     */
    resetClock(delay) {
        /** @type {?} */
        const view = this.currentView;
        /** @type {?} */
        const value = view === 'hour' ? this.hours : this.minutes;
        /** @type {?} */
        const isHours = view === 'hour';
        /** @type {?} */
        const unit = Math.PI / (isHours ? 6 : 30);
        /** @type {?} */
        const radian = value * unit;
        /** @type {?} */
        const radius = isHours && value > 0 && value < 13 ? this.innerRadius : this.outerRadius;
        /** @type {?} */
        const x = Math.sin(radian) * radius;
        /** @type {?} */
        const y = -Math.cos(radian) * radius;
        if (this.svgSupported && delay) {
            this.canvas.classList.add('clockpicker-canvas-out');
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.canvas.classList.remove('clockpicker-canvas-out');
                this.setHand(x, y, null);
            }), 0);
        }
        else {
            this.setHand(x, y, null);
        }
    }
    /**
     * @param {?} x
     * @param {?} y
     * @param {?} dragging
     * @return {?}
     */
    setHand(x, y, dragging) {
        /** @type {?} */
        let radian = Math.atan2(x, -y);
        /** @type {?} */
        const isHours = this.currentView === 'hour';
        /** @type {?} */
        const z = Math.sqrt(x * x + y * y);
        /** @type {?} */
        const inner = isHours && z < (this.outerRadius + this.innerRadius) / 2;
        /** @type {?} */
        let radius = inner ? this.innerRadius : this.outerRadius;
        /** @type {?} */
        let unit;
        /** @type {?} */
        let value;
        // Calculate the unit
        if (isHours) {
            unit = (1 / 6) * Math.PI;
        }
        else {
            unit = (1 / 30) * Math.PI;
        }
        if (!this.config.is24HourFormat) {
            radius = this.outerRadius;
        }
        // Radian should in range [0, 2PI]
        if (radian < 0) {
            radian = Math.PI * 2 + radian;
        }
        // Get the round value
        value = Math.round(radian / unit);
        // Get the round radian
        radian = value * unit;
        // Correct the hours or minutes
        if (isHours) {
            value *= 1;
            if (this.config.is24HourFormat && !inner === value > 0) {
                value += 12;
            }
            if ((this.config.is24HourFormat && value === 0) || value === 24) {
                value = 0;
            }
        }
        else {
            value *= 1;
            if (value === 60) {
                value = 0;
            }
        }
        $(this[isHours ? 'spanHours' : 'spanMinutes']).html(this.leadingZero(value, isHours ? true : false));
        if (isHours) {
            this.hours = value;
        }
        if (!isHours) {
            this.minutes = value;
        }
        // If svg is not supported, just add an active class to the tick
        if (!this.svgSupported) {
            this[isHours ? 'hoursView' : 'minutesView']
                .find('.clockpicker-tick')
                .each((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const tick = $(this);
                tick.toggleClass('active', value === +tick.html());
            }));
            return;
        }
        // Place clock hand at the top when dragging
        if (dragging || (!isHours && value % 5)) {
            this.g.insertBefore(this.hand, this.bearing);
            this.g.insertBefore(this.bg, this.fg);
            this.bg.setAttribute('class', 'clockpicker-canvas-bg clockpicker-canvas-bg-trans');
        }
        else {
            // Or place it at the bottom
            this.g.insertBefore(this.hand, this.bg);
            this.g.insertBefore(this.fg, this.bg);
            this.bg.setAttribute('class', 'clockpicker-canvas-bg');
        }
        // Set clock hand and others' position
        /** @type {?} */
        const cx = Math.sin(radian) * radius;
        /** @type {?} */
        const cy = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx);
        this.hand.setAttribute('y2', cy);
        this.bg.setAttribute('cx', cx);
        this.bg.setAttribute('cy', cy);
        this.fg.setAttribute('cx', cx);
        this.fg.setAttribute('cy', cy);
        this.changeTimeEvent();
    }
    /**
     * @return {?}
     */
    createTimepicker() {
        this.initialTimeValue = this.input.value;
        if (!this.initialized) {
            /** @type {?} */
            const container = this.container && ((/** @type {?} */ (this.container))).nativeElement ? ((/** @type {?} */ (this.container))).nativeElement : this.container;
            this.timepicker.classList.add(`bs-popover-${this.config.placement ? this.config.placement : 'top'}`);
            this.renderer.appendChild(container ? container : this.el.nativeElement, this.timepicker);
            if (!((/** @type {?} */ (this.el.nativeElement))).getAttribute('tabindex')) {
                this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '-1');
            }
            this.renderer.setAttribute(this.timepicker, 'tabindex', '-1');
            this.currentView = 'hour';
            this.plate = this.timepicker.querySelector('.clockpicker-plate'),
                this.hoursView = this.timepicker.querySelector('.clockpicker-hours');
            this.minutesView = this.timepicker.querySelector('.clockpicker-minutes');
            if (!this.config.is24HourFormat) {
                this.clockDesign(true);
            }
            else {
                this.clockDesign(false);
            }
            this.drawClock();
        }
        this.currentView = 'hour';
        this.isHours = true;
    }
    /**
     * @return {?}
     */
    doneFunc() {
        this.hideTimepicker();
        this.changeTimeEvent();
        this.close.emit();
    }
    /**
     * @return {?}
     */
    changeTimeEvent() {
        /** @type {?} */
        let outHours = this.hours;
        /** @type {?} */
        let value = ':' + this.leadingZero(this.minutes, false);
        value = this.leadingZero(outHours, false) + value;
        if (!this.config.is24HourFormat) {
            value = value + this.AMorPM;
        }
        this.input.value = value;
        this.change.emit(this.input.value);
        this.changesRef.detectChanges();
    }
    /**
     * @return {?}
     */
    updateTimepicker() {
        /** @type {?} */
        const rect = this.timepicker.getBoundingClientRect();
        /** @type {?} */
        const arrow = this.timepicker.querySelector('.arrow');
        /** @type {?} */
        const rectArrow = arrow.getBoundingClientRect();
        if (!this.config.placement || this.config.placement === 'top' || this.config.placement === 'bottom') {
            /** @type {?} */
            const left = rect.width / 2 - rectArrow.width / 2;
            this.renderer.setStyle(this.timepicker.querySelector('.arrow'), 'left', `${left}px`);
        }
        else {
            /** @type {?} */
            const top = rect.height / 2 - rectArrow.height / 2;
            this.renderer.setStyle(this.timepicker.querySelector('.arrow'), 'top', `${top}px`);
        }
    }
    /**
     * @return {?}
     */
    showTimepicker() {
        this.createTimepicker();
        this.updateTimepicker();
        this.renderer.removeClass(this.timepicker, 'fade');
        this.renderer.addClass(this.timepicker, 'show');
        if (this.hoursView || this.minutesView) {
            this.toggleView('hour', 0);
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.initialized = true;
        }));
    }
    /**
     * @return {?}
     */
    hideTimepicker() {
        this.renderer.removeClass(this.timepicker, 'show');
        this.renderer.addClass(this.timepicker, 'fade');
        this.currentView = 'hour';
        if (this.hoursView || this.minutesView) {
            this.toggleView('hour', 0);
        }
    }
    /**
     * @param {?} num
     * @param {?} twelveHour
     * @return {?}
     */
    leadingZero(num, twelveHour) {
        if (twelveHour && num === 0) {
            return 12;
        }
        return (num < 10 ? '0' : '') + num;
    }
}
InlineTimePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-inline-time-picker',
                template: "<div class=\"clockpicker-popover-container\" [class.d-none]=\"!initialized\">\n  <div #popoverContainer class=\"clockpicker-popover if-popover-container popover fade\">\n      <div class=\"popover-header\">\n        <div class =\"arrow\"></div>\n        <span class=\"clockpicker-span-hours\" [class.font-weight-bold]=\"isHours\" [class.text-white-50]=\"!isHours\" (click)=\"toggleView('hour');\">{{hours}}</span>\n        <span>:</span>\n        <span class=\"clockpicker-span-minutes\" [class.font-weight-bold]=\"!isHours\" [class.text-white-50]=\"isHours\" (click)=\"toggleView('minutes');\">{{minutes | timeLeadingZero}}</span>\n        <span *ngIf=\"!config.is24HourFormat\" class=\"clockpicker-buttons-am-pm d-flex\" [class.d-none]=\"config?.is24HourFormat\">\n          <a class=\"btn-am font-weight-bold\" [class.text-white-50]=\"AMorPM != 'AM'\" role=\"button\" (click)=\"setAMPM('AM')\">{{ 'ui.input-timepicker.btn.am.label' | translate}}</a>\n          <a class=\"btn-pm font-weight-bold\" [class.text-white-50]=\"AMorPM != 'PM'\" role=\"button\" (click)=\"setAMPM('PM')\">{{ 'ui.input-timepicker.btn.pm.label' | translate}}</a>\n        </span>\n    </div>\n    <div class=\"popover-body\">\n        <div class=\"clockpicker-plate\">\n        <div class=\"clockpicker-canvas\"></div>\n        <div class=\"clockpicker-dial clockpicker-hours\"></div>\n        <div class=\"clockpicker-dial clockpicker-minutes clockpicker-dial-out\"></div>\n    </div>\n    <div class=\"clockpicker-close-block\">\n        <button type=\"button\" (click)=\"doneFunc()\" class=\"btn btn-sm btn-outline-primary clockpicker-button clockpicker-button-done m-0\" >{{'ui.input-timepicker.btn.done.label' | translate}}</button>\n    </div>\n    </div>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
InlineTimePickerComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
InlineTimePickerComponent.propDecorators = {
    config: [{ type: Input }],
    input: [{ type: Input }],
    container: [{ type: Input, args: ['timePickerContainer',] }],
    change: [{ type: Output }],
    close: [{ type: Output }],
    popoverContainer: [{ type: ViewChild, args: ['popoverContainer', { static: true },] }]
};
if (false) {
    /** @type {?} */
    InlineTimePickerComponent.prototype.hoursView;
    /** @type {?} */
    InlineTimePickerComponent.prototype.minutesView;
    /** @type {?} */
    InlineTimePickerComponent.prototype.currentView;
    /** @type {?} */
    InlineTimePickerComponent.prototype.isInput;
    /** @type {?} */
    InlineTimePickerComponent.prototype.addon;
    /** @type {?} */
    InlineTimePickerComponent.prototype.popoverBody;
    /** @type {?} */
    InlineTimePickerComponent.prototype.closeBlock;
    /** @type {?} */
    InlineTimePickerComponent.prototype.spanHours;
    /** @type {?} */
    InlineTimePickerComponent.prototype.spanMinutes;
    /** @type {?} */
    InlineTimePickerComponent.prototype.buttonsAmPm;
    /** @type {?} */
    InlineTimePickerComponent.prototype.AMorPM;
    /** @type {?} */
    InlineTimePickerComponent.prototype.plate;
    /** @type {?} */
    InlineTimePickerComponent.prototype.tpl;
    /** @type {?} */
    InlineTimePickerComponent.prototype.popper;
    /** @type {?} */
    InlineTimePickerComponent.prototype.mousedownEvent;
    /** @type {?} */
    InlineTimePickerComponent.prototype.mousemoveEvent;
    /** @type {?} */
    InlineTimePickerComponent.prototype.mouseupEvent;
    /** @type {?} */
    InlineTimePickerComponent.prototype.toggleViewTimer;
    /** @type {?} */
    InlineTimePickerComponent.prototype.initialized;
    /** @type {?} */
    InlineTimePickerComponent.prototype.isHours;
    /** @type {?} */
    InlineTimePickerComponent.prototype.defaultClockTransition;
    /** @type {?} */
    InlineTimePickerComponent.prototype.defaultTransitionDelayBetweenHandClick;
    /** @type {?} */
    InlineTimePickerComponent.prototype.config;
    /** @type {?} */
    InlineTimePickerComponent.prototype.input;
    /** @type {?} */
    InlineTimePickerComponent.prototype.container;
    /** @type {?} */
    InlineTimePickerComponent.prototype.change;
    /** @type {?} */
    InlineTimePickerComponent.prototype.close;
    /** @type {?} */
    InlineTimePickerComponent.prototype.popoverContainer;
    /** @type {?} */
    InlineTimePickerComponent.prototype.movingTimer;
    /** @type {?} */
    InlineTimePickerComponent.prototype.initialTimeValue;
    /** @type {?} */
    InlineTimePickerComponent.prototype.showToggle;
    /** @type {?} */
    InlineTimePickerComponent.prototype.timepicker;
    /** @type {?} */
    InlineTimePickerComponent.prototype.dialRadius;
    /** @type {?} */
    InlineTimePickerComponent.prototype.outerRadius;
    /** @type {?} */
    InlineTimePickerComponent.prototype.innerRadius;
    /** @type {?} */
    InlineTimePickerComponent.prototype.tickRadius;
    /** @type {?} */
    InlineTimePickerComponent.prototype.diameter;
    /** @type {?} */
    InlineTimePickerComponent.prototype.duration;
    /** @type {?} */
    InlineTimePickerComponent.prototype.canvas;
    /** @type {?} */
    InlineTimePickerComponent.prototype.hand;
    /** @type {?} */
    InlineTimePickerComponent.prototype.bg;
    /** @type {?} */
    InlineTimePickerComponent.prototype.fg;
    /** @type {?} */
    InlineTimePickerComponent.prototype.bearing;
    /** @type {?} */
    InlineTimePickerComponent.prototype.g;
    /** @type {?} */
    InlineTimePickerComponent.prototype.oldHours;
    /** @type {?} */
    InlineTimePickerComponent.prototype.oldMinutes;
    /** @type {?} */
    InlineTimePickerComponent.prototype.hours;
    /** @type {?} */
    InlineTimePickerComponent.prototype.minutes;
    /** @type {?} */
    InlineTimePickerComponent.prototype.cancelButton;
    /** @type {?} */
    InlineTimePickerComponent.prototype.doneButton;
    /** @type {?} */
    InlineTimePickerComponent.prototype.svgSupported;
    /**
     * @type {?}
     * @private
     */
    InlineTimePickerComponent.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    InlineTimePickerComponent.prototype.el;
    /**
     * @type {?}
     * @private
     */
    InlineTimePickerComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTimePickerComponent extends FieldComponent {
    /**
     * @param {?} elRef
     * @param {?} zone
     * @param {?} translate
     * @param {?} cd
     */
    constructor(elRef, zone, translate, cd) {
        super();
        this.elRef = elRef;
        this.zone = zone;
        this.translate = translate;
        this.cd = cd;
        this.validationDelay = 300;
        this.change = new EventEmitter();
        this.timeFormat = 'hh:mma';
        this.oldvalue = '';
        this.defaultHourFormat = true;
        this.defaultPlacement = 'top';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.showTimePicker = false;
        if (this.field) {
            this.defaultAriaDescribedByList = `${this.field.id}_error_req ${this.field.id}_error_custom ${this.field.id}_desc ${this.field.id}_help`;
            this.ariaDescribedByList = this.defaultAriaDescribedByList;
            this.setTimeFormat();
            if (!this.field.placeholder) {
                this.field.placeholder = 'HH:MM'; //we should probably do this through helper text and not placeholder
            }
            /** @type {?} */
            const formatExample = format(Date.now(), this.timeFormat);
            this.translate.get([
                'ui.input-timepicker.expected_format_example',
                'ui.input-timepicker.invalid_format_error',
                'ui.input-timepicker.input.helptext'
            ], {
                example: formatExample,
                format: this.field.placeholder
            }).pipe(take(1)).subscribe((/**
             * @param {?} text
             * @return {?}
             */
            text => {
                this.timeFormatDesc = text['ui.input-timepicker.expected_format_example'];
                this.invalidFormatError = text['ui.input-timepicker.invalid_format_error'];
                if (this.field.helperText) {
                    this.field.helperText = text['ui.input-timepicker.input.helptext'];
                }
            }));
            /** @type {?} */
            const inputValidators = [];
            inputValidators.push(this.timeFormatValidator());
            if (this.asyncValidators) {
                if (Array.isArray(this.asyncValidators)) {
                    inputValidators.push(...this.asyncValidators);
                }
                else {
                    inputValidators.push(this.asyncValidators);
                }
            }
            this.asyncValidators = inputValidators;
            super.ngOnInit();
            this.zone.runOutsideAngular((/**
             * @return {?}
             */
            () => {
                this.timepickerSettings = (/** @type {?} */ ({
                    timeFormat: this.config ? this.config.timeFormat : 'hh:mma',
                    default: 'now',
                    // default time, 'now' or '13:14' e.g.
                    fromNow: 0,
                    // set default time to * milliseconds from now (using with default = 'now')
                    is24HourFormat: this.config ? this.config.is24HourFormat : this.defaultHourFormat,
                    placement: this.config ? this.config.placement : this.defaultPlacement,
                    ampmSubmit: this.config ? this.config.ampmSubmit : false
                }));
            }));
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.field) {
            super.updateOriginalValue();
        }
        if (changes.field && changes.field.currentValue && !changes.field.isFirstChange()) {
            this.FormCtrl.setValue(changes.field.currentValue.value);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    defaultAMPM($event) {
        if (!this.config.is24HourFormat && !this.field.value && $event.code.indexOf('Digit') > -1) {
            $event.preventDefault();
            $event.stopPropagation();
            this.field.value = `${$event.which - 48}:00${format(Date.now(), 'a')}`;
            this.FormCtrl.setValue(this.field.value);
            $event.target.setSelectionRange(1, 1);
            return false;
        }
    }
    /**
     * @return {?}
     */
    timeFormatValidator() {
        return (/**
         * @param {?} control
         * @return {?}
         */
        (control) => {
            this.ariaDescribedByList = ''; // prevent JAWS+IE11 from reading outdated aria-describedby during validation
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const value = control.value;
                if (!value) {
                    return null;
                }
                return this.validateTime(value, this.timeFormat);
            })));
        });
    }
    /**
     * @param {?} value
     * @param {?} format
     * @return {?}
     */
    validateTime(value, format) {
        /** @type {?} */
        const m = parse(value.replace(/\s*/g, ''), format, new Date());
        if (!isValid(m)) {
            return {
                inValidTime: value,
                customErrorMsg: this.invalidFormatError
            };
        }
        return null;
    }
    /**
     * @return {?}
     */
    toggle() {
        this.showTimePicker = !this.showTimePicker;
        if (this.showTimePicker) {
            this.timepickerChild.showTimepicker();
        }
        else {
            this.timepickerChild.hideTimepicker();
        }
    }
    /**
     * @return {?}
     */
    openTimePicker() {
        this.showTimePicker = true;
        this.timepickerChild.showTimepicker();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    hide($event) {
        if ($event && $event.currentTarget && ((/** @type {?} */ ($event.currentTarget))).contains((/** @type {?} */ ($event.relatedTarget)))) {
            return true;
        }
        this.showTimePicker = false;
        this.timepickerChild.hideTimepicker();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    timeChanged(value) {
        if (this.timepickerChild && this.field && value !== this.oldvalue) {
            this.oldvalue = this.field.value;
            this.field.value = value;
            this.FormCtrl.setValue(this.field.value);
            this.checkForError();
            this.hasError = false;
            this.cd.detectChanges();
            this.change.emit(this.field);
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.ariaDescribedByList = this.defaultAriaDescribedByList;
            }));
        }
    }
    /**
     * @return {?}
     */
    handleBlur() {
        this.setFormat(false);
        this.timeChanged(this.FormCtrl.value);
    }
    /**
     * @param {?} open
     * @return {?}
     */
    setFormat(open) {
        /** @type {?} */
        let isFieldEmpty = true;
        if (this.FormCtrl.value) {
            /** @type {?} */
            const hourMatch = this.FormCtrl.value.match(/^(\d+)/);
            if (hourMatch && hourMatch[1]) {
                isFieldEmpty = false;
                /** @type {?} */
                const inputHour = parseInt(hourMatch[1], 10);
                /** @type {?} */
                let inputMinute;
                /** @type {?} */
                let AMPM;
                /** @type {?} */
                const matches = this.FormCtrl.value.match(/:(\d+)/);
                inputMinute = matches && matches[1] ? parseInt(matches[1], 10) : 0;
                if (!inputMinute) {
                    inputMinute = 0;
                }
                AMPM = this.FormCtrl.value.match(/([AaPp][Mm])$/);
                AMPM = AMPM && AMPM[1] ? AMPM[1] : null;
                if (!AMPM) {
                    AMPM = format(Date.now(), 'a');
                }
                else {
                    AMPM = AMPM.toString().toUpperCase();
                }
                /** @type {?} */
                let hour = (inputHour < 10) ? '0' + inputHour.toString() : inputHour.toString();
                /** @type {?} */
                const minute = (inputMinute < 10) ? '0' + inputMinute.toString() : inputMinute.toString();
                if (!this.config.is24HourFormat) {
                    hour = (inputHour > 12) ? (inputHour - 12).toString() : hour;
                    this.FormCtrl.setValue(`${hour}:${minute}${AMPM}`);
                }
                else {
                    this.FormCtrl.setValue(`${hour}:${minute}`);
                }
            }
        }
        this.checkForError();
        if (open) {
            if (!isFieldEmpty) {
                this.timepickerChild.parseInputValue(this.FormCtrl.value);
            }
            else {
                this.timepickerChild.parseInputValue(this.config.default);
            }
            this.openTimePicker();
        }
        else {
            this.showTimePicker = false;
            this.timepickerChild.hideTimepicker();
        }
    }
    /**
     * @private
     * @return {?}
     */
    setTimeFormat() {
        if (this.config && this.config.timeFormat) {
            this.timeFormat = this.config.timeFormat;
        }
    }
}
InputTimePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-time-picker',
                template: "<ng-container *ngIf=\"!config.useDefaultMobileView; else inputtime\">\n    <div (focusout)=\"hide($event)\" tabindex=\"-1\">\n      <ui-form-field [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" >\n          <ng-template #template let-field=\"field\">\n              <div class=\"input-group input-timepicker\">\n              <span class=\"sr-only\" [id]=\"field.id + '_desc'\" [innerText]=\"timeFormatDesc\"></span>\n              <input\n                  [id]= \"field.id\"\n                  (click)=\"!field.disabled && hide($event)\"\n                  (focus)=\"!field.disabled && hide($event)\"\n                  (keydown)=\"defaultAMPM($event)\"\n                  ifPII\n                  #timepicker\n                  type=\"text\"\n                  class=\"form-control\"\n                  autocomplete=\"off\"\n                  [attr.aria-invalid]=\"hasError\"\n                  [attr.aria-describedby]=\"ariaDescribedByList ? ariaDescribedByList : ''\"\n                  (blur)=\"handleBlur()\"\n                  [formControlName]=\"field.name\"\n                  [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n                  [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n                  [attr.name]=\"field.name\" [attr.id]=\"field.id\"\n                  [required]=\"field.required && field.required !== 'false'\"\n                  [attr.disabled]=\"field.disabled? '': null\"\n                  [attr.placeholder]=\"field.placeholder ? field.placeholder: ''\">\n              <button type=\"button\" tabindex=\"-1\" aria-hidden=\"true\" class=\"btn btn-primary input-group-addon\"\n                  (click)=\"!field.disabled && setFormat(true);\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n                  <i class=\"ifc-icon ifc-time-clock\"></i>\n              </button>\n              </div>\n          </ng-template>\n      </ui-form-field>\n      <ui-inline-time-picker #inlineTimePicker (change)=\"timeChanged($event)\" [config]=\"config\" [input]=\"field\" (close)=\"toggle()\" [class.d-none]=\"!showTimePicker\"></ui-inline-time-picker>\n    </div>\n</ng-container>\n<ng-template #inputtime>\n    <ui-input-time [field]=\"field\" [form]=\"form\"></ui-input-time>\n</ng-template>\n"
            }] }
];
/** @nocollapse */
InputTimePickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: TranslateService },
    { type: ChangeDetectorRef }
];
InputTimePickerComponent.propDecorators = {
    timepickerChild: [{ type: ViewChild, args: ['inlineTimePicker', { static: false },] }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validationDelay: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputTimePickerComponent.prototype.timepickerChild;
    /** @type {?} */
    InputTimePickerComponent.prototype.field;
    /** @type {?} */
    InputTimePickerComponent.prototype.form;
    /** @type {?} */
    InputTimePickerComponent.prototype.config;
    /** @type {?} */
    InputTimePickerComponent.prototype.validationDelay;
    /** @type {?} */
    InputTimePickerComponent.prototype.asyncValidators;
    /** @type {?} */
    InputTimePickerComponent.prototype.change;
    /** @type {?} */
    InputTimePickerComponent.prototype.hasError;
    /** @type {?} */
    InputTimePickerComponent.prototype.defaultAriaDescribedByList;
    /** @type {?} */
    InputTimePickerComponent.prototype.ariaDescribedByList;
    /** @type {?} */
    InputTimePickerComponent.prototype.timepickerSettings;
    /** @type {?} */
    InputTimePickerComponent.prototype.showTimePicker;
    /** @type {?} */
    InputTimePickerComponent.prototype.validators;
    /** @type {?} */
    InputTimePickerComponent.prototype.timePicker;
    /** @type {?} */
    InputTimePickerComponent.prototype.timeFormat;
    /** @type {?} */
    InputTimePickerComponent.prototype.timeFormatDesc;
    /** @type {?} */
    InputTimePickerComponent.prototype.invalidFormatError;
    /** @type {?} */
    InputTimePickerComponent.prototype.invalidRangeError;
    /** @type {?} */
    InputTimePickerComponent.prototype.oldvalue;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.defaultHourFormat;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.defaultPlacement;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.zone;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.translate;
    /**
     * @type {?}
     * @private
     */
    InputTimePickerComponent.prototype.cd;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TimeLeadingZeroPipe {
    /**
     * @param {?} time
     * @return {?}
     */
    transform(time) {
        if (time < 10) {
            return `0${time}`;
        }
        return time;
    }
}
TimeLeadingZeroPipe.decorators = [
    { type: Pipe, args: [{
                name: 'timeLeadingZero'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DateReformatPipeParams {
}
if (false) {
    /** @type {?} */
    DateReformatPipeParams.prototype.locale;
    /** @type {?} */
    DateReformatPipeParams.prototype.format;
}
/* Pipe for reformating date strings.
 * Replaces ifdate
 */
class DateReformatPipe {
    constructor() { }
    /**
     * @param {?} value
     * @param {?=} params
     * @return {?}
     */
    transform(value, params) {
        try {
            /** @type {?} */
            let inputFormat = 'MM/dd/yyyy';
            if (params && params.locale && params.locale.dateFormat) {
                inputFormat = params.locale.dateFormat.replace('DD', 'dd').replace('YYYY', 'yyyy').replace('D', 'd').replace('YY', 'yy');
            }
            /** @type {?} */
            let outputFormat = 'MMM d, yyyy';
            if (params && params.format) {
                outputFormat = params.format;
            }
            /** @type {?} */
            const date = parse(value, inputFormat, new Date());
            if (isValid(date)) {
                return format(date, outputFormat);
            }
            return value;
        }
        catch (e) {
            console.error(`Error parsing date value '${value}'.`, e);
            return value;
        }
    }
}
DateReformatPipe.decorators = [
    { type: Pipe, args: [{ name: 'uiDateReformat' },] }
];
/** @nocollapse */
DateReformatPipe.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputDateRangeComponent {
    /**
     * @param {?} cd
     * @param {?} translate
     */
    constructor(cd, translate) {
        this.cd = cd;
        this.translate = translate;
        this.validationDelay = 300;
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.asyncDateRangeValidators = [this.dateRangeValidator()];
        this.translate.get('ui.input-date-range.invalid-end-date').subscribe((/**
         * @param {?} text
         * @return {?}
         */
        text => {
            this.invalidEndDateMsg = text;
        }));
        this.dateFormat = this.config ? this.config.dateFormat : 'yyyy-MM-dd';
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @return {?}
     */
    dateRangeValidator() {
        return (/**
         * @param {?} control
         * @return {?}
         */
        (control) => {
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const value = control.value;
                if (!value) {
                    return null;
                }
                /** @type {?} */
                const endDate = parse(this.endDate.value, this.dateFormat, new Date());
                /** @type {?} */
                const startDate = parse(this.startDate.value, this.dateFormat, new Date());
                /** @type {?} */
                const compareDates = compareAsc(endDate, startDate);
                if (compareDates < 0) {
                    return {
                        invalidDateRange: value,
                        customErrorMsg: this.invalidEndDateMsg
                    };
                }
            })));
        });
    }
    /**
     * @param {?} event
     * @param {?} isStartDate
     * @return {?}
     */
    handleChange(event, isStartDate) {
        this.change.emit((/** @type {?} */ ({ start: this.startDate, end: this.endDate })));
        if (isStartDate) {
            if (!this.form.controls[this.endDate.name].touched) {
                this.form.controls[this.endDate.name].markAsTouched();
            }
            this.form.controls[this.endDate.name].updateValueAndValidity();
        }
    }
}
InputDateRangeComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-date-range',
                template: "<div class=\"row\">\n  <div class=\"col\">\n    <ui-input-date\n      [field]=\"startDate\"\n      [form]=\"form\"\n      [config]=\"config\"\n      (change)=\"handleChange($event, true)\"\n    >\n    </ui-input-date>\n  </div>\n  <div class=\"col\">\n    <ui-input-date\n      [field]=\"endDate\"\n      [form]=\"form\"\n      [config]=\"config\"\n      [asyncValidators]=\"asyncDateRangeValidators\"\n      (change)=\"handleChange($event, false)\"\n    >\n    </ui-input-date>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
InputDateRangeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService }
];
InputDateRangeComponent.propDecorators = {
    startDate: [{ type: Input }],
    endDate: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validationDelay: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputDateRangeComponent.prototype.startDate;
    /** @type {?} */
    InputDateRangeComponent.prototype.endDate;
    /** @type {?} */
    InputDateRangeComponent.prototype.form;
    /** @type {?} */
    InputDateRangeComponent.prototype.config;
    /** @type {?} */
    InputDateRangeComponent.prototype.validationDelay;
    /** @type {?} */
    InputDateRangeComponent.prototype.change;
    /** @type {?} */
    InputDateRangeComponent.prototype.asyncDateRangeValidators;
    /** @type {?} */
    InputDateRangeComponent.prototype.invalidEndDateMsg;
    /** @type {?} */
    InputDateRangeComponent.prototype.dateFormat;
    /**
     * @type {?}
     * @private
     */
    InputDateRangeComponent.prototype.cd;
    /**
     * @type {?}
     * @private
     */
    InputDateRangeComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTimeRangeComponent {
    /**
     * @param {?} cd
     * @param {?} translate
     */
    constructor(cd, translate) {
        this.cd = cd;
        this.translate = translate;
        this.validationDelay = 300;
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.asyncTimeRangeValidators = [this.timeRangeValidator()];
        this.translate.get('ui.input-time-range.invalid-end-time').subscribe((/**
         * @param {?} text
         * @return {?}
         */
        text => {
            this.invalidEndTimeMsg = text;
        }));
        this.timeFormat = this.config ? this.config.timeFormat : 'hh:mma';
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.change.complete();
    }
    /**
     * @return {?}
     */
    timeRangeValidator() {
        return (/**
         * @param {?} control
         * @return {?}
         */
        (control) => {
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const value = control.value;
                if (!value) {
                    return null;
                }
                /** @type {?} */
                const endTimeValue = this.form.controls[this.endTime.name].value;
                /** @type {?} */
                const startTimeValue = this.form.controls[this.startTime.name].value;
                /** @type {?} */
                const endTime = parse(endTimeValue, this.timeFormat, new Date());
                /** @type {?} */
                const startTime = parse(startTimeValue, this.timeFormat, new Date());
                /** @type {?} */
                const compareTimes = compareAsc(endTime, startTime);
                if (compareTimes <= 0) {
                    return {
                        invalidTimeRange: value,
                        customErrorMsg: this.invalidEndTimeMsg
                    };
                }
            })));
        });
    }
    /**
     * @param {?} event
     * @param {?} isStartTime
     * @return {?}
     */
    handleChange(event, isStartTime) {
        this.change.emit((/** @type {?} */ ({ start: this.startTime, end: this.endTime })));
        if (isStartTime) {
            if (!this.form.controls[this.endTime.name].touched) {
                this.form.controls[this.endTime.name].markAsTouched();
            }
            this.form.controls[this.endTime.name].updateValueAndValidity();
        }
    }
}
InputTimeRangeComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-input-time-range',
                template: "<div class=\"row\">\n  <div class=\"col\">\n    <ui-input-time-picker\n      [config]=\"config\"\n      [field]=\"startTime | formatTimeFieldValue\"\n      [form]=\"form\"\n      [validationDelay]=\"validationDelay\"\n      (change)=\"handleChange($event, true)\"\n    >\n    </ui-input-time-picker>\n  </div>\n  <div class=\"col\">\n    <ui-input-time-picker\n      [config]=\"config\"\n      [field]=\"endTime | formatTimeFieldValue\"\n      [form]=\"form\"\n      [asyncValidators]=\"asyncTimeRangeValidators\"\n      [validationDelay]=\"validationDelay\"\n      (change)=\"handleChange($event, false)\">\n    </ui-input-time-picker>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
InputTimeRangeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService }
];
InputTimeRangeComponent.propDecorators = {
    startTime: [{ type: Input }],
    endTime: [{ type: Input }],
    config: [{ type: Input }],
    form: [{ type: Input }],
    validationDelay: [{ type: Input }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputTimeRangeComponent.prototype.startTime;
    /** @type {?} */
    InputTimeRangeComponent.prototype.endTime;
    /** @type {?} */
    InputTimeRangeComponent.prototype.config;
    /** @type {?} */
    InputTimeRangeComponent.prototype.form;
    /** @type {?} */
    InputTimeRangeComponent.prototype.validationDelay;
    /** @type {?} */
    InputTimeRangeComponent.prototype.change;
    /** @type {?} */
    InputTimeRangeComponent.prototype.asyncTimeRangeValidators;
    /** @type {?} */
    InputTimeRangeComponent.prototype.invalidEndTimeMsg;
    /** @type {?} */
    InputTimeRangeComponent.prototype.timeFormat;
    /**
     * @type {?}
     * @private
     */
    InputTimeRangeComponent.prototype.cd;
    /**
     * @type {?}
     * @private
     */
    InputTimeRangeComponent.prototype.translate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormatTimeFieldValuePipe {
    /**
     * @param {?} field
     * @return {?}
     */
    transform(field) {
        if (field && field.value) {
            /** @type {?} */
            const timeValue = parse(field.value, 'hh:mm:ssa', new Date());
            if (isValid(timeValue)) {
                field.value = format(timeValue, 'hh:mma');
            }
        }
        return field;
    }
}
FormatTimeFieldValuePipe.decorators = [
    { type: Pipe, args: [{ name: 'formatTimeFieldValue' },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastService {
    constructor() {
        this.subject = new BehaviorSubject({ status: false });
        this.observable = this.subject.asObservable();
    }
    /**
     * @return {?}
     */
    get status() {
        return this.observable;
    }
    /**
     * @param {?} message
     * @param {?=} delay
     * @param {?=} style
     * @param {?=} id
     * @return {?}
     */
    show(message, delay, style, id = '') {
        this.hide();
        this.subject.next({ message: message, status: true, style: style, id: id });
        if (delay) {
            this.timeOut = setTimeout((/**
             * @return {?}
             */
            () => {
                this.subject.next({ status: false });
            }), delay);
        }
    }
    /**
     * @return {?}
     */
    hide() {
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
        this.subject.next({ status: false });
    }
}
ToastService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ToastService.ctorParameters = () => [];
/** @nocollapse */ ToastService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(); }, token: ToastService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    ToastService.prototype.subject;
    /**
     * @type {?}
     * @private
     */
    ToastService.prototype.observable;
    /**
     * @type {?}
     * @private
     */
    ToastService.prototype.timeOut;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastComponent {
    /**
     * @param {?} toastService
     */
    constructor(toastService) {
        this.toastService = toastService;
        this.id = '';
        this.closed = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.toastService.status.subscribe((/**
         * @param {?} toastModel
         * @return {?}
         */
        (toastModel) => {
            if (this.id === toastModel.id || !toastModel.status) {
                if (this.active && !toastModel.status) {
                    this.closed.emit(this.id);
                }
                this.message = toastModel.message;
                this.active = toastModel.status;
                this.style = toastModel.style;
            }
        })));
    }
    /**
     * @return {?}
     */
    hideToast() {
        this.toastService.hide();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.closed.complete();
    }
}
ToastComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-toast',
                template: "<ng-container *ngIf=\"active\">\n  <div class=\"container justify-content-between align-items-center\" [class.active]=\"active\">\n    <div class=\"alert\" [ngClass]=\"(style) ? style : ''\">\n      <ng-container\n        *ngTemplateOutlet=\"customToastBodyTemplate? customToastBodyTemplate : defaultToastBodyTemplate; context: {'message': message, 'hideToast':hideToast.bind(this)}\">\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n\n\n<ng-template #defaultToastBodyTemplate let-message=\"message\" let-hideToast=\"hideToast\">\n  <span>{{ message | translate }}</span>\n  <button type=\"button\" class=\"btn btn-sm default\" (click)=\"hideToast()\">\n    <span class=\"sr-only\">{{ 'ui.toast.close' | translate }}</span>\n    <i class=\"ifc-icon ifc-remove\"></i>\n  </button>\n</ng-template>"
            }] }
];
/** @nocollapse */
ToastComponent.ctorParameters = () => [
    { type: ToastService }
];
ToastComponent.propDecorators = {
    customToastBodyTemplate: [{ type: ContentChild, args: ['customToastBodyTemplate', { static: false },] }],
    id: [{ type: Input }],
    closed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    ToastComponent.prototype.customToastBodyTemplate;
    /** @type {?} */
    ToastComponent.prototype.id;
    /** @type {?} */
    ToastComponent.prototype.closed;
    /** @type {?} */
    ToastComponent.prototype.active;
    /** @type {?} */
    ToastComponent.prototype.style;
    /** @type {?} */
    ToastComponent.prototype.message;
    /**
     * @type {?}
     * @private
     */
    ToastComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    ToastComponent.prototype.toastService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UINgModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: UINgModule,
            providers: [
                HooksService,
                TrackingPixelsService,
                ModalService,
                ScrollService,
                StorageService,
                ProxyUrlService,
                LoadingService,
                BreadcrumbsService,
                NotificationService,
                StepsService,
                ToastService
            ]
        };
    }
}
UINgModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    CoreNg,
                    TranslateModule,
                    RouterModule
                ],
                declarations: [
                    InputRangeComponent,
                    InputFileComponent,
                    LoadingComponent,
                    LoadingSpinnerComponent,
                    InputSwitchComponent,
                    ListViewComponent,
                    TileViewComponent,
                    GenericEditComponent,
                    ErrorComponent,
                    CopyrightComponent,
                    ResponsiveImgComponent,
                    AttachmentsComponent,
                    ModalComponent,
                    ModalDialogDirective,
                    ProxyUrlComponent,
                    TrackingPixelsComponent,
                    ImageContentComponent,
                    FooterComponent,
                    StickyNavbarComponent,
                    CookieAdvisoryBannerComponent,
                    CookieStatementComponent,
                    CookieExplicitBannerComponent,
                    InlineDatepickerComponent,
                    PopoverDirective,
                    InputComponent,
                    SelectComponent,
                    HiddensComponent,
                    RadioComponent,
                    CheckboxComponent,
                    CheckRadioComponent,
                    TextAreaComponent,
                    SelectButtonsComponent,
                    BreadcrumbsComponent,
                    ButtonDirective,
                    InputDirective,
                    SROnlyLabelDirective,
                    ColumnHeaderComponent,
                    ErrorBoxComponent,
                    FormFieldComponent,
                    InputDateComponent,
                    FormControlComponent,
                    ValidationCheckerComponent,
                    SkipToMainComponent,
                    PageLayoutComponent,
                    ContainerLayoutComponent,
                    NavBarComponent,
                    HeaderComponent,
                    ButtonGroupComponent,
                    InputTypeaheadComponent,
                    ResponsiveTableComponent,
                    SearchComponent,
                    CheckboxGroupComponent,
                    MaintenanceComponent,
                    NotificationComponent,
                    ControlsFilterPipe,
                    YesNoComponent,
                    CarouselComponent,
                    ToggleSwitchDirective,
                    MessageLoaderComponent,
                    MultiSelectToCheckboxComponent,
                    RadioSliderComponent,
                    StepsComponent,
                    StepsHeaderComponent,
                    InputTimePipe,
                    InputTimeComponent,
                    InputGroupComponent,
                    BrowserDetectionComponent,
                    ProgressBarComponent,
                    TooltipComponent,
                    ToggletipDirective,
                    MultiSelectDropdownComponent,
                    OptionFilterPipe,
                    InlineTimePickerComponent,
                    InputTimePickerComponent,
                    TimeLeadingZeroPipe,
                    DateReformatPipe,
                    InputDateRangeComponent,
                    InputTimeRangeComponent,
                    FormatTimeFieldValuePipe,
                    ToastComponent,
                ],
                exports: [
                    InputRangeComponent,
                    InputFileComponent,
                    LoadingComponent,
                    LoadingSpinnerComponent,
                    InputSwitchComponent,
                    ListViewComponent,
                    TileViewComponent,
                    GenericEditComponent,
                    ErrorComponent,
                    CopyrightComponent,
                    ResponsiveImgComponent,
                    AttachmentsComponent,
                    ProxyUrlComponent,
                    TrackingPixelsComponent,
                    ImageContentComponent,
                    FooterComponent,
                    StickyNavbarComponent,
                    CookieAdvisoryBannerComponent,
                    CookieStatementComponent,
                    CookieExplicitBannerComponent,
                    InlineDatepickerComponent,
                    PopoverDirective,
                    ModalComponent,
                    ModalDialogDirective,
                    InputComponent,
                    SelectComponent,
                    HiddensComponent,
                    RadioComponent,
                    CheckboxComponent,
                    CheckRadioComponent,
                    TextAreaComponent,
                    SelectButtonsComponent,
                    BreadcrumbsComponent,
                    ButtonDirective,
                    InputDirective,
                    SROnlyLabelDirective,
                    ColumnHeaderComponent,
                    ErrorBoxComponent,
                    FormFieldComponent,
                    InputDateComponent,
                    FormControlComponent,
                    ValidationCheckerComponent,
                    SkipToMainComponent,
                    PageLayoutComponent,
                    ContainerLayoutComponent,
                    NavBarComponent,
                    HeaderComponent,
                    ButtonGroupComponent,
                    InputTypeaheadComponent,
                    ResponsiveTableComponent,
                    SearchComponent,
                    CheckboxGroupComponent,
                    MaintenanceComponent,
                    NotificationComponent,
                    ControlsFilterPipe,
                    YesNoComponent,
                    CarouselComponent,
                    ToggleSwitchDirective,
                    MessageLoaderComponent,
                    MultiSelectToCheckboxComponent,
                    RadioSliderComponent,
                    StepsComponent,
                    StepsHeaderComponent,
                    InputTimePipe,
                    InputTimeComponent,
                    InputGroupComponent,
                    BrowserDetectionComponent,
                    ProgressBarComponent,
                    TooltipComponent,
                    ToggletipDirective,
                    MultiSelectDropdownComponent,
                    OptionFilterPipe,
                    InlineTimePickerComponent,
                    InputTimePickerComponent,
                    TimeLeadingZeroPipe,
                    DateReformatPipe,
                    InputDateRangeComponent,
                    InputTimeRangeComponent,
                    FormatTimeFieldValuePipe,
                    ToastComponent,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function FilterResult() { }
if (false) {
    /** @type {?} */
    FilterResult.prototype.text;
    /** @type {?} */
    FilterResult.prototype.id;
    /** @type {?|undefined} */
    FilterResult.prototype.useText;
}
/**
 * @record
 */
function FilterParams() { }
if (false) {
    /** @type {?|undefined} */
    FilterParams.prototype.minSearchLength;
    /** @type {?|undefined} */
    FilterParams.prototype.caseSensitive;
    /** @type {?|undefined} */
    FilterParams.prototype.closeWhenNoResults;
    /** @type {?|undefined} */
    FilterParams.prototype.disallowFreeInput;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function TimePickerConfig() { }
if (false) {
    /** @type {?|undefined} */
    TimePickerConfig.prototype.useDefaultMobileView;
    /** @type {?} */
    TimePickerConfig.prototype.timeFormat;
    /** @type {?} */
    TimePickerConfig.prototype.default;
    /** @type {?} */
    TimePickerConfig.prototype.fromNow;
    /** @type {?|undefined} */
    TimePickerConfig.prototype.align;
    /** @type {?|undefined} */
    TimePickerConfig.prototype.doneText;
    /** @type {?|undefined} */
    TimePickerConfig.prototype.cancelText;
    /** @type {?|undefined} */
    TimePickerConfig.prototype.autoClose;
    /** @type {?|undefined} */
    TimePickerConfig.prototype.addonOnly;
    /** @type {?} */
    TimePickerConfig.prototype.is24HourFormat;
    /** @type {?} */
    TimePickerConfig.prototype.placement;
    /** @type {?} */
    TimePickerConfig.prototype.ampmSubmit;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ToastModel() { }
if (false) {
    /** @type {?} */
    ToastModel.prototype.status;
    /** @type {?|undefined} */
    ToastModel.prototype.message;
    /** @type {?|undefined} */
    ToastModel.prototype.style;
    /** @type {?|undefined} */
    ToastModel.prototype.id;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AttachmentsComponent, BreadcrumbItem, BreadcrumbsComponent, BreadcrumbsService, BrowserDetectionComponent, ButtonDirective, ButtonGroupComponent, CarouselComponent, CheckRadioComponent, CheckboxComponent, CheckboxGroupComponent, ColumnHeaderComponent, ContainerLayoutComponent, ControlsFilterPipe, CookieAdvisoryBannerComponent, CookieExplicitBannerComponent, CookieStatementComponent, CopyrightComponent, DateReformatPipe, DateReformatPipeParams, Direction, ErrorBoxComponent, ErrorComponent, FieldComponent, FormControlComponent, FormHelper, HeaderComponent, HiddensComponent, HooksService, ImageContentComponent, InlineDatepickerComponent, InlineTimePickerComponent, InputComponent, InputDateComponent, InputDirective, InputFileComponent, InputGroupComponent, InputRangeComponent, InputSwitchComponent, InputTimeComponent, InputTimePickerComponent, InputTimePipe, InputTypeaheadComponent, ListViewComponent, LoadingComponent, LoadingService, LoadingSpinnerComponent, MaintenanceComponent, MessageLoaderComponent, ModalComponent, ModalService, MultiSelectDropdownComponent, MultiSelectToCheckboxComponent, NavBarComponent, NotificationComponent, NotificationService, OptionFilterPipe, PageLayoutComponent, PopoverDirective, ProgressBarComponent, ProxyUrlComponent, ProxyUrlService, RadioComponent, RadioSliderComponent, ResponsiveImgComponent, ResponsiveTableComponent, ScrollService, SearchComponent, SelectButtonsComponent, SelectComponent, StepsComponent, StepsHeaderComponent, StepsService, StickyNavbarComponent, StorageMethod, StorageService, TextAreaComponent, TileViewComponent, TimeLeadingZeroPipe, ToastComponent, ToastService, TooltipComponent, TrackingPixelsComponent, TrackingPixelsService, UINgModule, ValidationCheckerComponent, YesNoComponent, GenericEditComponent as ɵa, ModalDialogDirective as ɵb, FooterComponent as ɵc, SROnlyLabelDirective as ɵd, FormFieldComponent as ɵe, SkipToMainComponent as ɵf, ToggleSwitchDirective as ɵg, ToggletipDirective as ɵh, InputDateRangeComponent as ɵi, InputTimeRangeComponent as ɵj, FormatTimeFieldValuePipe as ɵk };
//# sourceMappingURL=inflight-ui-ng.js.map
